import React, { createRef } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "./Css/themes/base/all.css";
import "../App.css";
import "./Css/trafico.css";
import "./Css/traficoResponsive.css";
import PreloaderHistorico from "../components/preloaders/preloader-historico";
import Tooltip from "../components/Tooltip";
import Select from "react-select";
import Barra from "../Modulos/Barra";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaFilter } from "@react-icons/all-files/fa/FaFilter";
import { FaTools } from "@react-icons/all-files/fa/FaTools";
import { FaEye } from "@react-icons/all-files/fa/FaEye";
import { FaEyeSlash } from "@react-icons/all-files/fa/FaEyeSlash";
import { FaExpand } from "@react-icons/all-files/fa/FaExpand";
import { FaCompress } from "@react-icons/all-files/fa/FaCompress";
import { FaInfoCircle } from "@react-icons/all-files/fa/FaInfoCircle";
import Gallery from "../Modulos/Gallery";
import ReporteServicio from "../Modulos/Reporteservicio";
import ReporteDian from "../Modulos/ReporteDian";
import DianDocumentsHub from "../components/modals/menuContratos/DianDocumentsHub";
import ReporteContrato from "../Modulos/ReporteContrato";
import VideoGallery from "../componentes/videoGallery";
import Swal from "sweetalert2";
import PrintComponent from "../components/printComponent/PrintComponent";
import { createRoot } from "react-dom/client";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import FormUpdateContrato from "../components/formsSolicitudes/formUpdateContrato";
import BaseModalCreateSolcitud from "../components/modals/baseModal";
import axios from './../utils/axiosConfig';
import RSeguimientoServicio from "../components/modals/modalRSeguimientoServicio";
import FormReporteServicio from "./../components/formsSolicitudes/formReporteServicio";
import FormUpdateContratoProyecto from "../components/formsSolicitudes/formUpdateContratoProyectos";
import { formatMinutesToHoursAndMinutes, formattedGlobalDate } from "../utils/formattedDates";
import ModalReporteConsolidadoAjustado from "../components/modals/modalReporteConsolidadoAjustado";
import FormStaticsMapsRecorrido from "../components/formsSolicitudes/formStaticsMapsRecorrido";
import ModalReporteServicio from "../components/modals/modalReporteServicio";
import BarraTrafico from "../Modulos/BarraTrafico";
import FilterBodyOffcanvas from "../components/filtersTrafico/filterBodyOffcanvas";
import MenuContratos from "../components/menuContratos/menuContratos";
import ModalFoto from "../components/modals/menuContratos/modalFoto";
import BaseModalAuto from "../components/modals/baseModalAuto";
import ModalVideo from "../components/modals/menuContratos/modalVideo";
import ModalBaseLg from "../components/modals/modal-base-lg";
import ModalComprobanteValitronics from "../components/modals/menuContratos/modalComprobanteValitronics";
import BaseModalXXL from "../components/modals/baseModalXXL";
import BaseModalAuto2 from "../components/modals/BaseModalAuto2";
import ModalGaleria from "../components/modals/menuContratos/modalGaleria";
import ModalMultimediaHub, { multimediaHubTabs } from "../components/modals/menuContratos/modalMultimediaHub";
import ModalAsignacion from "../components/modals/menuContratos/modalAsignacion";
import ModalReporteServicio2 from "../components/modals/menuContratos/modalReporteServicio";
import { pastelColors } from "../utils/colors";
import EnVivoPanel from "../components/enVivo/EnVivoPanel";
import LiveFloatingPanel from "../components/enVivo/LiveFloatingPanel";
import TraficoDesktopWindows from "../components/trafico/TraficoDesktopWindows";
import { Toaster, toast } from "react-hot-toast";

var table;
var miStorage = window.localStorage;
const ACTIVE_STREAMS_STORAGE_KEY = "active_streams_v1";
const TRAFFIC_GRID_HEIGHT_STORAGE_KEY = "trafico_live_grid_height_v1";
// El estado temporal de Tráfico debe pertenecer a la pestaña, no al navegador completo.
const TRAFICO_SEARCH_STORAGE_KEY = "trafico:search";
const TRAFICO_FILTERS_STORAGE_KEY = "trafico:arrayFilters";
const showEmpresa = localStorage.getItem("sw-empresa") === "true";
const showUbicacionGps = localStorage.getItem("sw-ubicaciongps") === "true";
const showDispositivo = localStorage.getItem("sw-dispositivo") === "true";
const MULTIVENTANA_ENABLED_STORAGE_KEY = "trafico_multiventana_enabled";
const showBateria = localStorage.getItem("sw-bateria") === "true";
const showRuta = localStorage.getItem("sw-ruta") === "true";
const showEstado = localStorage.getItem("sw-estado") === "true";
const showUbicacionTrafico = localStorage.getItem("sw-ubicaciontrafico") === "true";
const showRef = localStorage.getItem("sw-ref") !== "false";
const showTiempo = localStorage.getItem("sw-tiempo") === "true";
const TRAFICO_COMPANIES_STORAGE_KEY = "trafico-selected-companies";

const readTrafficCompanyFilter = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(TRAFICO_COMPANIES_STORAGE_KEY) || "[]");
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
};
const showMoving = localStorage.getItem("sw-moving") === "true";
const showLocked = localStorage.getItem("sw-locked") === "true";
const showBack = localStorage.getItem("sw-back") === "true";
const showDesvio = localStorage.getItem("sw-desvio") === "true";
const showSeguro = localStorage.getItem("sw-seguro") === "true";
const showPlaca = localStorage.getItem("sw-placa") === "true";
const showValitronics = localStorage.getItem("sw-valitronics") === "true";
const showNoGps = localStorage.getItem("sw-nogps") === "true";
const showColorsRefuerzo = localStorage.getItem("sw-colors-refuerzo") === "true";
const storedShowPhotos = localStorage.getItem("sw-photos");
const showPhotos = storedShowPhotos === null || storedShowPhotos === "true";


const trueValues = [
  showEmpresa,
  showUbicacionGps,
  showDispositivo,
  showBateria,
  showRuta,
  showEstado,
  showUbicacionTrafico,
  showRef,
  showTiempo,
  showMoving,
  showLocked,
  showBack,
  showDesvio,
  showSeguro,
  showPlaca,
  showValitronics,
  showNoGps,
  showPhotos,
];

const columnasfijadas = trueValues.filter((value) => value === true).length + 1;

const getCurrentTimeAdjustedByPreferredTimeZone = () => new Date();

const getMinutesSinceLastReport = (loksysServerTime) => {
  const contratoFecha = new Date(loksysServerTime);
  if (Number.isNaN(contratoFecha.getTime())) return 0;

  return Math.floor(
    (getCurrentTimeAdjustedByPreferredTimeZone() - contratoFecha) / (1000 * 60)
  );
};

const getCompanyFilterCandidates = (contrato) =>
  [
    contrato?.NombreEmpresa,
    contrato?.EmpresaConsulta1,
    contrato?.EmpresaConsulta2,
    contrato?.EmpresaConsulta3,
  ]
    .map((value) => String(value ?? "").trim())
    .filter((value) => value.length > 0 && value.toLowerCase() !== "null");

const matchesCompanyFilter = (contrato, selectedCompanies = []) =>
  getCompanyFilterCandidates(contrato).some((company) =>
    selectedCompanies.includes(company)
  );

const hasLegacyTimeExchange = (loksysServerTime) => {
  const contratoFecha = new Date(loksysServerTime);
  if (Number.isNaN(contratoFecha.getTime())) return false;

  const currentTime = new Date();
  currentTime.setHours(currentTime.getHours() - 5);
  const thirtyMinutesInMs = 30 * 60 * 1000;
  return currentTime - contratoFecha >= thirtyMinutesInMs;
};

const isUnsecuredContrato = (contrato) =>
  String(contrato?.IconSeguro || "").toLowerCase().includes("unsecured");

const videos2 = [
  {
    src: "https://www.youtube.com/watch?v=LXb3EKWsInQ",
    subHtml: `<h4>'Peck Pocketed' by Kevin Herron | Disney Favorite</h4>`,
  },
  {
    src: "https://www.youtube.com/watch?v=ttLu7ygaN6I",
    subHtml: `<h4>Forest Path - Unreal Engine 5 Cinematic by Sharkyy</h4>`,
  },
  {
    src: "https://www.youtube.com/watch?v=C3vyugaBhSs",
    subHtml: `<h4>UE5 | In The Heart Of The Forest by Anastasia Gorban</h4>`,
  },
];



class Trafico extends React.Component {
  constructor(props) {
    super(props);
    this.mockTrigger = null;
    this.dialogElement = null;
    this.trafficStackRef = null;
    this.desktopWindowsRef = React.createRef();
    this.mobileBottomNavRef = React.createRef();
    this.mobileScrollRaf = null;
    this.mobileScrollStopTimer = null;
    this.trafficLoadingRequestId = 0;
    this.trafficLoadingTimeout = null;
    this.lastMobileScrollY = typeof window !== "undefined" ? window.scrollY : 0;
    this.trafficResizeRef = { startY: 0, startHeight: 0, stackHeight: 0 };
    this.liveSuppressionMap = new Map();
    // Ref síncrono: evita que dos clicks entren antes de que React actualice el estado.
    this.deviceActionInFlight = false;
    this.state = {
      listContratos: [],
      isTrafficLoading: true,
      listRutas: [],
      listEventos: [],
      listComprobantes: [],
      contratoseleccionado: -1,
      contratoDian: -1,
      rutaseleccionada: -1,
      eventoseleccionado: -1,
      isShow: false,
      infocontrato: { ContractID: "ND" },
      infocontrato2: { ContractID: "ND" },
      infocontratoAjustado: { ContractID: "ND" },
      modalAbierto: false,
      modalAbierto2: false,
      modalEnVivoOpen: false,
      contratoEnVivo: null,
      liveStreamUrl: "",
      liveStreamVersion: 0,
      sortBy: null,
      sortDirection: "asc",
      searchValue: sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY) || "",
      selectedTrafficCompanies: readTrafficCompanyFilter(),
      filteredContratos: [],
      isFullscreen: false,
      desktopWindowLauncherVisible: window.innerWidth >= 1200 && sessionStorage.getItem(MULTIVENTANA_ENABLED_STORAGE_KEY) === "true",
      fondoseleccionado: "#e6eef7",
      dropdownOpenMultimedia: false,
      dropdownOpenReportes: false,
      dropdownOpenOpciones: false,
      dropdownOpenValitronics: false,
      playing: false,
      modalOpen: false,
      onHide: false,
      collapsableResponsive: false,
      listControlesColores: [],
      isDialogOpenEditSolicitud: false,
      isDialogOpenEditContratoProject: false,
      isDialogOpenRSeguimientoServicio: false,
      isDialogOpenRServicioAjustado: false,
      isDialogOpenModalReporteServicio: false,
      infoUpdateContrato: [],
      project: localStorage.getItem('project'),
      critico: false,
      countContrats: -1,
      username: "",
      placa: "",
      device: "",
      FKLokProyecto: "",
      FKICEmpresa: "",
      ultPunto: -1,
      contractR: -1,
      infocontratoContainer: '',
      bitOpen: false,
      bitInsert: false,
      bitEdit: false,
      bitDelete: false,
      bitOpenTracking: false,
      bitInsertTracking: false,
      bitEditTracking: false,
      bitDeleteTracking: false,
      bitOpenMonitoreo: false,
      bitInsertMonitoreo: false,
      bitEditMonitoreo: false,
      bitDeleteMonitoreo: false,
      bitOpenUpdateContrato: false,
      bitInsertUpdateContrato: false,
      bitEditUpdateContrato: false,
      bitDeleteUpdateContrato: false,
      bitOpenUpdateContract: false,
      bitInsertUpdateContract: false,
      bitEditUpdateContract: false,
      bitDeleteUpdateContract: false,
      bitOpenActualizarContrato: false,
      bitInsertUActualizarContrato: false,
      bitEditUActualizarContrato: false,
      bitDeleteUActualizarContrato: false,

      isMovingActive: false,
      isStopActive: false,
      isStopAlertActive: false,
      isDesvioAlertActive: false,
      isLowBatteryActive: false,
      isOpenActive: false,
      isTimeExchangeActive: false,
      isRefuerzoActive: false,
      isNoGpsActive: false,
      isNoRutaActive: false,
      isStreamingActive: false,
      isUnsecuredActive: false,

      notificationCircle: false,
      offcanvasActive: false,

      lowBatteryCount: 0,
      openCount: 0,
      timeExchange: 0,
      movingCount: 0,
      stopCount: 0,
      stopAlertCount: 0,
      desvioCount: 0,
      differTime: 0,
      refuerzoCount: 0,
      NoGpsCount: 0,
      NoRutaCount: 0,
      streamingCount: 0,
      unsecuredCount: 0,

      mostrarReporteConsolidado: false,

      newValueFilterButton: '',
      deleteValueFilterButton: '',

      savedFilters: false,

      dataGlobal: {},
      collapsable: false,

      //modales
      isDialogOpenModalFoto: false,
      isDialogOpenModalVideo: false,
      isDialogOpenModalComprobanteValitronics: false,
      isDialogOpenModalListaCheck: false,
      isDialogOpenModalGaleria: false,
      isDialogOpenModalMultimedia: false,
      multimediaHubTab: multimediaHubTabs.PHOTOS,
      isDialogOpenAsignacion: false,

      //loading
      modalLoading: false,
      modalIsLoading: false,
      deviceActionLoading: false,
      modalAbierto2Base: false,
      anexosState: false,

      arrayFilters: JSON.parse(sessionStorage.getItem(TRAFICO_FILTERS_STORAGE_KEY)) || { filters: [] },
      activeStreams: this.readActiveStreamsFromSession(),
      liveSearch: "",
      trafficGridHeight: null,
      isResizingTrafficGrid: false,
      responsiveMoreInfo: null,
      responsiveAlertsExpanded: false,
      isMobileView: window.innerWidth < 768,
      isMobileBottomNavHidden: false,
      mobileBottomNavHeight: 0,
      // speedMoving:null,
      // timeDetention:'',
      // toltipDetention:'',
    };

    this.HandlePageByRole();
    this.ListarContratos();
    this.ListarRutas();
    this.ListarEventos();
    this.listarcontrolesColores();

    this.abrirModal = this.abrirModal.bind(this);
    this.cerrarModal = this.cerrarModal.bind(this);
    this.abrirModal2 = this.abrirModal2.bind(this);
    this.abrirModalEnVivo = this.abrirModalEnVivo.bind(this);
    this.cerrarModal2 = this.cerrarModal2.bind(this);
    this.cerrarModalEnVivo = this.cerrarModalEnVivo.bind(this);


    /* manejo de this componentes hijos*/
    this.OpenGalleryPhoto = this.OpenGalleryPhoto.bind(this);
    this.OpenGalleryVideo = this.OpenGalleryVideo.bind(this);
    this.OpenUploadPhoto = this.OpenUploadPhoto.bind(this);
    this.OpenUploadVideo = this.OpenUploadVideo.bind(this);
    this.OpenMultimediaHub = this.OpenMultimediaHub.bind(this);
    this.OpenListCheck = this.OpenListCheck.bind(this);
    this.OpenReporteServicio = this.OpenReporteServicio.bind(this);
    this.OpenComprobante = this.OpenComprobante.bind(this);
    this.EditContrato = this.EditContrato.bind(this);
    this.EditarEvento = this.EditarEvento.bind(this);
    this.UploadPhoto = this.UploadPhoto.bind(this);
    this.ActualizarContratoDevice = this.ActualizarContratoDevice.bind(this);
    this.onCloseEditContract = this.onCloseEditContract.bind(this);
    this.onCloseReporteServicio = this.onCloseReporteServicio.bind(this);
    this.onCloseReporteServicioAjustado = this.onCloseReporteServicioAjustado.bind(this);
    this.onCloseModalReporteServicio = this.onCloseModalReporteServicio.bind(this);
    this.OpenListCheck = this.OpenListCheck.bind(this);

    this.handleViewportResize = this.handleViewportResize.bind(this);
  }

  handleMockNotifications = () => {
    if (this.mockTrigger) {
      this.mockTrigger();
    }
  };

  registerMockTrigger = (fn) => {
    this.mockTrigger = fn;
  };

  readActiveStreamsFromSession = () => {
    const tryParse = (raw) => {
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("Error parseando activeStreams:", error);
        return null;
      }
    };

    const sessionRaw = sessionStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
    const sessionParsed = tryParse(sessionRaw);
    if (sessionParsed) return sessionParsed;

    const localRaw = localStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
    const localParsed = tryParse(localRaw);
    if (localParsed) {
      try {
        sessionStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, JSON.stringify(localParsed));
      } catch (error) {
        console.error("Error sincronizando sessionStorage desde localStorage:", error);
      }
      return localParsed;
    }

    return [];
  };

  syncWithSessionStorage = (nextStreams = this.state.activeStreams) => {
    try {
      const payload = JSON.stringify(nextStreams || []);
      sessionStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, payload);
      localStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, payload);
    } catch (error) {
      console.error("Error sincronizando sessionStorage activeStreams:", error);
    }
  };

  getLiveSuppressionKey = (deviceId, streamId = "*") =>
    `${this.normalizeDeviceId(deviceId)}::${String(streamId || "*").trim() || "*"}`;

  pruneLiveSuppression = () => {
    const now = Date.now();
    for (const [key, expiresAt] of this.liveSuppressionMap.entries()) {
      if (!expiresAt || expiresAt <= now) {
        this.liveSuppressionMap.delete(key);
      }
    }
  };

  suppressLiveStream = (deviceId, streamId = "*", ttlMs = 30000) => {
    const normalizedDeviceId = this.normalizeDeviceId(deviceId);
    if (!normalizedDeviceId) return;
    this.pruneLiveSuppression();
    const key = this.getLiveSuppressionKey(normalizedDeviceId, streamId);
    this.liveSuppressionMap.set(key, Date.now() + ttlMs);
  };

  clearLiveSuppression = (deviceId, streamId = "*") => {
    const normalizedDeviceId = this.normalizeDeviceId(deviceId);
    if (!normalizedDeviceId) return;
    this.pruneLiveSuppression();
    this.liveSuppressionMap.delete(this.getLiveSuppressionKey(normalizedDeviceId, streamId));
    this.liveSuppressionMap.delete(this.getLiveSuppressionKey(normalizedDeviceId, "*"));
  };

  isLiveSuppressed = (deviceId, streamId = "") => {
    const normalizedDeviceId = this.normalizeDeviceId(deviceId);
    if (!normalizedDeviceId) return false;
    this.pruneLiveSuppression();
    const exactKey = this.getLiveSuppressionKey(normalizedDeviceId, streamId);
    const deviceKey = this.getLiveSuppressionKey(normalizedDeviceId, "*");
    return this.liveSuppressionMap.has(exactKey) || this.liveSuppressionMap.has(deviceKey);
  };

  normalizeStreamKey = (value) => {
    const raw = String(value || "").trim();
    if (!raw) return "";
    let decoded = raw;
    try {
      decoded = decodeURIComponent(raw);
    } catch { }
    const lower = decoded.toLowerCase();
    const playIdMatch = lower.match(/[?&]id=([^&]+)/i);
    if (playIdMatch?.[1]) return playIdMatch[1];
    const playNameMatch = lower.match(/[?&]name=([^&]+)/i);
    if (playNameMatch?.[1]) return playNameMatch[1];
    const liveAppMatch = lower.match(/liveapp\/([^/?#]+)/i);
    if (liveAppMatch?.[1]) return liveAppMatch[1];
    const parts = lower.split("/").filter(Boolean);
    return parts[parts.length - 1] || lower;
  };

  getContratoStreamingRawUrl = (contrato) => {
    if (!contrato || typeof contrato !== "object") return "";
    return (
      contrato.StreamingUrl ||
      contrato.streamingUrl ||
      contrato.StreamUrl ||
      contrato.streamUrl ||
      contrato.Url ||
      contrato.URL ||
      contrato.url ||
      ""
    );
  };

  parseStreamingUrls = (rawUrl) => {
    if (!rawUrl) return [];
    return String(rawUrl)
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };

  buildActiveStreamsFromContratos = (contratos = []) => {
    if (!Array.isArray(contratos)) return [];

    const byDeviceAndStream = new Map();

    contratos.forEach((contrato) => {
      if (!this.isStreamingOn(contrato)) return;

      const deviceId = String(contrato?.FKLokDeviceID || "").trim();
      if (!deviceId) return;

      const rawUrl = this.getContratoStreamingRawUrl(contrato);
      const parsedUrls = this.parseStreamingUrls(rawUrl);
      const candidates = parsedUrls.length > 0 ? parsedUrls : [rawUrl];

      candidates.forEach((candidate) => {
        const resolvedUrl = this.resolveLiveStreamUrl(
          { streamId: candidate, streamUrl: candidate, url: candidate },
          deviceId
        );

        const streamId = String(resolvedUrl || candidate || "").trim();
        if (!streamId) return;
        if (
          this.isLiveSuppressed(deviceId, streamId) ||
          this.isLiveSuppressed(deviceId, this.normalizeStreamKey(streamId))
        ) {
          return;
        }

        const key = `${deviceId}::${streamId}`;
        byDeviceAndStream.set(key, {
          deviceId,
          streamId,
          timestamp: contrato?.LoksysServerTime || new Date().toISOString(),
        });
      });
    });

    return Array.from(byDeviceAndStream.values());
  };

  getContractsForLiveDisplay = () =>
    this.state.filteredContratos?.length
      ? this.state.filteredContratos
      : this.state.listContratos || [];

  getLiveStreamsForDisplay = () => {
    const currentStreams = this.state.activeStreams || [];
    if (currentStreams.length > 0) return currentStreams;
    return this.buildActiveStreamsFromContratos(this.getContractsForLiveDisplay());
  };

  areStreamsEqual = (a = [], b = []) => {
    if (a.length !== b.length) return false;

    const sortKey = (item) => `${item?.deviceId || ""}::${item?.streamId || ""}`;
    const aSorted = [...a].sort((x, y) => sortKey(x).localeCompare(sortKey(y)));
    const bSorted = [...b].sort((x, y) => sortKey(x).localeCompare(sortKey(y)));

    for (let i = 0; i < aSorted.length; i += 1) {
      if (
        String(aSorted[i]?.deviceId || "") !== String(bSorted[i]?.deviceId || "") ||
        String(aSorted[i]?.streamId || "") !== String(bSorted[i]?.streamId || "")
      ) {
        return false;
      }
    }

    return true;
  };

  normalizeDeviceId = (value) => String(value || "").trim();

  buildStreamIdentity = (stream) => {
    const deviceId = this.normalizeDeviceId(stream?.deviceId);
    const streamId = String(stream?.streamId || "").trim();
    return `${deviceId}::${streamId}`;
  };

  reconcileActiveStreamsWithContratos = (contratos = []) => {
    const seeded = this.buildActiveStreamsFromContratos(contratos || []);
    const seededKeys = new Set(seeded.map((s) => this.buildStreamIdentity(s)));

    const current = this.state.activeStreams || [];
    const next = current
      .filter((s) => seededKeys.has(this.buildStreamIdentity(s)));

    // Agregar los que falten desde el estado real de la grilla.
    const existing = new Set(next.map((s) => this.buildStreamIdentity(s)));
    seeded.forEach((s) => {
      const key = this.buildStreamIdentity(s);
      if (!existing.has(key)) next.push(s);
    });

    return next;
  };

  ensureActiveStreamsPersistence = () => {
    const hasSession = !!sessionStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
    const hasLocal = !!localStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
    if (!hasSession || !hasLocal) {
      this.syncWithSessionStorage(this.state.activeStreams || []);
    }
  };

  getAllowedDevices = () => {
    const source =
      (this.state.filteredContratos && this.state.filteredContratos.length > 0)
        ? this.state.filteredContratos
        : (this.state.listContratos || []);
    return source
      .map((c) => String(c?.FKLokDeviceID || ""))
      .filter(Boolean);
  };

  addStream = (msg) => {
    const deviceId = String(
      msg?.deviceId ||
      msg?.deviceID ||
      msg?.fkLokDeviceID ||
      msg?.FKLokDeviceID ||
      msg?.data?.deviceId ||
      msg?.data?.deviceID ||
      ""
    ).trim();
    const incomingStreamId = String(
      msg?.streamId ||
      msg?.streamID ||
      msg?.streamUrl ||
      msg?.streamURL ||
      msg?.url ||
      msg?.data?.streamId ||
      msg?.data?.streamUrl ||
      msg?.data?.url ||
      ""
    ).trim();
    if (!deviceId) return;

    // Muchos eventos LIVE_START llegan sin streamId/url.
    // En ese caso usamos un fallback deterministico por dispositivo.
    const streamId =
      incomingStreamId || this.resolveLiveStreamUrl({ streamId: "", streamUrl: "", url: "" }, deviceId);
    const normalizedIncomingKey = this.normalizeStreamKey(streamId);

    const allowedSet = new Set(this.getAllowedDevices().map((id) => String(id || "").trim()));
    // Si aun no hay contratos cargados, no bloquear el alta por filtro.
    if (allowedSet.size > 0 && !allowedSet.has(deviceId)) return;

    this.clearLiveSuppression(deviceId, streamId);
    if (normalizedIncomingKey && normalizedIncomingKey !== streamId) {
      this.clearLiveSuppression(deviceId, normalizedIncomingKey);
    }

    this.setState((prev) => {
      const exists = (prev.activeStreams || []).some(
        (s) => s.deviceId === deviceId && s.streamId === streamId
      );
      if (exists) return null;
      const next = [
        ...(prev.activeStreams || []),
        {
          streamId,
          deviceId,
          timestamp: msg?.timestamp || new Date().toISOString(),
        },
      ];
      return { activeStreams: next };
    }, () => {
      this.syncWithSessionStorage(this.state.activeStreams || []);
    });
  };

  removeStream = (msg) => {
    const deviceId = String(
      msg?.deviceId ||
      msg?.deviceID ||
      msg?.fkLokDeviceID ||
      msg?.FKLokDeviceID ||
      msg?.data?.deviceId ||
      msg?.data?.deviceID ||
      ""
    );
    const streamId = String(
      msg?.streamId ||
      msg?.streamID ||
      msg?.streamUrl ||
      msg?.streamURL ||
      msg?.url ||
      msg?.data?.streamId ||
      msg?.data?.streamUrl ||
      msg?.data?.url ||
      ""
    );
    if (!deviceId && !streamId) return;

    const incomingKey = this.normalizeStreamKey(streamId);
    const incomingLooksJt800 =
      String(streamId || "").toLowerCase().includes("jt800") ||
      String(incomingKey || "").includes("jt800");

    if (deviceId && streamId) {
      this.suppressLiveStream(deviceId, streamId);
      if (incomingKey && incomingKey !== streamId) {
        this.suppressLiveStream(deviceId, incomingKey);
      }
    } else if (deviceId) {
      this.suppressLiveStream(deviceId, "*");
    }

    this.setState((prev) => {
      const next = (prev.activeStreams || []).filter((s) => {
        const sameDevice = deviceId && String(s?.deviceId || "") === deviceId;
        const storedStream = String(s?.streamId || "");
        const storedKey = this.normalizeStreamKey(storedStream);
        const exactMatch = !!streamId && storedStream === streamId;
        const normalizedMatch = !!incomingKey && storedKey === incomingKey;
        const jt800Fallback = sameDevice && incomingLooksJt800 && storedKey.includes("jt800");

        if (streamId) {
          return !(exactMatch || normalizedMatch || jt800Fallback);
        }
        // Si LIVE_END llega sin streamId, asumimos que finalizo el live del dispositivo.
        if (sameDevice) return false;
        return true;
      });
      if (next.length === (prev.activeStreams || []).length) return null;
      return { activeStreams: next };
    }, () => {
      this.syncWithSessionStorage(this.state.activeStreams || []);
    });
  };

  abrirModal(data) {
    //console.log("$$", data);
    //console.log(data.ContractID);

    this.setState({ modalAbierto: true, contratoDian: data.ContractID });
  }

  cerrarModal() {
    this.setState({ modalAbierto: false });
  }

  finishDeviceActionLoading = () => {
    this.deviceActionInFlight = false;
    if (this.state.deviceActionLoading) this.setState({ deviceActionLoading: false });
  };

  beginDeviceActionLoading = () => {
    if (this.deviceActionInFlight) return false;

    this.deviceActionInFlight = true;
    this.setState({ deviceActionLoading: true });
    return true;
  };

  abrirModal2 = async (data, onAuthorized, options = {}) => {
    const shouldOpenInDesktopWindow = Boolean(options.openInDesktopWindow);

    if (!options.allowAtDesktopLimit && this.desktopWindowsRef.current?.isAtWindowLimit?.()) {
      this.handleDesktopWindowLimitReached(5);
      return;
    }

    if (!this.beginDeviceActionLoading()) return;

    this.setState({ dataGlobal: data, modalIsLoading: true });

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify({ pagina: "13" }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Validar antes de montar el modal o crear la multiventana.
      if (res.data.success === false) {
        window.location = "/";
        return;
      }

      const permissions = res.data?.data?.[0];
      if (!permissions?.bitOpen) {
        this.cerrarModal2();
        Swal.fire({
          title: "InformaciÃ³n",
          text: "No tiene los permisos necesarios para acceder a esta pÃ¡gina",
          icon: "info",
          timer: 3000,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        return;
      }

      this.setState({
        bitOpenTracking: permissions.bitOpen,
        bitInsertTracking: permissions.bitInsert,
        bitEditTracking: permissions.bitEdit,
        bitDeleteTracking: permissions.bitDelete,
      });

      if (shouldOpenInDesktopWindow) {
        const opened = this.desktopWindowsRef.current?.openContractTab?.(data);
        if (!opened) this.handleDesktopWindowLimitReached(5);
        onAuthorized?.();
        return;
      }

      this.setState({
        modalAbierto2: true,
        infocontrato2: data,
        modalIsLoading: false,
      });
      onAuthorized?.();
      return;

      /* Legacy permission flow kept temporarily for reference; the flow above is authoritative.
      if (false) {
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenTracking: res.data.data[0].bitOpen,
              bitInsertTracking: res.data.data[0].bitInsert,
              bitEditTracking: res.data.data[0].bitEdit,
              bitDeleteTracking: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenTracking) {
                console.warn("Tienes todos los permisos");
                //console.log("$$", data);
                //console.log(data.ContractID);
                this.setState({
                  modalAbierto2: true,
                  infocontrato2: data,
                  modalIsLoading: false
                }, () => {
                  this.finishDeviceActionLoading();
                  onAuthorized?.();
                });
              } else {
                this.cerrarModal2();
                this.finishDeviceActionLoading();
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta página",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                }).catch((error) => {
                  console.error(error)
                }
                );
              }
            }
          );
        }
      }
      }
      */
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
      this.finishDeviceActionLoading();
    } finally {
      this.setState({ modalIsLoading: false });
      this.finishDeviceActionLoading();
    }
  };

  abrirModalEnVivo = async (data, liveStreamUrl = "") => {
    const resolvedInitialUrl =
      liveStreamUrl || this.getLiveStreamUrlForDevice(data?.FKLokDeviceID);
    this.setState({
      dataGlobal: data,
      modalIsLoading: true,
      modalEnVivoOpen: true,
      contratoEnVivo: data,
      liveStreamUrl: resolvedInitialUrl || "",
      liveStreamVersion: Date.now(),
    });

    if (resolvedInitialUrl) {
      this.setState({ modalIsLoading: false });
      return;
    }

    let dataPermisos = {
      pagina: "13",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (res.data.success === false) {
        window.location = "/";
      } else if (res.data.data.length > 0) {
        this.setState(
          {
            bitOpenTracking: res.data.data[0].bitOpen,
            bitInsertTracking: res.data.data[0].bitInsert,
            bitEditTracking: res.data.data[0].bitEdit,
            bitDeleteTracking: res.data.data[0].bitDelete,
          },
          () => {
            if (this.state.bitOpenTracking) {
              this.setState({
                modalIsLoading: false,
              });
            } else {
              this.cerrarModalEnVivo();
              Swal.fire({
                title: "Información",
                text: "No tiene los permisos necesarios para acceder a esta página",
                icon: "info",
                timer: 3000,
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              }).catch((error) => {
                console.error(error);
              });
            }
          }
        );
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
      this.cerrarModalEnVivo();
    }
  };

  abrirModalEnVivoDesdeListaResponsive = (data, liveStreamUrl = "") => {
    if (this.state.isMobileView && this.state.offcanvasActive) {
      this.setState({ offcanvasActive: false }, () => {
        window.setTimeout(() => {
          this.abrirModalEnVivo(data, liveStreamUrl);
        }, 230);
      });
      return;
    }
    this.abrirModalEnVivo(data, liveStreamUrl);
  };

  cerrarModalEnVivo() {
    this.setState({
      modalEnVivoOpen: false,
      contratoEnVivo: null,
      liveStreamUrl: "",
      liveStreamVersion: 0,
      modalIsLoading: false
    });
  }

  ensureLiveToastStyles = () => {
    if (document.getElementById("live-toast-styles")) return;
    const style = document.createElement("style");
    style.id = "live-toast-styles";
    style.innerHTML = `
      @keyframes liveToastProgress {
        from { width: 100%; }
        to { width: 0%; }
      }
    `;
    document.head.appendChild(style);
  };

  handleLiveNow = (msg) => {
    this.addStream(msg);
    const deviceId = msg?.deviceId;
    if (!deviceId) return;
    const liveStreamUrl = this.resolveLiveStreamUrl(msg, deviceId);

    this.setState((prev) => {
      const modalDeviceId = String(prev?.contratoEnVivo?.FKLokDeviceID || "");
      const sameDevice = modalDeviceId === String(deviceId);
      if (!prev.modalEnVivoOpen || !sameDevice || !liveStreamUrl) return null;
      return {
        liveStreamUrl,
        liveStreamVersion: Date.now(),
      };
    });

    const contratos = (this.state.filteredContratos?.length
      ? this.state.filteredContratos
      : this.state.listContratos) || [];
    const contrato = contratos.find(
      (c) => String(c?.FKLokDeviceID) === String(deviceId)
    );

    if (!contrato) return;

    const durationMs = 8000;
    this.ensureLiveToastStyles();

    toast.custom(
      (t) => (
        <div
          onClick={() => {
            toast.dismiss(t.id);
            this.abrirModalEnVivo(contrato, liveStreamUrl);
          }}
          style={{
            cursor: "pointer",
            background: "#fff",
            color: "#111",
            padding: "10px 14px",
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            borderLeft: "4px solid #1e90ff",
            width: 280,
            minWidth: 280,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <style>{`
              @keyframes liveToastPulse {
                0% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.35); opacity: 0.55; }
                100% { transform: scale(1); opacity: 1; }
              }
            `}</style>
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "#ff2d2d",
                boxShadow: "0 0 0 4px rgba(255,45,45,0.18)",
                animation: "liveToastPulse 1.2s ease-in-out infinite",
              }}
            />
            <strong>En vivo</strong>
          </div>
          <div style={{ fontSize: 13, marginTop: 4 }}>
            Este dispositivo comenzó un live ({deviceId})
          </div>
          <div
            style={{
              marginTop: 8,
              height: 3,
              background: "#e6eef7",
              borderRadius: 999,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                background: "#1e90ff",
                animation: `liveToastProgress ${durationMs}ms linear forwards`,
              }}
            />
          </div>
        </div>
      ),
      { id: `live-${deviceId}`, duration: durationMs }
    );
  };

  handleOpenLive = (msg) => {
    this.addStream(msg);
    const deviceId = String(
      msg?.deviceId ||
      msg?.deviceID ||
      msg?.fkLokDeviceID ||
      msg?.FKLokDeviceID ||
      msg?.data?.deviceId ||
      msg?.data?.deviceID ||
      ""
    ).trim();
    if (!deviceId) return;

    const liveStreamUrl = this.resolveLiveStreamUrl(msg, deviceId);
    const contratos = (this.state.filteredContratos?.length
      ? this.state.filteredContratos
      : this.state.listContratos) || [];
    const contrato = contratos.find(
      (c) => String(c?.FKLokDeviceID || "") === deviceId
    );

    if (contrato) {
      this.abrirModalEnVivo(contrato, liveStreamUrl);
      return;
    }

    this.abrirModalEnVivo(
      {
        FKLokDeviceID: deviceId,
        NombreEmpresa: "N/D",
        DescripcionRuta: "N/D",
        TipoReporte: "En vivo",
        PlacaTruck: "N/D",
      },
      liveStreamUrl
    );
  };

  simulateLiveToast = () => {
    const firstContract = (this.state.filteredContratos || [])[0];
    const deviceId = firstContract?.FKLokDeviceID || "SIM-001";
    this.handleLiveNow({ deviceId, streamId: "https://example.com/live/SIM-001" });
  };


  onCloseModalGaleria = () => {
    this.setState({ isDialogOpenModalGaleria: false });
    this.eliminar();
  }



  cerrarModal2() {
    const modalElement = document.getElementById("ModalReporteSegimiento");
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement); // Get the Bootstrap modal instance
      if (modalInstance) {
        modalInstance.hide(); // Close the Bootstrap modal
      }
    }
    this.setState({ modalAbierto2: false, rutaseleccionada: -1 }); // Also update your React state
  }

  handleUpdateContract = (ruta) => {
    //console.log("actualizando contrato");
    this.setState({
      rutaseleccionada: ruta,
    }, () => {
      //console.log("Esta es la ruta seleccionada: ", this.state.rutaseleccionada);
    })
  }

  onCloseModalFoto = () => {
    this.setState({ isDialogOpenModalFoto: false });
  }

  onCloseModalVideo = () => {
    this.setState({ isDialogOpenModalVideo: false });
  }

  onCloseModalMultimediaHub = () => {
    this.setState({
      isDialogOpenModalMultimedia: false,
      multimediaHubTab: multimediaHubTabs.PHOTOS,
    });
  }

  OpenMultimediaHub(data, tab = multimediaHubTabs.PHOTOS) {
    const streamUrl = this.getLiveStreamUrlForDevice(data?.FKLokDeviceID);
    this.setState({
      dataGlobal: data,
      contratoseleccionado: data?.ContractID || -1,
      infocontratoContainer: data?.ContainerNum || "",
      contratoEnVivo: data || null,
      liveStreamUrl: streamUrl || "",
      liveStreamVersion: Date.now(),
      isDialogOpenModalMultimedia: true,
      multimediaHubTab: tab,
    });
  }

  onCloseModalComprobanteValitronics = () => {
    this.setState({ isDialogOpenModalComprobanteValitronics: false });
  }

  onCloseModalListaCheck = () => {
    this.setState({ isDialogOpenModalListaCheck: false });
  }

  handleCloseModalAsignacion = () => {
    //console.log("Cerradno modal asignacion");
    if (this.state.modalAbierto2) {
      //console.log("este es el valor del modal de reporte", this.state.modalAbierto2);
      //console.log("Saliendo por modal asignacion sobre el reporte en tiempo real");
      this.setState({ isDialogOpenAsignacion: false });
    } else {
      //console.log("este es el valor del modal de reporte", this.state.modalAbierto2);
      //console.log("Saliendo por modal asignacion independiente");
      this.setState({ rutaseleccionada: -1 });
    }
  }

  componentDidMount() {
    document.body.classList.add("trafico-responsive-page");
    document.documentElement.classList.add("table-page-lock");
    // Borrar todos los estados de expansión de los contratos en localStorage al montar el componente
    Object.keys(localStorage).forEach((key) => {
      if (key.includes('_expanded')) {
        localStorage.setItem(key, JSON.stringify(false)); // Cambiar el estado de cada contrato a false (colapsado)
      }

      // Restaurar la búsqueda guardada si existe
      // const busquedaGuardada = sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY);
      // if (busquedaGuardada) {
      //   const event = { target: { value: busquedaGuardada } };
      //   this.handleSearchChange(event); // Aplicar la búsqueda guardada
      //   document.getElementById("search").value = busquedaGuardada; // Actualizar el input con el valor restaurado
      // }

    });

    // Leer el estado global de expansión desde localStorage
    const globalExpansionState = JSON.parse(localStorage.getItem('global_expansion_state'));

    if (globalExpansionState !== null) {
      // Si existe un estado global de expansión, aplicarlo a todos los contratos
      this.collapsable(globalExpansionState);
    }

    var busquedaGuardada = sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY) || "";
    $("#search").val(busquedaGuardada);
    $("#success-alert").hide();
    $("#danger-alert").hide();

    if (!this.dialogElement) {
      this.dialogElement = document.createElement("div");
      this.dialogElement.id = "dialog";
      this.dialogElement.title = "Basic dialog";
      document.body.appendChild(this.dialogElement);
    }

    $(this.dialogElement).dialog({
      autoOpen: false,
      show: {
        effect: "blind",
        duration: 1000,
      },
      hide: {
        effect: "explode",
        duration: 500,
      },
    });

    const swEmpresa = localStorage.getItem("sw-empresa");
    document.getElementById("Sw-01").checked = swEmpresa === "true";
    const swUbicacionGps = localStorage.getItem("sw-ubicaciongps");
    document.getElementById("Sw-02").checked = swUbicacionGps === "true";
    const swDispositivo = localStorage.getItem("sw-dispositivo");
    document.getElementById("Sw-03").checked = swDispositivo === "true";
    const swRuta = localStorage.getItem("sw-ruta");
    document.getElementById("Sw-04").checked = swRuta === "true";
    const swUbicacionTrafico = localStorage.getItem("sw-ubicaciontrafico");
    document.getElementById("Sw-05").checked = swUbicacionTrafico === "true";
    const swTiempo = localStorage.getItem("sw-tiempo");
    document.getElementById("Sw-06").checked = swTiempo === "true";
    const swPlaca = localStorage.getItem("sw-placa");
    document.getElementById("Sw-07").checked = swPlaca === "true";
    const swBateria = localStorage.getItem("sw-bateria");
    document.getElementById("Sw-08").checked = swBateria === "true";
    const swEstado = localStorage.getItem("sw-estado");
    document.getElementById("Sw-09").checked = swEstado === "true";
    const swMoving = localStorage.getItem("sw-moving");
    document.getElementById("Sw-11").checked = swMoving === "true";
    const swLocked = localStorage.getItem("sw-locked");
    document.getElementById("Sw-12").checked = swLocked === "true";
    const swBack = localStorage.getItem("sw-back");
    document.getElementById("Sw-13").checked = swBack === "true";
    const swDesvio = localStorage.getItem("sw-desvio");
    document.getElementById("Sw-14").checked = swDesvio === "true";
    const swSeguro = localStorage.getItem("sw-seguro");
    document.getElementById("Sw-15").checked = swSeguro === "true";
    const swValitronics = localStorage.getItem("sw-valitronics");
    document.getElementById("Sw-16").checked = swValitronics === "true";
    document.getElementById("Sw-19").checked = showPhotos;
    const swNoGps = localStorage.getItem("sw-nogps");
    document.getElementById("Sw-17").checked = swNoGps === "true";
    const swColorsRefuerzo = localStorage.getItem("sw-colors-refuerzo");
    document.getElementById("Sw-18").checked = swColorsRefuerzo === "true";
    var self = this;
    // this.setupDataReload();

    this.handleViewportResize();
    window.addEventListener("resize", this.handleViewportResize);
    this.syncMobileBottomNavMetrics();



  }

  componentDidUpdate(prevProps, prevState) {
    let allowedContratos = [];
    this.state.filteredContratos.find((contrato) => {
      if (contrato.allowstream === true) {
        allowedContratos = [...allowedContratos, contrato.ContractID];
      }
    });
    //TODO: optimizar este bloque para no recalcular allowedContratos completo cada vez que cambian los contratos, sino solo cuando realmente cambian los contratos relevantes para streaming.
    // console.log("Contratos permitidos para streaming:", allowedContratos);
    // Hidratacion inicial de lives al cargar trafico:
    // si hay contratos con StreamingOn pero activeStreams aun esta vacio,
    // sembramos una vez para que el floating button refleje el estado real.
    if (
      (prevState.listContratos !== this.state.listContratos ||
        prevState.filteredContratos !== this.state.filteredContratos) &&
      (this.state.activeStreams || []).length === 0
    ) {
      const baseContratos =
        this.state.filteredContratos?.length > 0
          ? this.state.filteredContratos
          : this.state.listContratos || [];
      const seeded = this.buildActiveStreamsFromContratos(baseContratos);
      if (seeded.length > 0) {
        this.setState({ activeStreams: seeded });
        return;
      }
    }

    if (
      prevState.listContratos !== this.state.listContratos ||
      prevState.filteredContratos !== this.state.filteredContratos
    ) {
      const baseContratos =
        this.state.filteredContratos?.length > 0
          ? this.state.filteredContratos
          : this.state.listContratos || [];
      const reconciled = this.reconcileActiveStreamsWithContratos(baseContratos);
      if (!this.areStreamsEqual(this.state.activeStreams || [], reconciled)) {
        this.setState({ activeStreams: reconciled });
        return;
      }
    }

    if (prevState.filteredContratos !== this.state.filteredContratos) {
      const updatedContracts = this.state.filteredContratos.map((contrato) => {
        const storedState = JSON.parse(localStorage.getItem(`contrato_${contrato.ContractID}_expanded`)) || false;
        return {
          ...contrato,
          expanded: storedState,
        };
      });

      if (JSON.stringify(prevState.filteredContratos) !== JSON.stringify(updatedContracts)) {
        this.setState({ filteredContratos: updatedContracts });
        return;
      }
    }

    // Nota: activeStreams se controla por eventos live (WebSocket).
    // No rehidratar desde contratos aquí, porque puede reinsertar streams históricos
    // y ensuciar active_streams_v1 tras un LIVE_END.

    if (prevState.activeStreams !== this.state.activeStreams) {
      this.syncWithSessionStorage(this.state.activeStreams);
    } else {
      this.ensureActiveStreamsPersistence();
    }

    if (this.state.offcanvasActive && !prevState.offcanvasActive && !this.state.isMobileView) {
      this.initializeTrafficGridHeight();
    }

    if (this.state.isMobileView && !prevState.isMobileView) {
      this.removeTrafficResizeListeners();
      if (this.state.isResizingTrafficGrid) {
        this.setState({ isResizingTrafficGrid: false });
      }
    }

    if (!this.state.offcanvasActive && prevState.offcanvasActive) {
      this.removeTrafficResizeListeners();
      if (this.state.isResizingTrafficGrid || this.state.trafficGridHeight !== null) {
        this.setState({ isResizingTrafficGrid: false, trafficGridHeight: null });
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("trafico-responsive-page");
    document.documentElement.classList.remove("table-page-lock");
    window.removeEventListener("resize", this.handleViewportResize);
    window.removeEventListener("scroll", this.handleMobileScroll);
    if (this.mobileScrollRaf) window.cancelAnimationFrame(this.mobileScrollRaf);
    if (this.mobileScrollStopTimer) window.clearTimeout(this.mobileScrollStopTimer);
    if (this.trafficLoadingTimeout) window.clearTimeout(this.trafficLoadingTimeout);
    this.removeTrafficResizeListeners();
    try {
      if (this.dialogElement) {
        $(this.dialogElement).dialog("destroy");
        this.dialogElement.remove();
        this.dialogElement = null;
      }
    } catch (error) {
      console.error("Error limpiando dialog:", error);
    }
  }

  handleViewportResize() {
    const isMobileView = window.innerWidth < 768;
    if (this.state.isMobileView !== isMobileView) {
      this.lastMobileScrollY = window.scrollY || 0;
      this.setState({
        isMobileView,
        isMobileBottomNavHidden: false,
      }, this.syncMobileBottomNavMetrics);
      return;
    }
    this.syncMobileBottomNavMetrics();
  }

  syncMobileBottomNavMetrics = () => {
    if (!this.state.isMobileView || !this.mobileBottomNavRef.current) {
      if (this.state.mobileBottomNavHeight !== 0) {
        this.setState({ mobileBottomNavHeight: 0 });
      }
      return;
    }

    const height = Math.ceil(this.mobileBottomNavRef.current.getBoundingClientRect().height || 0);
    if (height !== this.state.mobileBottomNavHeight) {
      this.setState({ mobileBottomNavHeight: height });
    }
  };

  getMobileLiveFabBottom = () => {
    if (!this.state.isMobileView) return 20;

    const measuredHeight = this.mobileBottomNavRef.current?.getBoundingClientRect().height || 0;
    const navHeight = Math.max(measuredHeight, this.state.mobileBottomNavHeight, 62);
    return Math.max(76, Math.ceil(navHeight) + 14);
  };

  handleMobileScroll = () => {
    if (!this.state.isMobileView || this.mobileScrollRaf) return;

    this.mobileScrollRaf = window.requestAnimationFrame(() => {
      this.mobileScrollRaf = null;
      const currentY = Math.max(0, window.scrollY || window.pageYOffset || 0);
      const delta = currentY - this.lastMobileScrollY;
      this.lastMobileScrollY = currentY;

      if (Math.abs(delta) >= 3) {
        const scrollingDown = delta > 0 && currentY > 12;
        const shouldHide = scrollingDown;
        if (this.state.isMobileBottomNavHidden !== shouldHide) {
          this.setState({ isMobileBottomNavHidden: shouldHide });
        }
      }

      if (this.mobileScrollStopTimer) window.clearTimeout(this.mobileScrollStopTimer);
      this.mobileScrollStopTimer = window.setTimeout(() => {
        this.mobileScrollStopTimer = null;
        if (this.state.isMobileView && this.state.isMobileBottomNavHidden) {
          this.setState({ isMobileBottomNavHidden: false });
        }
      }, 160);
    });
  }

  initializeTrafficGridHeight = () => {
    if (!this.trafficStackRef || this.state.trafficGridHeight !== null) return;
    const stackHeight = this.trafficStackRef.offsetHeight || 0;
    if (!stackHeight) return;
    const persistedHeight = this.readPersistedTrafficGridHeight();
    const defaultHeight = this.clampTrafficGridHeight(
      persistedHeight ?? Math.floor(stackHeight * 0.6),
      stackHeight
    );
    this.setState({ trafficGridHeight: defaultHeight });
  };

  clampTrafficGridHeight = (height, stackHeight) => {
    const handleHeight = 8;
    const minGrid = 220;
    const minLive = 160;
    const maxGrid = Math.max(minGrid, stackHeight - minLive - handleHeight);
    return Math.max(minGrid, Math.min(maxGrid, Number(height) || minGrid));
  };

  readPersistedTrafficGridHeight = () => {
    const raw = localStorage.getItem(TRAFFIC_GRID_HEIGHT_STORAGE_KEY);
    const parsed = Number(raw);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    return parsed;
  };

  persistTrafficGridHeight = (height) => {
    const value = Number(height);
    if (!Number.isFinite(value) || value <= 0) return;
    localStorage.setItem(TRAFFIC_GRID_HEIGHT_STORAGE_KEY, String(Math.round(value)));
  };

  removeTrafficResizeListeners = () => {
    window.removeEventListener("mousemove", this.handleTrafficResizeMouseMove);
    window.removeEventListener("mouseup", this.handleTrafficResizeMouseUp);
  };

  handleTrafficResizeMouseDown = (event) => {
    if (!this.trafficStackRef) return;
    event.preventDefault();
    const stackHeight = this.trafficStackRef.offsetHeight || 0;
    if (!stackHeight) return;
    const startHeight = this.state.trafficGridHeight || Math.max(240, Math.floor(stackHeight * 0.6));
    this.trafficResizeRef = {
      startY: event.clientY,
      startHeight,
      stackHeight,
    };
    this.setState({ isResizingTrafficGrid: true, trafficGridHeight: startHeight });
    window.addEventListener("mousemove", this.handleTrafficResizeMouseMove);
    window.addEventListener("mouseup", this.handleTrafficResizeMouseUp);
  };

  handleTrafficResizeMouseMove = (event) => {
    if (!this.state.isResizingTrafficGrid) return;
    const { startY, startHeight, stackHeight } = this.trafficResizeRef || {};
    if (!stackHeight) return;
    const nextHeight = this.clampTrafficGridHeight(
      startHeight + (event.clientY - startY),
      stackHeight
    );
    this.setState({ trafficGridHeight: nextHeight });
  };

  handleTrafficResizeMouseUp = () => {
    if (!this.state.isResizingTrafficGrid) return;
    this.setState(
      { isResizingTrafficGrid: false },
      () => this.persistTrafficGridHeight(this.state.trafficGridHeight)
    );
    this.removeTrafficResizeListeners();
  };

  toggleOffcanvas = () => {
    this.setState(
      (prevState) => ({
        offcanvasActive: !prevState.offcanvasActive,
      }),
      () => {
        if (this.state.offcanvasActive) {
          const target = document.getElementById("live-inline-section");
          if (target?.scrollIntoView) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    );
  };

  toggleNavigationMenu = () => {
    const sideNavToggle = document.querySelector('[class*="sidenav-toggle"]');
    sideNavToggle?.click();
  };

  openDesktopTrafficWindow = (type = "summary") => {
    if (window.innerWidth < 1200) return;
    this.desktopWindowsRef.current?.openWindow(type);
  };

  openDesktopContractTab = (contract) => {
    if (window.innerWidth < 1200) return false;
    this.desktopWindowsRef.current?.openContractTab(contract);
  };

  handleDeviceTrackingClick = (contract) => {
    this.abrirModal2(contract, undefined, {
      openInDesktopWindow: this.state.desktopWindowLauncherVisible && window.innerWidth >= 1200,
    });
  };

  openContractInModalFromDesktop = (contract, closeInternalWindow) => {
    this.abrirModal2(contract, closeInternalWindow, { allowAtDesktopLimit: true });
  };

  handleDesktopWindowLimitReached = (limit = 5) => {
    Swal.fire({
      icon: "warning",
      title: "Límite de multiventanas alcanzado",
      text: `Debes cerrar una ventana interna antes de abrir otro contrato de seguimiento. El máximo es ${limit}.`,
      confirmButtonText: "Entendido",
    });
  };

  toggleDesktopTrafficWindowLauncher = () => {
    if (window.innerWidth < 1200) return;
    const nextVisible = !this.state.desktopWindowLauncherVisible;
    sessionStorage.setItem(MULTIVENTANA_ENABLED_STORAGE_KEY, String(nextVisible));
    this.desktopWindowsRef.current?.toggleLauncher();
    this.setState({ desktopWindowLauncherVisible: nextVisible });
  };

  handleDesktopWindowLauncherVisibilityChange = (visible) => {
    this.setState({ desktopWindowLauncherVisible: visible });
  };

  handleDesktopWindowShortcut = (shortcut) => {
    if (shortcut === "filter") document.querySelector('[data-bs-target="#offcanvasFilter"]')?.click();
    if (shortcut === "live") this.toggleOffcanvas();
    if (shortcut === "fullscreen") this.toggleFullscreen();
  };

  handleLiveSearchChange = (event) => {
    this.setState({ liveSearch: event.target.value });
  };

  isStreamingOn = (contrato) => {
    const value = contrato?.StreamingOn ?? contrato?.streamingOn;
    return value === true || value === "true" || value === 1 || value === "1";
  };

  resolveLiveStreamUrl = (msg, deviceId) => {
    const raw =
      msg?.streamId ||
      msg?.streamUrl ||
      msg?.url ||
      msg?.data?.url ||
      "";

    const normalizeName = (value) => {
      if (!value) return "";
      const text = String(value);

      // play.html?name=XYZ
      const playMatch = text.match(/play\.html\?name=([^&]+)/i);
      if (playMatch?.[1]) return playMatch[1];

      // rtmp://.../LiveApp/NAME or http(s)://.../LiveApp/NAME
      const liveAppMatch = text.match(/LiveApp\/([^/?#]+)/i);
      if (liveAppMatch?.[1]) return liveAppMatch[1];

      // generic: take last path segment
      if (text.includes("/")) {
        const last = text.split("/").filter(Boolean).pop();
        if (last) return last;
      }

      return text;
    };

    if (raw && String(raw).toLowerCase().includes("play.html")) return raw;

    const nameFromRaw = normalizeName(raw);
    if (nameFromRaw) {
      return `https://streaming.cargotronics.com:5443//LiveApp/play.html?name=${nameFromRaw}`;
    }

    if (deviceId) {
      return `https://streaming.cargotronics.com:5443//LiveApp/play.html?name=${deviceId}_JT800`;
    }
    return "";
  };

  ensureMutedStreamUrl = (url) => {
    if (!url) return url;
    const lower = String(url).toLowerCase();
    const hasMute = lower.includes("mute=");
    const hasMuted = lower.includes("muted=");
    const hasAutoplay = lower.includes("autoplay=");
    let next = url;
    if (!hasMute && !hasMuted) next += `${next.includes("?") ? "&" : "?"}mute=true`;
    if (!hasAutoplay) next += `${next.includes("?") ? "&" : "?"}autoplay=true`;
    return next;
  };

  handleLiveEnded = (msg) => {
    this.removeStream(msg);
  };

  getLiveStreamUrlForDevice = (deviceId) => {
    const streams = this.state.activeStreams || [];
    const stream = streams.find(
      (s) => String(s?.deviceId || "") === String(deviceId || "")
    );
    return stream ? this.resolveLiveStreamUrl(stream, stream.deviceId) : "";
  };

  renderActiveStreams = () => {
    const streams = this.getLiveStreamsForDisplay();
    if (streams.length === 0) {
      return (
        <div style={{ color: "#6c757d", fontSize: 14 }}>
          No hay transmisiones activas.
        </div>
      );
    }

    const contratos = this.getContractsForLiveDisplay();

    const findContratoByDevice = (deviceId) =>
      contratos.find(
        (c) =>
          c?.FKLokDeviceID &&
          deviceId &&
          c.FKLokDeviceID.toString() === deviceId.toString()
      );

    return (
      <div style={{ display: "grid", gap: 12 }}>
        {streams.map((stream) => {
          const contrato = findContratoByDevice(stream.deviceId) || {};
          const dispositivo =
            contrato.FKLokDeviceID || stream.deviceId || "N/D";
          const placa = contrato.PlacaTruck || "N/D";
          const cliente = contrato.NombreEmpresa || "N/D";

          return (
            <div
              key={stream.streamId}
              style={{
                background: "#fff",
                borderRadius: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                overflow: "hidden",
                border: "1px solid #e6eef7",
              }}
            >
              <div style={{ padding: "8px 10px" }}>
                <div style={{ fontWeight: 700 }}>{dispositivo}</div>
                <div style={{ fontSize: 12, color: "#5f6b7a" }}>
                  Placa: {placa} · Cliente: {cliente}
                </div>
              </div>
              <iframe
                title={`live-${stream.deviceId}`}
                src={this.ensureMutedStreamUrl(
                  this.resolveLiveStreamUrl(stream, stream.deviceId)
                )}
                width="100%"
                height="240"
                allow="autoplay; fullscreen"
                style={{ border: "none", display: "block" }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderLiveStreamSection = () => {
    if (!this.state.offcanvasActive) return null;

    const streams = this.getLiveStreamsForDisplay();
    const contratos = this.getContractsForLiveDisplay();

    const findContratoByDevice = (deviceId) =>
      contratos.find(
        (c) =>
          c?.FKLokDeviceID &&
          deviceId &&
          c.FKLokDeviceID.toString() === deviceId.toString()
      );

    const term = (this.state.liveSearch || "").trim().toLowerCase();
    const enriched = streams.map((stream) => {
      const contrato = findContratoByDevice(stream.deviceId) || {};
      const dispositivo = contrato.FKLokDeviceID || stream.deviceId || "N/D";
      const placa = contrato.PlacaTruck || "N/D";
      const cliente = contrato.NombreEmpresa || "N/D";
      const match = `${dispositivo} ${placa} ${cliente}`.toLowerCase();
      const streamUrl = this.ensureMutedStreamUrl(
        this.resolveLiveStreamUrl(stream, stream.deviceId)
      );
      return { stream, contrato, dispositivo, placa, cliente, match, streamUrl };
    });
    const filtered = term
      ? enriched.filter((item) => item.match.includes(term))
      : enriched;

    return (
      <div
        id="live-inline-section"
        className="card live-inline-section"
        style={{ marginTop: this.state.isMobileView ? 0 : 16, width: "100%", border: "1px solid #dce6f2", borderRadius: 12, overflow: "hidden", background: "#fff" }}
      >
        <div style={{ padding: "12px 14px", borderBottom: "1px solid #e6eef7", background: "#fff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            {!this.state.isMobileView && (
              <div style={{ fontWeight: 700, fontSize: 16 }}>
                Live activos ({filtered.length}/{streams.length})
              </div>
            )}
            <div className="input-group" style={{ maxWidth: 320 }}>
              <span className="input-group-text">
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar live..."
                value={this.state.liveSearch}
                onChange={this.handleLiveSearchChange}
              />
            </div>
          </div>
        </div>

        <div className="live-inline-body">
          {filtered.length === 0 ? (
            <div style={{ color: "#6c757d", fontSize: 14 }}>
              {this.state.isMobileView && streams.length === 0 ? "No hay transmisiones disponibles" : "No hay transmisiones que coincidan con la búsqueda."}
            </div>
          ) : (
            <div
              className="live-inline-grid"
              style={{
                display: "flex",
                flexDirection: this.state.isMobileView ? "column" : "row",
                gap: 12,
                overflowX: this.state.isMobileView ? "visible" : "auto",
                paddingBottom: 6,
              }}
            >
              {filtered.map((item) => (
                <div
                  key={item.stream.streamId}
                  style={{
                    minWidth: this.state.isMobileView ? "100%" : 320,
                    background: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    border: "1px solid #e6eef7",
                    display: "flex",
                    flexDirection: this.state.isMobileView ? "row" : "column",
                    alignItems: "stretch",
                    cursor: "pointer",
                  }}
                  onClick={() => this.abrirModalEnVivoDesdeListaResponsive(item.contrato, item.streamUrl)}
                >
                  <div
                    style={{
                      padding: "10px 12px",
                      flex: "1 1 auto",
                      minWidth: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{item.dispositivo}</div>
                    <div style={{ fontSize: 12, color: "#5f6b7a", marginTop: 4 }}>
                      Placa: {item.placa} · Cliente: {item.cliente}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: this.state.isMobileView ? "0 0 42%" : "0 0 auto",
                      width: this.state.isMobileView ? "42%" : "100%",
                      minWidth: this.state.isMobileView ? 132 : "100%",
                      maxWidth: this.state.isMobileView ? 180 : "100%",
                      borderLeft: this.state.isMobileView ? "1px solid #e6eef7" : "none",
                      borderTop: this.state.isMobileView ? "none" : "1px solid #e6eef7",
                      background: "#eef4fa",
                    }}
                  >
                    <iframe
                      title={`live-inline-${item.stream.deviceId}`}
                      src={item.streamUrl}
                      width="100%"
                      height={this.state.isMobileView ? "112" : "200"}
                      allow="autoplay; fullscreen"
                      style={{ border: "none", display: "block", pointerEvents: "none" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Función para aplicar filtros
  applyFilters = (arrayFilter) => {
    //console.log("Aplicando filtros:", arrayFilter);
    const searchValue = sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY) || "";
    const arrayFilters = JSON.parse(sessionStorage.getItem(TRAFICO_FILTERS_STORAGE_KEY)) || { filters: [] };
    //console.log("Aplicando filtros desde localStorage:", arrayFilters);

    // Filtrar los nuevos contratos
    const visibleContratos = this.applyCriticalContractsFilter(this.state.listContratos);
    const filteredContratos = this.filterContratos(visibleContratos, searchValue);
    const updatedContratos = filteredContratos;

    // Actualizar el estado de notificacion si el arreglo de filtros es es mayor a 0, es decir que exista
    const checkNotificationCircle = (arrayFilter) => {
      //console.log("Verificando si hay filtros para notificación:", arrayFilter);
      if (arrayFilter) {
        this.setState({ notificationCircle: true });
      } else {
        this.setState({
          notificationCircle: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });

      }
    }


    this.setState({ arrayFilter: arrayFilter }, () => {
      //console.log("Guardando filtros en localStorage:", this.state.arrayFilters);
      checkNotificationCircle(sessionStorage.getItem(TRAFICO_FILTERS_STORAGE_KEY));
    });
    const storedFilters = arrayFilter;
    // const storedFilters = JSON.parse(localStorage.getItem('arrayFilters'));
    if (!storedFilters) {
      //console.log('No hay filtros en localStorage');
      this.ListarContratosWithinFilters();
      //this.loadFillData(this.state.listContratos);
      // this.setState({
      //   countContrats: this.state.listContratos.length,
      // });
      return;
    }

    //console.log("Aplicando filtros desde localStorage:", storedFilters);

    let contratosFiltrados = [...visibleContratos];

    storedFilters.filters.forEach((filter) => {
      const key = Object.keys(filter)[0];
      const value = filter[key];

      switch (key) {
        case 'filterEmpresa':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            matchesCompanyFilter(contrato, value)
          );
          break;
        case 'filterEstado':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            value.includes(contrato.TipoReporte)
          );
          break;
        case 'filterRuta':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            value.includes(contrato.DescripcionRuta)
          );
          break;
        case 'filterCiudadOrigen':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            value.includes(contrato.CiudadOrigen)
          );
          break;
        case 'filterCiudadDestino':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            value.includes(contrato.CiudadDestino)
          );
          break;
        case 'filterDispositivo':
          contratosFiltrados = contratosFiltrados.filter((contrato) =>
            value.includes(contrato.FKLokDeviceID)
          );
          break;
        case 'filterAlerta':
          contratosFiltrados = contratosFiltrados.filter((contrato) => {
            const alertIcons = [
              contrato.IconMoving,
              contrato.IconBack,
              contrato.icon_bat,
              contrato.IconDesvio,
              contrato.IconLocked,
              contrato.IconSeguro,
              contrato.IconValitronics,
            ];

            // Filtrar por íconos de alerta
            const iconResult = alertIcons.some(icon => {
              // Extraer el nombre del archivo sin la extensión
              const iconName = String(icon || "").split("/").pop().replace(/\.(png|gif)$/, "");  // RegExp para manejar .png o .gif
              return value?.alertas?.includes(iconName) && iconName !== "transparent";
            });

            // Filtrar por `tiempoUltReporte`
            let tiempoUltReporteResult = false;
            if (value.tiempoUltReporte) {

              const diferenciaEnMinutos = getMinutesSinceLastReport(contrato.LoksysServerTime);
              const valorNumerico = parseInt(value.tiempoUltReporte, 10);
              //console.log("diferecnia en minutos", diferenciaEnMinutos);
              //console.log("valor de tiempo ultimo reporte", valorNumerico);
              tiempoUltReporteResult = diferenciaEnMinutos >= valorNumerico;
            }

            // Filtrar por `tiempoDetencion`
            let tiempoDetencionResult = false;
            if (value.tiempoDetencion) {
              tiempoDetencionResult =
                parseInt(contrato.tiempodetencion || 0, 10) >= parseInt(value.tiempoDetencion, 10);
            }

            let nogpsResult = false;
            if (value.alertas && value.alertas.includes("nogps")) {
              //console.log("entro a no gps");
              nogpsResult = contrato.bitGPS === true;
            }

            let noTrayectoResult = false;
            if (value.alertas && value.alertas.includes("trayectonull")) {
              //console.log("entro a no trayecto");
              noTrayectoResult = contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9;
            }

            return iconResult || tiempoUltReporteResult || tiempoDetencionResult || nogpsResult || noTrayectoResult;
          });
          break;
        case 'orderByCriteria':
          contratosFiltrados = this.sortByCriteria(contratosFiltrados, value);
          break;
        default:
          break;
      }
    });

    // Actualizar estadísticas
    const countOpenChain = contratosFiltrados.filter((contrato) =>
      contrato.IconLocked.includes('candado') || contrato.IconLocked.includes('openedpadlockalerta')
    ).length;
    const countLowBattery = contratosFiltrados.filter((contrato) =>
      contrato.icon_bat.includes('batt-low')
    ).length;
    const countMoving = contratosFiltrados.filter((contrato) =>
      contrato.IconMoving.includes('moving')
    ).length;
    const countStop = contratosFiltrados.filter((contrato) =>
      contrato.IconMoving.includes('stop')
    ).length;
    const countStopAlert = contratosFiltrados.filter((contrato) =>
      contrato.IconMoving.includes('stopAlert')
    ).length;
    const countDesvio = contratosFiltrados.filter((contrato) =>
      contrato.IconDesvio.includes('desvioalerta')
    ).length;
    const countNoGps = contratosFiltrados.filter((contrato) =>
      contrato.bitGPS === true
    ).length;
    const countNoRuta = contratosFiltrados.filter((contrato) =>
      contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
    ).length;
    const streamingCount = contratosFiltrados.filter((contrato) =>
      this.isStreamingOn(contrato)
    ).length;

    const timeExchangeContractCount = contratosFiltrados.filter((contrato) =>
      hasLegacyTimeExchange(contrato.LoksysServerTime)
    ).length;
    const countRefuerzo = contratosFiltrados.filter((data) => {
      const anexos = this.state.filteredContratos.filter(
        (contratoAnexo) =>
          (contratoAnexo.PlacaTruck !== null && contratoAnexo.PlacaTruck !== '') &&
          (data.PlacaTruck !== null && data.PlacaTruck !== '') &&
          // (contratoAnexo.ContainerNum !== null && contratoAnexo.ContainerNum !== '') &&
          // (data.ContainerNum !== null && data.ContainerNum !== '') &&
          // Comparamos que ambos tengan los mismos valores y que sean de contratos distintos
          contratoAnexo.PlacaTruck === data.PlacaTruck &&
          contratoAnexo.ContainerNum === data.ContainerNum &&
          contratoAnexo.ContractID !== data.ContractID
      );
      return anexos.length > 0;
    }).length;
    // Actualizar estado
    this.setState({
      filteredContratos: contratosFiltrados,
      countContrats: contratosFiltrados.length,
      openCount: countOpenChain,
      lowBatteryCount: countLowBattery,
      movingCount: countMoving,
      refuerzoCount: countRefuerzo,
      stopCount: countStop,
      stopAlertCount: countStopAlert,
      desvioCount: countDesvio,
      timeExchange: timeExchangeContractCount,
      NoGpsCount: countNoGps,
      NoRutaCount: countNoRuta,
      streamingCount: streamingCount,
      unsecuredCount: contratosFiltrados.filter((contrato) => isUnsecuredContrato(contrato)).length,
    });
  };


  filterContratos = (contratos, value) => {
    //console.log("Filtrando contratos con el término de búsqueda:", value);
    //console.log("Filtrando contratos con el término de búsqueda: contrato", contratos);
    const selectedCompanies = this.state.selectedTrafficCompanies || [];
    const companyFiltered = selectedCompanies.length === 0
      ? contratos
      : contratos.filter((contrato) => matchesCompanyFilter(contrato, selectedCompanies));

    return companyFiltered.filter(contrato => {
      const lowerValue = (value || "").toLowerCase();
      const lowerContractID = contrato.ContractID ? contrato.ContractID.toLowerCase() : "";
      const lowerNombreEmpresa = contrato.NombreEmpresa ? contrato.NombreEmpresa.toLowerCase() : "";
      const lowerCiudad = contrato.Ciudad ? contrato.Ciudad.toLowerCase() : "";
      const lowerFKLokDeviceID = contrato.FKLokDeviceID ? contrato.FKLokDeviceID.toLowerCase() : "";
      const lowerPlacaTruck = contrato.PlacaTruck ? contrato.PlacaTruck.toLowerCase() : "";
      const lowerDescripcionRuta = contrato.DescripcionRuta ? contrato.DescripcionRuta.toLowerCase() : "";
      const lowerLastReportUbica = contrato.LastReportUbica ? contrato.LastReportUbica.toLowerCase() : "";
      const lowerContainerNum = contrato.ContainerNum ? contrato.ContainerNum.toLowerCase() : "";
      const lowerRef = contrato.Ref ? contrato.Ref.toLowerCase() : "";

      return (
        lowerContractID.includes(lowerValue) ||
        lowerNombreEmpresa.includes(lowerValue) ||
        lowerCiudad.includes(lowerValue) ||
        lowerFKLokDeviceID.includes(lowerValue) ||
        lowerPlacaTruck.includes(lowerValue) ||
        lowerDescripcionRuta.includes(lowerValue) ||
        lowerLastReportUbica.includes(lowerValue) ||
        lowerContainerNum.includes(lowerValue) ||
        lowerRef.includes(lowerValue)
      );
    });
  }

  isCriticalContrato = (contrato) => Number(contrato?.EsCritico || 0) === 1;

  applyCriticalContractsFilter = (contratos = []) => {
    const source = Array.isArray(contratos) ? contratos : [];

    if (!this.state.critico) {
      return source;
    }

    return source.filter((contrato) => this.isCriticalContrato(contrato));
  }

  getQuickFilterStats = (contratos = [], refContratos = contratos) => {
    const source = Array.isArray(contratos) ? contratos : [];
    const refSource = Array.isArray(refContratos) ? refContratos : source;

    return {
      openCount: source.filter((contrato) =>
        (contrato?.IconLocked || "").includes("candado") ||
        (contrato?.IconLocked || "").includes("openedpadlockalerta")
      ).length,
      lowBatteryCount: source.filter((contrato) => (contrato?.icon_bat || "").includes("batt-low")).length,
      movingCount: source.filter((contrato) => (contrato?.IconMoving || "").includes("moving")).length,
      stopCount: source.filter((contrato) => (contrato?.IconMoving || "").includes("stop")).length,
      stopAlertCount: source.filter((contrato) => (contrato?.IconMoving || "").includes("stopAlert")).length,
      desvioCount: source.filter((contrato) => (contrato?.IconDesvio || "").includes("desvioalerta")).length,
      timeExchange: source.filter((contrato) => hasLegacyTimeExchange(contrato?.LoksysServerTime)).length,
      refuerzoCount: source.filter((data) => {
        const anexos = refSource.filter(
          (contratoAnexo) =>
            (contratoAnexo?.PlacaTruck || "") !== "" &&
            (data?.PlacaTruck || "") !== "" &&
            contratoAnexo.PlacaTruck === data.PlacaTruck &&
            contratoAnexo.ContainerNum === data.ContainerNum &&
            contratoAnexo.ContractID !== data.ContractID
        );
        return anexos.length > 0;
      }).length,
      NoGpsCount: source.filter((contrato) => contrato?.bitGPS === true).length,
      NoRutaCount: source.filter((contrato) => contrato?.DescripcionTrayecto === null && contrato?.FKLokTipoEquipo === 9).length,
      streamingCount: source.filter((contrato) => this.isStreamingOn(contrato)).length,
      unsecuredCount: source.filter((contrato) => isUnsecuredContrato(contrato)).length,
    };
  }

  handleSearchChange = (event) => {
    const { listContratos } = this.state;
    const value = event.target.value.toLowerCase();
    // Guardar el valor de búsqueda en localStorage
    sessionStorage.setItem(TRAFICO_SEARCH_STORAGE_KEY, value);

    // Filtra los contratos con el término de búsqueda
    const visibleContratos = this.applyCriticalContractsFilter(listContratos);
    const filteredContratos = this.filterContratos(visibleContratos, value);

    const stats = this.getQuickFilterStats(filteredContratos, filteredContratos);

    // Actualizar el estado con los contratos filtrados
    this.setState({
      searchValue: value,
      filteredContratos: filteredContratos,
      countContrats: filteredContratos.length,
      ...stats,
    });
  };

  getTrafficCompanyOptions = () => {
    const companies = new Set();
    (this.state.listContratos || []).forEach((contrato) => {
      getCompanyFilterCandidates(contrato).forEach((company) => companies.add(company));
    });

    const selectedCompanies = new Set(this.state.selectedTrafficCompanies || []);

    return Array.from(companies)
      .sort((first, second) => first.localeCompare(second, "es", { sensitivity: "base" }))
      .map((company) => ({ value: company, label: company }))
      .sort((first, second) => {
        const firstSelected = selectedCompanies.has(first.value) ? 0 : 1;
        const secondSelected = selectedCompanies.has(second.value) ? 0 : 1;
        return firstSelected - secondSelected;
      });
  };

  handleTrafficCompanyChange = (selectedOptions) => {
    const selectedCompanies = (selectedOptions || []).map((option) => option.value);
    sessionStorage.setItem(TRAFICO_COMPANIES_STORAGE_KEY, JSON.stringify(selectedCompanies));

    this.setState({ selectedTrafficCompanies: selectedCompanies }, () => {
      const visibleContratos = this.applyCriticalContractsFilter(this.state.listContratos || []);
      const filteredContratos = this.filterContratos(visibleContratos, this.state.searchValue);
      const stats = this.getQuickFilterStats(filteredContratos, filteredContratos);

      this.setState({
        filteredContratos,
        countContrats: filteredContratos.length,
        ...stats,
      });
    });
  };

  scrollToContract(contractId) {
    const element = document.getElementById(`contract-${contractId}`);
    if (element) {
      // Desplazamiento suave
      element.scrollIntoView({ behavior: "smooth", block: "start" });

      // Agrega la clase para el efecto "parpadeo"
      element.classList.add("blink-bg");

      // Quita la clase tras 3 segundos
      setTimeout(() => {
        element.classList.remove("blink-bg");
      }, 3000);
    }
  }



  HandlePageByRole = async () => {
    let data = {
      pagina: "1",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true, // this should be inside the options object
        }
      );

      /*
      if (res.data.success === false) {
        window.location = "/";
        return;
      }

      const permissions = res.data?.data?.[0];
      this.setState({
        bitOpenActualizarContrato: Boolean(permissions?.bitOpen),
        bitInsertUActualizarContrato: permissions?.bitInsert,
        bitEditUActualizarContrato: permissions?.bitEdit,
        bitDeleteUActualizarContrato: permissions?.bitDelete,
      });

      if (!permissions?.bitOpen) {
        Swal.fire({
          title: "InformaciÃ³n",
          text: "No tiene los permisos necesarios para acceder a esta opciÃ³n",
          icon: "info",
          timer: 3000,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        return;
      }

      const endpoint = this.state.project == 1
        ? "/contratos/getinfocontrato"
        : "/contratos/getinfocontratoproyecto";
      const resContrato = await axios.post(
        process.env.REACT_APP_SERVER + endpoint,
        JSON.stringify({ contrato: data.ContractID }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (resContrato.data?.success === false) {
        window.location = "/";
        return;
      }

      this.setState({
        infoUpdateContrato: resContrato.data?.data || [],
        contratoseleccionado: data.ContractID,
        ...(this.state.project == 1
          ? { isDialogOpenEditSolicitud: true }
          : { isDialogOpenEditContratoProject: true }),
      });
      return;

      */
      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
        this.finishDeviceActionLoading();
      } else {
        //console.log("BIt permisos: ", res.data.data);
        if (res.data.data?.length > 0) {
          this.setState({
            bitOpen: res.data.data[0].bitOpen,
            bitInsert: res.data.data[0].bitInsert,
            bitEdit: res.data.data[0].bitEdit,
            bitDelete: res.data.data[0].bitDelete,
          }, () => {
            if (this.state.bitOpen) {
              console.warn("Tienes todos los permisos");

              return
            } else {
              Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta página',
                icon: 'info',
                timer: 3000, // The time in milliseconds before the alert closes (3 seconds in this case)
                showConfirmButton: false,
                allowOutsideClick: false, // Prevents clicking outside the modal to close it
                didOpen: () => {
                  Swal.showLoading(); // Shows the loading spinner
                },
                timer: 3000 // Time before redirecting (3 seconds)
              }).then(() => {
                // This will execute after the modal finishes showing
                window.location.href = "/principal"; // Redirect to another page
              });
            }

          })
        }

      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }
  };


  loadingChange = () => {
    this.setState({ modalLoading: !this.state.modalLoading }, () => {
      //console.log(this.state.modalLoading);
    });

  }


  toggleFullscreen = () => {
    if (!this.state.isFullscreen) {
      // Activar el modo de pantalla completa
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    } else {
      // Desactivar el modo de pantalla completa
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }

    // Actualizar el estado
    this.setState({ isFullscreen: !this.state.isFullscreen });
  };

  // METODO PARA EDITAR TRAYECTO EN EL CONTRATO
  EditarRuta() {
    let data = {
      Trayecto: this.state.rutaseleccionada,
      Contrato: this.state.contratoseleccionado,
    };
    const json = JSON.stringify(data);
    if (this.state.rutaseleccionada != -1) {
      axios
        .post(
          process.env.REACT_APP_SERVER + "/operaciones/updatecontratotrayecto",
          json,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.data.hasOwnProperty("success")) {
            $("#success-alert")
              .fadeTo(2000, 500)
              .slideUp(500, function () {
                $("#success-alert").slideUp(2000);
              });
            $("#ModalAsignacion .close").click();

            //history.go(0);
          } else {
            $("#danger-alert")
              .fadeTo(2000, 500)
              .slideUp(500, function () {
                $("#danger-alert").slideUp(2000);
              });
          }
        });
    } else {
      $("#danger-alert")
        .fadeTo(2000, 500)
        .slideUp(500, function () {
          $("#danger-alert").slideUp(2000);
        });
    }
  }

  async ListarContratosWithinFilters() {
    try {

      let contratosConEstadoExpandido = [];
      const visibleContratos = this.applyCriticalContractsFilter(this.state.listContratos);
      this.setState({ filteredContratos: visibleContratos }, () => {
        //console.log(this.state.filteredContratos);
        contratosConEstadoExpandido = this.state.filteredContratos;
        //console.log("estos son los filtros desde localStorage:", this.state.arrayFilters);

        const countOpenChain = contratosConEstadoExpandido.filter((contrato) => contrato.IconLocked.includes('candado') || contrato.IconLocked.includes('openedpadlockalerta')).length;
        //console.log(countOpenChain);

        const countLowBattery = contratosConEstadoExpandido.filter((contrato) => contrato.icon_bat.includes('batt-low')).length;
        //console.log(countLowBattery);

        const countMoving = contratosConEstadoExpandido.filter((contrato) => contrato.IconMoving.includes('moving')).length;
        //console.log(countMoving);

        const countStop = contratosConEstadoExpandido.filter((contrato) => contrato.IconMoving.includes('stop')).length;
        //console.log(countStop);

        const countStopAlert = contratosConEstadoExpandido.filter((contrato) => contrato.IconMoving.includes('stopAlert')).length;
        //console.log(countStopAlert);

        const countDesvio = contratosConEstadoExpandido.filter((contrato) => contrato.IconDesvio.includes('desvioalerta')).length;
        //console.log(countDesvio);

        const countNoGps = contratosConEstadoExpandido.filter((contrato) =>
          contrato.bitGPS === true
        ).length;
        const countNoRuta = contratosConEstadoExpandido.filter((contrato) =>
          contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
        ).length;
        const countStreaming = contratosConEstadoExpandido.filter((contrato) =>
          this.isStreamingOn(contrato)
        ).length;


        const timeExchangeContractCount = contratosConEstadoExpandido.filter((contrato) =>
          hasLegacyTimeExchange(contrato.LoksysServerTime)
        ).length;
        const countRefuerzo = contratosConEstadoExpandido.filter((data) => {
          const anexos = contratosConEstadoExpandido.filter(
            (contratoAnexo) =>
              (contratoAnexo.PlacaTruck !== null && contratoAnexo.PlacaTruck !== '') &&
              (data.PlacaTruck !== null && data.PlacaTruck !== '') &&
              // (contratoAnexo.ContainerNum !== null && contratoAnexo.ContainerNum !== '') &&
              // (data.ContainerNum !== null && data.ContainerNum !== '') &&
              // Comparamos que ambos tengan los mismos valores y que sean de contratos distintos
              contratoAnexo.PlacaTruck === data.PlacaTruck &&
              contratoAnexo.ContainerNum === data.ContainerNum &&
              contratoAnexo.ContractID !== data.ContractID
          );
          return anexos.length > 0;
        }).length;
        const countContratos = contratosConEstadoExpandido.length;
        //console.log("countContratos :", countContratos);
        this.setState({
          countContrats: countContratos,
          openCount: countOpenChain,
          lowBatteryCount: countLowBattery,
          timeExchange: timeExchangeContractCount,
          movingCount: countMoving,
          refuerzoCount: countRefuerzo,
          stopCount: countStop,
          stopAlertCount: countStopAlert,
          desvioCount: countDesvio,
          NoGpsCount: countNoGps,
          NoRutaCount: countNoRuta,
          streamingCount: countStreaming,
          unsecuredCount: contratosConEstadoExpandido.filter((contrato) => isUnsecuredContrato(contrato)).length,
        });
      }

      );
      //console.log(contratosConEstadoExpandido);






    } catch (error) {
      console.error("Error al listar contratos:", error);
    }
  }

  // METODO PARA LISTAR CONTRATOS ACTIVOS
  async ListarContratos() {
    const routeSelected = this.props.contractsEndpoint || 'operaciones/getcontratostrafico';
    const loadingRequestId = ++this.trafficLoadingRequestId;
    const loadingStartedAt = Date.now();
    this.setState({ isTrafficLoading: true });
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVER}/${routeSelected}`, {
        withCredentials: true, // Si necesitas credenciales
      });

      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("entre a listar contratos");
        const contratosRecibidos = Array.isArray(res.data.data) ? res.data.data : [];
        const contratosConEstadoExpandido = contratosRecibidos.map((contrato) => {
          // Convierte el tiempo Unix a una fecha formateada
          const formattedDate = contrato.tiempoUnix
            ? formattedGlobalDate(new Date(contrato.tiempoUnix * 1000).toISOString()) // Formatea en zona preferida
            : null;

          return {
            ...contrato,
            expanded: JSON.parse(localStorage.getItem(`contrato_${contrato.ContractID}_expanded`)) || false,
            formattedDate // Agrega la fecha formateada al objeto
          };
        });
        const visibleContratos = this.applyCriticalContractsFilter(contratosConEstadoExpandido);
        const searchValue = sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY) || "";
        const searchFilteredContratos = this.filterContratos(visibleContratos, searchValue);
        this.desktopWindowsRef.current?.updateContracts(contratosConEstadoExpandido);
        console.log(
          `[${this.props.contractsEndpoint === "operaciones/getcontratosporrecoger"
            ? "TraficoPorRecoger"
            : "Trafico"}] contratos listados:`,
          contratosRecibidos
        );
        //console.log(this.state.filteredContratos);
        this.setState({
          listContratos: contratosConEstadoExpandido,
          filteredContratos: searchFilteredContratos,
          searchValue,
        });
        //console.log(contratosConEstadoExpandido);




        //console.log("estos son los filtros desde localStorage:", this.state.arrayFilters);
        const storedFilters = this.state.arrayFilters;
        if (storedFilters.filters.length > 0) {
          let contratosFiltrados = searchFilteredContratos;
          storedFilters.filters.forEach(filter => {
            const key = Object.keys(filter)[0];
            const value = filter[key];

            switch (key) {
              case 'filterEmpresa':
                contratosFiltrados = contratosFiltrados.filter(contrato =>
                  matchesCompanyFilter(contrato, value)
                );
                break;
              case 'filterEstado':
                contratosFiltrados = contratosFiltrados.filter(contrato =>
                  value.includes(contrato.TipoReporte)
                );
                break;
              case 'filterRuta':
                contratosFiltrados = contratosFiltrados.filter(contrato =>
                  value.includes(contrato.DescripcionRuta)
                );
                break;

              case 'filterCiudadOrigen':
                contratosFiltrados = contratosFiltrados.filter((contrato) =>
                  value.includes(contrato.CiudadOrigen)
                );
                break;
              case 'filterCiudadDestino':
                contratosFiltrados = contratosFiltrados.filter((contrato) =>
                  value.includes(contrato.CiudadDestino)
                );
                break;
              case 'filterDispositivo':
                contratosFiltrados = contratosFiltrados.filter(contrato =>
                  value.includes(contrato.FKLokDeviceID)
                );
                break;
              case 'filterAlerta':
                contratosFiltrados = contratosFiltrados.filter(contrato => {
                  const alertIcons = [
                    contrato.IconMoving,
                    contrato.IconBack,
                    contrato.icon_bat,
                    contrato.IconDesvio,
                    contrato.IconLocked,
                    contrato.IconSeguro,
                    contrato.IconValitronics
                  ];

                  // Filtrar por íconos de alerta
                  const iconResult = alertIcons.some(icon => {
                    // Extraer el nombre del archivo sin la extensión
                    const iconName = String(icon || "").split("/").pop().replace(/\.(png|gif)$/, "");  // RegExp para manejar .png o .gif
                    return value?.alertas?.includes(iconName) && iconName !== "transparent";
                  });

                  // Filtrar por `tiempoUltReporte`
                  let tiempoUltReporteResult = false;
                  if (value.tiempoUltReporte) {

                    const diferenciaEnMinutos = getMinutesSinceLastReport(contrato.LoksysServerTime);
                    const valorNumerico = parseInt(value.tiempoUltReporte, 10);
                    //console.log("diferecnia en minutos", diferenciaEnMinutos);
                    //console.log("valor de tiempo ultimo reporte", valorNumerico);
                    tiempoUltReporteResult = diferenciaEnMinutos >= valorNumerico;
                  }


                  // Filtrar por `tiempoDetencion`
                  let tiempoDetencionResult = false;
                  if (value.tiempoDetencion) {
                    const tiempoDetencionNumerico = parseInt(contrato.tiempodetencion || 0, 10);
                    const valorDetencionNumerico = parseInt(value.tiempoDetencion, 10);
                    tiempoDetencionResult = tiempoDetencionNumerico >= valorDetencionNumerico;
                  }

                  //console.log("Resultado del filtro por íconos:", iconResult);
                  //console.log("Resultado del filtro por tiempo último reporte:", tiempoUltReporteResult);
                  //console.log("Resultado del filtro por tiempo de detención:", tiempoDetencionResult);

                  let nogpsResult = false;
                  if (value.alertas && value.alertas.includes("nogps")) {
                    //console.log("entro a no gps");
                    nogpsResult = contrato.bitGPS === true;
                  }

                  let noTrayectoResult = false;
                  if (value.alertas && value.alertas.includes("trayectonull")) {
                    //console.log("entro a no trayecto");
                    noTrayectoResult = contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9;
                  }

                  // Retorna `true` si alguno de los filtros coincide (operador OR)
                  return iconResult || tiempoUltReporteResult || tiempoDetencionResult || nogpsResult || noTrayectoResult;

                });
                break;
              case 'orderByCriteria': // Ordenar los contratos
                contratosFiltrados = this.sortByCriteria(contratosFiltrados, value);
                break;
              default:
                break;
            }
          });
          const countOpenChain = contratosFiltrados.filter((contrato) => contrato.IconLocked.includes('candado') || contrato.IconLocked.includes('openedpadlockalerta')).length;
          //console.log(countOpenChain);

          const countLowBattery = contratosFiltrados.filter((contrato) => contrato.icon_bat.includes('batt-low')).length;
          //console.log(countLowBattery);

          const countMoving = contratosFiltrados.filter((contrato) => contrato.IconMoving.includes('moving')).length;
          //console.log(countMoving);

          const countStop = contratosFiltrados.filter((contrato) => contrato.IconMoving.includes('stop')).length;
          //console.log(countStop);

          const countStopAlert = contratosFiltrados.filter((contrato) => contrato.IconMoving.includes('stopAlert')).length;
          //console.log(countStopAlert);

          const countDesvio = contratosFiltrados.filter((contrato) => contrato.IconDesvio.includes('desvioalerta')).length;
          //console.log(countDesvio);

          const countNoGps = contratosFiltrados.filter((contrato) =>
            contrato.bitGPS === true
          ).length;
          const countNoRuta = contratosFiltrados.filter((contrato) =>
            contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
          ).length;
          const countStreaming = contratosFiltrados.filter((contrato) =>
            this.isStreamingOn(contrato)
          ).length;

          const timeExchangeContractCount = contratosFiltrados.filter((contrato) =>
            hasLegacyTimeExchange(contrato.LoksysServerTime)
          ).length;
          const countRefuerzo = contratosFiltrados.filter((data) => {
            const anexos = contratosFiltrados.filter(
              (contratoAnexo) =>
                (contratoAnexo.PlacaTruck !== null && contratoAnexo.PlacaTruck !== '') &&
                (data.PlacaTruck !== null && data.PlacaTruck !== '') &&
                // (contratoAnexo.ContainerNum !== null && contratoAnexo.ContainerNum !== '') &&
                // (data.ContainerNum !== null && data.ContainerNum !== '') &&
                // Comparamos que ambos tengan los mismos valores y que sean de contratos distintos
                contratoAnexo.PlacaTruck === data.PlacaTruck &&
                contratoAnexo.ContainerNum === data.ContainerNum &&
                contratoAnexo.ContractID !== data.ContractID
            );
            return anexos.length > 0;
          }).length;
          const countContratos = contratosFiltrados.length;
          //console.log("countContratos :", countContratos);
          this.setState({
            // listContratos: this.state.listContratos,
            filteredContratos: contratosFiltrados,
            countContrats: countContratos,
            openCount: countOpenChain,
            lowBatteryCount: countLowBattery,
            timeExchange: timeExchangeContractCount,
            movingCount: countMoving,
            refuerzoCount: countRefuerzo,
            stopCount: countStop,
            stopAlertCount: countStopAlert,
            desvioCount: countDesvio,
            NoGpsCount: countNoGps,
            NoRutaCount: countNoRuta,
            streamingCount: countStreaming,
          })
        } else {
          const countOpenChain = visibleContratos.filter((contrato) => contrato.IconLocked.includes('candado') || contrato.IconLocked.includes('openedpadlockalerta')).length;
          //console.log(countOpenChain);

          const countLowBattery = visibleContratos.filter((contrato) => contrato.icon_bat.includes('batt-low')).length;
          //console.log(countLowBattery);

          const countMoving = visibleContratos.filter((contrato) => contrato.IconMoving.includes('moving')).length;
          //console.log(countMoving);

          const countStop = visibleContratos.filter((contrato) => contrato.IconMoving.includes('stop')).length;
          //console.log(countStop);

          const countStopAlert = visibleContratos.filter((contrato) => contrato.IconMoving.includes('stopAlert')).length;
          //console.log(countStopAlert);

          const countDesvio = visibleContratos.filter((contrato) => contrato.IconDesvio.includes('desvioalerta')).length;
          //console.log(countDesvio);

          const countNoGps = visibleContratos.filter((contrato) =>
            contrato.bitGPS === true
          ).length;
          const countNoRuta = visibleContratos.filter((contrato) =>
            contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
          ).length;
          const countStreaming = visibleContratos.filter((contrato) =>
            this.isStreamingOn(contrato)
          ).length;

          const timeExchangeContractCount = visibleContratos.filter((contrato) =>
            hasLegacyTimeExchange(contrato.LoksysServerTime)
          ).length;
          const countRefuerzo = visibleContratos.filter((data) => {
            const anexos = visibleContratos.filter(
              (contratoAnexo) =>
                (contratoAnexo.PlacaTruck !== null && contratoAnexo.PlacaTruck !== '') &&
                (data.PlacaTruck !== null && data.PlacaTruck !== '') &&
                // (contratoAnexo.ContainerNum !== null && contratoAnexo.ContainerNum !== '') &&
                // (data.ContainerNum !== null && data.ContainerNum !== '') &&
                // Comparamos que ambos tengan los mismos valores y que sean de contratos distintos
                contratoAnexo.PlacaTruck === data.PlacaTruck &&
                contratoAnexo.ContainerNum === data.ContainerNum &&
                contratoAnexo.ContractID !== data.ContractID
            );
            return anexos.length > 0;
          }).length;
          const countContratos = visibleContratos.length;
          //console.log("countContratos :", countContratos);
          this.setState({
            //listContratos: this.state.listContratos,
            filteredContratos: visibleContratos,
            countContrats: countContratos,
            openCount: countOpenChain,
            lowBatteryCount: countLowBattery,
            timeExchange: timeExchangeContractCount,
            movingCount: countMoving,
            refuerzoCount: countRefuerzo,
            stopCount: countStop,
            stopAlertCount: countStopAlert,
            desvioCount: countDesvio,
            NoGpsCount: countNoGps,
            NoRutaCount: countNoRuta,
            streamingCount: countStreaming,
            unsecuredCount: visibleContratos.filter((contrato) => isUnsecuredContrato(contrato)).length,
          });
        }

      }
    } catch (error) {
      console.error("Error al listar contratos:", error);
    } finally {
      const remainingLoadingTime = Math.max(0, 450 - (Date.now() - loadingStartedAt));
      if (this.trafficLoadingTimeout) window.clearTimeout(this.trafficLoadingTimeout);
      this.trafficLoadingTimeout = window.setTimeout(() => {
        if (this.trafficLoadingRequestId === loadingRequestId) {
          this.setState({ isTrafficLoading: false });
        }
      }, remainingLoadingTime);
    }
  }


  //MANEJO DE CONTRATO Y REPORTE AJUSTADO
  async handleUltPunto(newValue) {
    this.setState({
      ultPunto: newValue
    });
  }

  async handleUltRecorrido(newValue) {
    this.setState({
      contractR: newValue
    });
  }

  handleSubmitAndOpenReporteAjustado = () => {
    const { infocontrato } = this.state;

    // Mostrar en consola la información de los servicios
    // //console.log('Contrato último punto:', ultPunto);
    // //console.log('Contrato recorrido:', contractR);
    //console.log('INFOCONTRATO:', infocontrato);

    // Hacer una copia del infocontrato para evitar mutaciones
    const infocontratoCopy = { ...infocontrato };

    // Después de actualizar el estado, abrir el modal
    this.setState({
      isDialogOpenRServicioAjustado: false,
    });
    this.OpenModalReporteServicio(infocontratoCopy);
  };


  ListarComprobantes(contrato) {
    let send = {
      contrato: contrato,
    };
    //console.log(send);
    const json = JSON.stringify(send);
    axios
      .post(process.env.REACT_APP_SERVER + "/operaciones/getcomprobantevalitronics", json, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tkn")}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.success == false) {
          window.location = "/";
        } else {
          //console.log(res.data.data);
          this.setState({ listComprobantes: res.data.data });
        }
      });
  }

  // METODO PARA LISTAR TRAYECTOS
  ListarRutas() {
    axios
      .get(process.env.REACT_APP_SERVER + "/operaciones/gettrayectoslist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tkn")}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.success == false) {
          window.location = "/";
        } else {
          this.setState({ listRutas: res.data.data });
        }
      });
  }

  // ABRIR MODAL DE EDICION DE TRAYECTO-CONTRATO
  EditContrato = async (data) => {
    this.setState({ dataGlobal: data });
    let dataPermisos = {
      pagina: "18",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("BIt permisos tracking: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenUpdateContract: res.data.data[0].bitOpen,
              bitInsertUpdateContract: res.data.data[0].bitInsert,
              bitEditUpdateContract: res.data.data[0].bitEdit,
              bitDeleteUpdateContract: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenUpdateContract) {
                console.warn("Tienes todos los permisos");
                this.setState({ contratoseleccionado: data.ContractID });
                if (data.trayecto != 0) {
                  this.setState({ rutaseleccionada: data.trayecto, isDialogOpenAsignacion: true });

                }
                const modalElement = document.getElementById("ModalAsignacion");
                const modalInstance3 = new bootstrap.Modal(modalElement, {
                  backdrop: 'static',
                  keyboard: false,
                });
                modalInstance3.show();
              } else {
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta opción",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
      }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }

    //$( "#dialog" ).dialog( "open" );
  }

  showEditContract = async (data) => {
    if (!this.beginDeviceActionLoading()) return;
    let dataPermisos = {
      pagina: "19",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (res.data.success === false) {
        window.location = "/";
        return;
      }

      const permissions = res.data?.data?.[0];
      this.setState({
        bitOpenActualizarContrato: Boolean(permissions?.bitOpen),
        bitInsertUActualizarContrato: permissions?.bitInsert,
        bitEditUActualizarContrato: permissions?.bitEdit,
        bitDeleteUActualizarContrato: permissions?.bitDelete,
      });

      if (!permissions?.bitOpen) {
        Swal.fire({
          title: "InformaciÃ³n",
          text: "No tiene los permisos necesarios para acceder a esta opciÃ³n",
          icon: "info",
          timer: 3000,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        return;
      }

      const endpoint = this.state.project == 1
        ? "/contratos/getinfocontrato"
        : "/contratos/getinfocontratoproyecto";
      const resContrato = await axios.post(
        process.env.REACT_APP_SERVER + endpoint,
        JSON.stringify({ contrato: data.ContractID }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (resContrato.data?.success === false) {
        window.location = "/";
        return;
      }

      this.setState({
        infoUpdateContrato: resContrato.data?.data || [],
        contratoseleccionado: data.ContractID,
        ...(this.state.project == 1
          ? { isDialogOpenEditSolicitud: true }
          : { isDialogOpenEditContratoProject: true }),
      });
      return;

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
        this.finishDeviceActionLoading();
      } else {
        //console.log("BIt permisos tracking: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenActualizarContrato: res.data.data[0].bitOpen,
              bitInsertUActualizarContrato: res.data.data[0].bitInsert,
              bitEditUActualizarContrato: res.data.data[0].bitEdit,
              bitDeleteUActualizarContrato: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenActualizarContrato) {
                console.warn("Tienes todos los permisos");
                if (this.state.project == 1) {
                  this.obtenerYEstablecerDatos(data.ContractID);
                } else {
                  this.obtenerYEstablecerDatosProyecto(data.ContractID);
                }
              } else {
                this.finishDeviceActionLoading();

                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta opción",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
        } else {
          this.finishDeviceActionLoading();
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
      this.finishDeviceActionLoading();
    } finally {
      this.finishDeviceActionLoading();
    }

  }

  updateTrafico = () => {
    // Lógica para actualizar el tráfico
  }

  onCloseEditContract() {
    if (this.state.project == 1) {
      this.setState({
        isDialogOpenEditSolicitud: false
      });
    } else {
      this.setState({
        isDialogOpenEditContratoProject: false
      });
    }
  }

  onCloseReporteServicio() {
    this.setState({
      isDialogOpenRSeguimientoServicio: false,
    });
  }
  onCloseModalReporteServicio() {
    this.setState({
      mostrarReporteConsolidado: false,
      isDialogOpenModalReporteServicio: false,
      ultPunto: -1,
      contractR: -1
    })
  }
  onCloseReporteServicioAjustado() {
    this.setState({
      isDialogOpenRServicioAjustado: false
    });
  }

  editarContrato() {
    this.EditarRuta();
  }

  handleChange(ruta) {
    this.setState({ rutaseleccionada: ruta });
  }

  ChangeFondo(color) {
    this.setState({ fondoseleccionado: color });
  }

  OpenReporteServicio(data) {
    //console.log("Data para el modal Reporte :", data);
    this.setState({ infocontrato: data, mostrarReporteConsolidado: true });
  }

  OpenModalReporteServicio(data) {
    //console.log("DAta desde el reporteModal", data);
    this.setState(
      {
        infocontratoAjustado: data,
        isDialogOpenModalReporteServicio: true
      }
    );
  }

  OpenReporteServicioAjustado(data) {
    //console.log("Data para el modal Reporte ajustado :", data);
    this.setState({ infocontrato: data, isDialogOpenRServicioAjustado: true });
  }

  OpenListCheck(data) {
    this.setState({ infocontrato: data, isDialogOpenModalListaCheck: true });
  }


  //LISTAR INFO CONTRATO UPDATE
  obtenerYEstablecerDatos = async (contrato) => {
    try {
      const resContrato = await axios.post(
        process.env.REACT_APP_SERVER + "/contratos/getinfocontrato",
        JSON.stringify({ contrato }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (resContrato.success === false) {
        window.location = "/";
      } else {
        //console.log("Respuesta a evaluar del contrato antes de actualizar ", resContrato);
        if (this.state.project == 1) {
          //console.log("Proyecto status", this.state.project)
          this.setState({
            infoUpdateContrato: resContrato.data.data,
            isDialogOpenEditSolicitud: true,
            contratoseleccionado: contrato
          }, this.finishDeviceActionLoading)
        } else {
          //console.log("Proyecto status", this.state.project)
          this.setState({
            infoUpdateContrato: resContrato.data.data,
            isDialogOpenEditContratoProject: true,
            contratoseleccionado: contrato
          }, this.finishDeviceActionLoading)
        }
      }
    } catch (err) {
      //console.log(err);
      this.finishDeviceActionLoading();
    }
  };

  obtenerYEstablecerDatosProyecto = async (contrato) => {
    try {
      const resContrato = await axios.post(
        process.env.REACT_APP_SERVER + "/contratos/getinfocontratoproyecto",
        JSON.stringify({ contrato }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (resContrato.success === false) {
        window.location = "/";
      } else {
        //console.log("Respuesta a evaluar del contrato antes de actualizar ", resContrato);
        if (this.state.project == 1) {
          //console.log("Proyecto status", this.state.project)
          this.setState({
            infoUpdateContrato: resContrato.data.data,
            isDialogOpenEditSolicitud: true,
            contratoseleccionado: contrato
          }, this.finishDeviceActionLoading)
        } else {
          //console.log("Proyecto status", this.state.project)
          this.setState({
            infoUpdateContrato: resContrato.data.data,
            isDialogOpenEditContratoProject: true,
            contratoseleccionado: contrato
          }, this.finishDeviceActionLoading)
        }
      }
    } catch (err) {
      //console.log(err);
      this.finishDeviceActionLoading();
    }
  };



  // METODO PARA OBTENER LISTADO DE EVENTOS POR PROYECTO
  ListarEventos() {
    axios
      .get(process.env.REACT_APP_SERVER + "/operaciones/geteventos", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tkn")}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.success === false) {
          window.location = "/";
        } else {
          this.setState({ listEventos: res.data.data });
          this.setState({ eventoseleccionado: res.data.data[0].ID_Evento });
        }
      }).catch((error) => console.log(error)
      );
  }

  // METODO PARA ACTUALIZAR EVENTO SELECCIONADO
  EditarEvento(evento) {
    this.setState({ eventoseleccionado: evento });
  }

  // ABRIR NODAL PARA SUBIR FOTOS
  OpenUploadPhoto = async (data) => {
    this.setState({ dataGlobal: data });
    //console.log("DATA", data);
    let dataPermisos = {
      pagina: "15",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("BIt permisos tracking: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenUploadPhoto: res.data.data[0].bitOpen,
              bitInsertUploadPhoto: res.data.data[0].bitInsert,
              bitEditUploadPhoto: res.data.data[0].bitEdit,
              bitDeleteUploadPhoto: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenUploadPhoto) {
                console.warn("Tienes todos los permisos");
                console.warn("DATA uplodad foto", data);
                $("#fotos").val("");
                this.setState({
                  contratoseleccionado: data.ContractID,
                  username: data.username,
                  placa: data.PlacaTruck,
                  device: data.FKLokDeviceID,
                  FKLokProyecto: data.FKLokProyecto,
                  FKICEmpresa: data.FKICEmpresa,
                  isDialogOpenModalFoto: true
                });
                $("#latitudF").val("0.00");
                $("#longitudF").val("0.00");
                $("#fechafoto").val(data.fecha);
                // const modalElement = document.getElementById("ModalFoto");
                // const modalInstance = new bootstrap.Modal(modalElement, {
                //   backdrop: 'static',
                //   keyboard: false,
                // });
                // modalInstance.show();
              } else {
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta opción",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }

  }

  //ABRIR MODAL PARA SUBIR VIDEOS
  OpenUploadVideo = async (data) => {
    this.setState({ dataGlobal: data });
    let dataPermisos = {
      pagina: "16",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("BIt permisos tracking: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenUploadVideo: res.data.data[0].bitOpen,
              bitInsertUploadVideo: res.data.data[0].bitInsert,
              bitEditUploadVideo: res.data.data[0].bitEdit,
              bitDeleteUploadVideo: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenUploadVideo) {
                console.warn("Tienes todos los permisos");
                $("#videos").val("");
                this.setState({
                  contratoseleccionado: data.ContractID,
                  username: data.username,
                  placa: data.PlacaTruck,
                  device: data.FKLokDeviceID,
                  FKLokProyecto: data.FKLokProyecto,
                  FKICEmpresa: data.FKICEmpresa,
                  isDialogOpenModalVideo: true
                });
                $("#latitudV").val("0.00");
                $("#longitudV").val("0.00");
                $("#fechaVideo").val(data.fecha);
                // const modalElement = document.getElementById("ModalVideo");
                // const modalInstance2 = new bootstrap.Modal(modalElement, {
                //   backdrop: 'static',
                //   keyboard: false,
                // });
                // modalInstance2.show();
              } else {
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta opción",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }

  }

  // METODO PARA SUBIR FOTOS
  UploadPhoto() {
    //console.log("Subiendo Foto...");
    //console.log(this.state.contratoseleccionado);

    var pattern = /\d+\.\d{2,}$/;
    if (
      !pattern.test($("#latitudF").val()) ||
      !pattern.test($("#longitudF").val())
    ) {
      $("#danger-alert")
        .fadeTo(2000, 500)
        .slideUp(500, function () {
          $("#danger-alert").slideUp(2000);
        });
    } else {
      try {
        const fecha = new Date($("#fechafoto").val());
        if (isNaN(fecha.getTime())) {
          $("#danger-alert")
            .fadeTo(2000, 500)
            .slideUp(500, function () {
              $("#danger-alert").slideUp(2000);
            });
        } else {
          const year = fecha.getFullYear();
          const mes = ("0" + (fecha.getMonth() + 1)).slice(-2);
          const dia = ("0" + fecha.getDate()).slice(-2);
          const hora = ("0" + fecha.getHours()).slice(-2);
          const minuto = ("0" + fecha.getMinutes()).slice(-2);
          const segundos = "25";
          var fechacompleta =
            year +
            "_" +
            mes +
            "_" +
            dia +
            "_" +
            hora +
            "_" +
            minuto +
            "_" +
            segundos;

          const files = $("#fotos").prop("files");
          const formData = new FormData();

          for (let i = 0; i < files.length; i++) {
            const newName =
              fechacompleta +
              "_" +
              i +
              "_" +
              this.state.device +
              "_" +
              this.state.placa +
              "_" +
              this.state.eventoseleccionado +
              "_" +
              Math.floor(Math.random() * 1000) +
              "_" +
              this.state.username +
              "_" +
              $("#latitudF").val() +
              "_" +
              $("#longitudF").val() +
              "_" +
              this.state.contratoseleccionado +
              "_" +
              this.state.FKLokProyecto +
              "_" +
              this.state.FKICEmpresa;

            if (files[i].type.startsWith("image/")) {
              formData.append("files", files[i], newName + ".jpg");
            } else if (files[i].type.startsWith("video/")) {
              formData.append("files", files[i], newName + ".mp4");
            }
            //console.log("Nombre de la foto ajustado", newName)
          }
          let timerInterval;
          Swal.fire({
            title: "Subiendo Foto...",
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
            willClose: () => {
              clearInterval(timerInterval);
            }
          });

          fetch(process.env.REACT_APP_SERVER + "/upload", {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("tkn")}`,
              // No se incluye 'Content-Type': 'multipart/form-data' porque fetch lo maneja automáticamente
            },
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              Swal.close();
              if (data.hasOwnProperty("success")) {
                $("#success-alert")
                  .fadeTo(2000, 500)
                  .slideUp(500, function () {
                    $("#success-alert").slideUp(2000);
                  });
                $("#ModalFoto .close").click();
              } else {
                Swal.close();
                $("#danger-alert")
                  .fadeTo(2000, 500)
                  .slideUp(500, function () {
                    $("#danger-alert").slideUp(2000);
                  });
              }
            })
            .catch(error => {
              Swal.close();
              console.error("Error subiendo foto:", error);
            });
        }
      } catch (err) {
        Swal.close();
        $("#danger-alert")
          .fadeTo(2000, 500)
          .slideUp(500, function () {
            $("#danger-alert").slideUp(2000);
          });
      }
    }
  }


  // METODO PARA SUBIR VIDEOS
  UploadVideo() {
    //console.log("subiendo video...");
    var pattern = /\d+\.\d{2,}$/;
    if (
      !pattern.test($("#latitudV").val()) ||
      !pattern.test($("#longitudV").val())
    ) {
      $("#danger-alert")
        .fadeTo(2000, 500)
        .slideUp(500, function () {
          $("#danger-alert").slideUp(2000);
        });
    } else {
      try {
        const fecha = new Date($("#fechaVideo").val());
        if (isNaN(fecha.getTime())) {
          $("#danger-alert")
            .fadeTo(2000, 500)
            .slideUp(500, function () {
              $("#danger-alert").slideUp(2000);
            });
        } else {
          const year = fecha.getFullYear();
          const mes = ("0" + (fecha.getMonth() + 1)).slice(-2);
          const dia = ("0" + fecha.getDate()).slice(-2);
          const hora = ("0" + fecha.getHours()).slice(-2);
          const minuto = ("0" + fecha.getMinutes()).slice(-2);
          const segundos = "25";
          var fechacompleta =
            year +
            "_" +
            mes +
            "_" +
            dia +
            "_" +
            hora +
            "_" +
            minuto +
            "_" +
            segundos;

          const files = $("#videos").prop("files");
          const formData = new FormData();

          for (let i = 0; i < files.length; i++) {
            const newName =
              fechacompleta +
              "_" +
              i +
              "_" +
              this.state.device +
              "_" +
              this.state.placa +
              "_" +
              this.state.eventoseleccionado +
              "_" +
              Math.floor(Math.random() * 1000) +
              "_" +
              this.state.username +
              "_" +
              $("#latitudV").val() +
              "_" +
              $("#longitudV").val();
            if (files[i].type.startsWith("image/")) {
              formData.append("files", files[i], newName + ".jpg");
            } else if (files[i].type.startsWith("video/")) {
              formData.append("files", files[i], newName + ".mp4");
            }

            //formData.append('files', files[i]);
          }
          let timerInterval;
          Swal.fire({
            title: "Subiendo Video...",
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
            willClose: () => {
              clearInterval(timerInterval);
            }
          });

          fetch(process.env.REACT_APP_SERVER + "/uploadvideo", formData, {
            method: 'POST',
            headers: {
              "Content-Type": "multipart/form-data",
              // Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
          })
            .then((response) => {
              Swal.close();
              if (response.data.hasOwnProperty("success")) {
                $("#success-alert")
                  .fadeTo(2000, 500)
                  .slideUp(500, function () {
                    $("#success-alert").slideUp(2000);
                  });
                $("#ModalVideo .close").click();

                //history.go(0);
              } else {
                Swal.close();
                $("#danger-alert")
                  .fadeTo(2000, 500)
                  .slideUp(500, function () {
                    $("#danger-alert").slideUp(2000);
                  });
              }
            })
            .catch((error) => {
              Swal.close();
              console.error(error);
            });
        }
      } catch (err) {
        Swal.close();
        $("#danger-alert")
          .fadeTo(2000, 500)
          .slideUp(500, function () {
            $("#danger-alert").slideUp(2000);
          });
      }
    }
  }

  showModalOpenResporteServicio = async (data) => {
    let dataPermisos = {
      pagina: "14",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("BIt permisos tracking: ", res.data.data);
        if (res.data?.data?.length > 0) {
          this.setState(
            {
              bitOpenMonitoreo: res.data.data[0].bitOpen,
              bitInsertMonitoreo: res.data.data[0].bitInsert,
              bitEditMonitoreo: res.data.data[0].bitEdit,
              bitDeleteMonitoreo: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenMonitoreo) {
                console.warn("Tienes todos los permisos");
                //console.log("$$", data);
                //console.log(data.ContractID);
                this.setState({
                  dataGlobal: data,
                  contratoseleccionado: data.ContractID,
                  isDialogOpenRSeguimientoServicio: true,
                });
              } else {
                this.onCloseReporteServicio();
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta página",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }


  }

  /* Metodos para reporte consolidado ajustado 🎩*/



  /* Metodo para mostrar el contenido del dropdown */

  handleAllStatesDropdowns = () => {
    this.setState({
      dropdownOpenMultimedia: false,
      dropdownOpenReportes: false,
      dropdownOpenOpciones: false,
      dropdownOpenValitronics: false
    })

  }

  toggleDropdownMultimedia = () => {
    this.setState(prevState => ({
      dropdownOpenMultimedia: !prevState.dropdownOpenMultimedia
    }));
  };

  toggleDropdownReportes = () => {
    this.setState(prevState => ({
      dropdownOpenReportes: !prevState.dropdownOpenReportes
    }));
  }
  toggleDropdownOpciones = () => {
    this.setState(prevState => ({
      dropdownOpenOpciones: !prevState.dropdownOpenOpciones
    }));
  }
  toggleDropdownValitronics = () => {
    this.setState(prevState => ({
      dropdownOpenValitronics: !prevState.dropdownOpenValitronics
    }));
  }

  OpenGalleryPhoto(data) {
    this.OpenMultimediaHub(data, multimediaHubTabs.PHOTOS);
  }

  OpenComprobante(data) {
    this.setState({ contratoseleccionado: data.ContractID, isDialogOpenModalComprobanteValitronics: true });
    this.ListarComprobantes(data.ContractID);
  }

  OpenGalleryVideo(data) {
    this.OpenMultimediaHub(data, multimediaHubTabs.VIDEOS);
  }

  ActualizarContratoDevice = async (data) => {
    this.setState({ dataGlobal: data });
    let dataPermisos = {
      pagina: "17",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(dataPermisos),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("BIt permisos actualizar contrato: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState(
            {
              bitOpenUpdateContrato: res.data.data[0].bitOpen,
              bitInsertUpdateContrato: res.data.data[0].bitInsert,
              bitEditUpdateContrato: res.data.data[0].bitEdit,
              bitDeleteUpdateContrato: res.data.data[0].bitDelete,
            },
            () => {
              if (this.state.bitOpenUpdateContrato) {
                console.warn("Tienes todos los permisos");
                let send = {
                  Device: data.FKLokDeviceID,
                  Contrato: data.ContractID,
                };
                const json = JSON.stringify(send);
                axios
                  .post(
                    process.env.REACT_APP_SERVER + "/operaciones/setlastcontractdevice",
                    json,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                      },
                      withCredentials: true,
                    }
                  )
                  .then((res) => {
                    if (res.data.success) {
                      $("#success-alert")
                        .fadeTo(2000, 500)
                        .slideUp(500, function () {
                          $("#success-alert").slideUp(2000);
                        });
                    } else {
                      $("#danger-alert")
                        .fadeTo(2000, 500)
                        .slideUp(500, function () {
                          $("#danger-alert").slideUp(2000);
                        });
                    }
                  });
              } else {
                Swal.fire({
                  title: "Información",
                  text: "No tiene los permisos necesarios para acceder a esta opción",
                  icon: "info",
                  timer: 3000,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                }).then(() => {

                  console.error("No tienes permisos");
                });
              }
            }
          );
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }

  }

  handleCheckboxChange(sw, valor) {
    //console.log(sw + " - " + valor);
    localStorage.setItem(sw, valor);
  }

  sortData = (field) => {
    const { sortDirection } = this.state;
    const sortedData = [...this.state.filteredContratos].sort((a, b) => {
      if (
        field === "NombreEmpresa" ||
        field === "Ciudad" ||
        field === "FKLokDeviceID" ||
        field === "DescripcionRuta" ||
        field === "LastReportUbica" ||
        field === "PlacaTruck" ||
        field === "IconMoving" ||
        field === "IconLocked" ||
        field === "IconBack" ||
        field === "IconDesvio" ||
        field === "IconSeguro" ||
        field === "IconValitronics"
      ) {
        // Ordenar cadenas alfabéticamente (campo 'empresa')
        return (a[field] || "").localeCompare(b[field] || "");
      } else {
        return (a[field] || 0) - (b[field] || 0);
      }
    });

    // Cambia la dirección de orden si es necesario
    if (sortDirection === "desc") {
      sortedData.reverse();
    }

    this.setState({
      filteredContratos: sortedData,
      sortBy: field,
      sortDirection: sortDirection === "asc" ? "desc" : "asc",
    });
  };

  renderSortIcon(column) {
    const { sortBy, sortDirection } = this.state;

    if (sortBy === column) {
      if (sortDirection === "asc") {
        return <span>&uarr;</span>; // Icono de flecha hacia arriba
      } else {
        return <span>&darr;</span>; // Icono de flecha hacia abajo
      }
    }

    return null; // No mostrar ningún ícono si no está ordenado por esta columna
  }

  handleChangueCritico = async (newValue) => {
    const loadingTitle = newValue
      ? "Cargando contratos criticos"
      : "Cargando todos los contratos";

    Swal.fire({
      title: loadingTitle,
      text: "Estamos preparando la informacion.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    this.setState(
      {
        critico: newValue,
      },
      async () => {
        try {
          await new Promise((resolve) => window.requestAnimationFrame(resolve));
          await this.ListarContratos();
        } catch (error) {
          console.error("Error al cambiar filtro critico:", error);
          Swal.fire(
            "Error",
            "No se pudieron cargar los contratos del filtro seleccionado.",
            "error"
          );
          return;
        }

        Swal.close();
      }
    );
  }

  eliminar() {

    var elementos = document.getElementsByClassName("object-box");
    var elementosArray = Array.from(elementos);
    elementosArray.forEach(function (elemento) {
      elemento.parentNode.removeChild(elemento);
    });

  };

  // Función para abrir el modal
  openModal = () => {
    this.setState({ modalOpen: true });
    //console.log("Modal abierto");

  };

  // Función para cerrar el modal
  closeModal = () => {
    this.setState({ modalOpen: false });
    this.eliminar();
    this.setState(prevState => ({ ...prevState }));
  };

  OpenImages = async () => {
    this.OpenMultimediaHub(this.state.dataGlobal, multimediaHubTabs.PHOTOS);
  }

  OpenVideos = async () => {
    this.OpenMultimediaHub(this.state.dataGlobal, multimediaHubTabs.VIDEOS);
  }

  OpenStreaming = async () => {
    this.OpenMultimediaHub(this.state.dataGlobal, multimediaHubTabs.STREAMING);
  }

  OpenValitronics = async () => {
    // this.cerrarModal2();
    this.OpenComprobante(this.state.dataGlobal);
  }

  OpenListCheckModal = async () => {
    // this.cerrarModal2();
    this.OpenListCheck(this.state.dataGlobal);
  }

  OpenImages2 = async () => {
    this.setState({
      isDialogOpenRSeguimientoServicio: false,
    });
    this.OpenMultimediaHub(this.state.dataGlobal, multimediaHubTabs.PHOTOS);
  }

  OpenTracking2 = async () => {
    this.setState({
      isDialogOpenRSeguimientoServicio: false,
    });
    this.abrirModal2(this.state.dataGlobal);
    $("#ModalReporteSegimiento").modal("show");
  }

  OpenTracking = async () => {

    //console.log("Entre");
    //console.log("Data global", this.state.dataGlobal);
    const modalElement = document.getElementById("ModalGaleria");
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement); // Get the Bootstrap modal instance
      if (modalInstance) {
        modalInstance.hide(); // Close the Bootstrap modal
      }
    }
    this.abrirModal2(this.state.dataGlobal);
    $("#ModalReporteSegimiento").modal("show");
  }

  OpenMonitoreo = async () => {
    // this.cerrarModal2();
    this.showModalOpenResporteServicio(this.state.dataGlobal);
  }

  showModalTrayecto = async () => {
    this.EditContrato(this.state.dataGlobal);
  }

  OpenReporteConsolidado = async () => {
    // this.cerrarModal2();
    this.OpenModalReporteServicio(this.state.dataGlobal);
  }

  OpenReporteConsolidado2 = async () => {
    // const modalElement = document.getElementById("ModalGaleria");
    // if (modalElement) {
    //   const modalInstance = bootstrap.Modal.getInstance(modalElement); // Get the Bootstrap modal instance
    //   if (modalInstance) {
    //     modalInstance.hide(); // Close the Bootstrap modal
    //   }
    // }
    this.OpenModalReporteServicio(this.state.dataGlobal);
  }


  OpenMonitoreo2 = async () => {
    const modalElement = document.getElementById("ModalGaleria");
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement); // Get the Bootstrap modal instance
      if (modalInstance) {
        modalInstance.hide(); // Close the Bootstrap modal
      }
    }
    this.showModalOpenResporteServicio(this.state.dataGlobal);
  }
  //METODO HANDLE PRINT 



  // Función para pausar los videos cuando se cierra el modal
  handleModalClose = () => {
    // Aquí puedes pausar los videos
    //console.log('Modal cerrado, pausar los videos aquí');
    this.setState({ onHide: true });

  };

  //LISTAR CONTRATOS CONTROLES DE TRAFICO 
  listarcontrolesColores = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVER}/contratos/getcontrolestrafico`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tkn")}`,
        },
        withCredentials: true,
      });

      if (res.data.success === false) {
        window.location = "/";
      } else {
        //console.log("listControlesColores: ", res.data.data);
        this.setState({ listControlesColores: res.data.data });
      }
    } catch (error) {
      console.error("Error al listar los controles de colores:", error);
    }
  };



  // Nueva función para ordenar por criterios
  sortByCriteria = (contratos, criteria) => {
    //console.log("Criteria", criteria);
    if (!criteria || criteria.length === 0) return contratos;

    return [...contratos].sort((a, b) => {
      for (const { field, direction } of criteria) {

        // Si el campo es un campo numérico (tiempodetencion o LoksysServerTime), realizamos la comparación numérica
        const isNumericField = field === 'tiempodetencion' || field === 'LoksysServerTime';

        if (isNumericField) {
          const valA = field === 'LoksysServerTime' ? new Date(a[field]).getTime() : Number(a[field]);
          const valB = field === 'LoksysServerTime' ? new Date(b[field]).getTime() : Number(b[field]);

          if (valA !== valB) {
            return (valA - valB) * (direction === 'asc' ? 1 : -1);
          }
        } else if (field === 'LoksysServerTime') {
          // Si el campo es una fecha, comparamos como objetos Date
          const dateA = new Date(a[field]);
          const dateB = new Date(b[field]);

          if (dateA.getTime() !== dateB.getTime()) {
            return (dateA - dateB) * (direction === 'asc' ? 1 : -1);
          }
        } else {
          // Lógica para ordenar los íconos de batería
          let imageIdMap = {
            'images/batt-full.png': 5,
            'images/batt-med1.png': 4,
            'images/batt-med2.png': 3,
            'images/batt-low.png': 2,
            'images/batt-charge.png': 1,
          };

          // Lógica para ordenar los íconos de candado
          let imageClosedPad = {
            '/images/closedpadlock.png': 3,
            '/images/candado.png': 2,
            '/images/openedpadlockalerta.gif': 1,
          };

          if (field === 'IconLocked') {
            //console.log("IconLocked", a.IconLocked);
            const indexA = imageClosedPad[a.IconLocked] || Number.MAX_SAFE_INTEGER;
            const indexB = imageClosedPad[b.IconLocked] || Number.MAX_SAFE_INTEGER;

            //console.log(`a.IconLocked: ${a.IconLocked}, b.IconLocked: ${b.IconLocked}`);

            //console.log(`Comparando IconLocked: ${indexA} con ${indexB}`);

            if (indexA !== indexB) {
              return (indexA - indexB) * (direction === 'asc' ? 1 : -1);
            }
          } else if (field === 'icon_bat') {
            const indexA = imageIdMap[a.icon_bat] || Number.MAX_SAFE_INTEGER;
            const indexB = imageIdMap[b.icon_bat] || Number.MAX_SAFE_INTEGER;

            if (indexA !== indexB) {
              return (indexA - indexB) * (direction === 'asc' ? 1 : -1);
            }
          } else {
            // Para otros campos (alfabéticos o valores), mantenemos la comparación alfabética
            const dirMultiplier = direction === 'asc' ? 1 : -1;
            if (a[field] < b[field]) return -1 * dirMultiplier;
            if (a[field] > b[field]) return 1 * dirMultiplier;
          }
        }
      }
      return 0; // Si todos los criterios son iguales, no cambia el orden
    });
  };





  updateContratos = (newContratos) => {
    const contratosRecibidos = Array.isArray(newContratos) ? newContratos : [];
    this.desktopWindowsRef.current?.updateContracts(contratosRecibidos);
    //console.log("Contratos actualizados", newContratos);
    // Recuperar el valor de búsqueda del localStorage
    const searchValue = sessionStorage.getItem(TRAFICO_SEARCH_STORAGE_KEY) || "";
    if (this.state.searchValue !== searchValue) {
      this.setState({ searchValue });
    }

    const visibleContratos = this.applyCriticalContractsFilter(contratosRecibidos);

    // Filtrar los nuevos contratos
    const filteredContratos = this.filterContratos(visibleContratos, searchValue);
    const updatedContratos = filteredContratos;


    //console.log("estos son los filtros desde localStorage:", this.state.arrayFilters);
    let storedFilters = { filters: [] };
    try {
      const parsedFilters = sessionStorage.getItem(TRAFICO_FILTERS_STORAGE_KEY)
        ? JSON.parse(sessionStorage.getItem(TRAFICO_FILTERS_STORAGE_KEY))
        : null;
      if (Array.isArray(parsedFilters?.filters)) {
        storedFilters = parsedFilters;
      }
    } catch (error) {
      console.warn("No se pudieron leer los filtros guardados de Tráfico:", error);
    }
    //console.log(storedFilters);
    if (storedFilters.filters.length > 0) {
      let contratosFiltrados = filteredContratos;
      storedFilters.filters.forEach(filter => {
        const key = Object.keys(filter)[0];
        //console.log(key);
        const value = filter[key];

        switch (key) {
          case 'filterEmpresa':
            contratosFiltrados = contratosFiltrados.filter(contrato =>
              matchesCompanyFilter(contrato, value)
            );
            //console.log(contratosFiltrados);
            break;
          case 'filterEstado':
            contratosFiltrados = contratosFiltrados.filter(contrato =>
              value.includes(contrato.TipoReporte)
            );
            break;
          case 'filterRuta':
            contratosFiltrados = contratosFiltrados.filter(contrato =>
              value.includes(contrato.DescripcionRuta)
            );
            break;
          case 'filterCiudadOrigen':
            contratosFiltrados = contratosFiltrados.filter((contrato) =>
              value.includes(contrato.CiudadOrigen)
            );
            break;
          case 'filterCiudadDestino':
            contratosFiltrados = contratosFiltrados.filter((contrato) =>
              value.includes(contrato.CiudadDestino)
            );
            break;
          case 'filterDispositivo':
            contratosFiltrados = contratosFiltrados.filter(contrato =>
              value.includes(contrato.FKLokDeviceID)
            );
            break;
          case 'filterAlerta':
            contratosFiltrados = contratosFiltrados.filter(contrato => {
              const alertIcons = [
                contrato.IconMoving,
                contrato.IconBack,
                contrato.icon_bat,
                contrato.IconDesvio,
                contrato.IconLocked,
                contrato.IconSeguro,
                contrato.IconValitronics
              ];

              // Filtrar por íconos de alerta
              const iconResult = alertIcons.some(icon => {
                // Extraer el nombre del archivo sin la extensión
                const iconName = String(icon || "").split("/").pop().replace(/\.(png|gif)$/, "");  // RegExp para manejar .png o .gif
                return value?.alertas?.includes(iconName) && iconName !== "transparent";
              });

              // Filtrar por `tiempoUltReporte`
              let tiempoUltReporteResult = false;
              if (value.tiempoUltReporte) {

                const diferenciaEnMinutos = getMinutesSinceLastReport(contrato.LoksysServerTime);
                const valorNumerico = parseInt(value.tiempoUltReporte, 10);
                //console.log("diferecnia en minutos", diferenciaEnMinutos);
                //console.log("valor de tiempo ultimo reporte", valorNumerico);
                tiempoUltReporteResult = diferenciaEnMinutos >= valorNumerico;
              }

              // Filtrar por `tiempoDetencion`
              let tiempoDetencionResult = false;
              if (value.tiempoDetencion) {
                const tiempoDetencionNumerico = parseInt(contrato.tiempodetencion || 0, 10);
                const valorDetencionNumerico = parseInt(value.tiempoDetencion, 10);
                tiempoDetencionResult = tiempoDetencionNumerico >= valorDetencionNumerico;
              }

              let nogpsResult = false;
              if (value.alertas && value.alertas.includes("nogps")) {
                //console.log("entro a no gps");
                nogpsResult = contrato.bitGPS === true;
              }

              let noTrayectoResult = false;
              if (value.alertas && value.alertas.includes("trayectonull")) {
                //console.log("entro a no trayecto");
                noTrayectoResult = contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9;
              }

              //console.log("Resultado del filtro por íconos:", iconResult);
              //console.log("Resultado del filtro por tiempo último reporte:", tiempoUltReporteResult);
              //console.log("Resultado del filtro por tiempo de detención:", tiempoDetencionResult);
              //console.log("Resultado del filtro por no gps:", nogpsResult);

              // Retorna `true` si alguno de los filtros coincide (operador OR)
              return iconResult || tiempoUltReporteResult || tiempoDetencionResult || nogpsResult || noTrayectoResult;
            });
            break;
          case 'orderByCriteria': // Ordenar los contratos
            contratosFiltrados = this.sortByCriteria(contratosFiltrados, value);
            break;
          default:
            break;
        }
      });
      let countOpenChain = 0;
      let countLowBattery = 0;
      let countMoving = 0;
      let countStop = 0;
      let countStopAlert = 0;
      let countDesvio = 0;
      let countNoGps = 0;
      let countNoRuta = 0;
      let timeExchangeContractCount = 0;
      let countRefuerzo = 0;
      let countStreaming = 0;

      try {
        countOpenChain = contratosFiltrados.filter(
          (c) =>
            (c?.IconLocked || "").includes("candado") ||
            (c?.IconLocked || "").includes("openedpadlockalerta")
        ).length;

        countLowBattery = contratosFiltrados.filter((c) =>
          (c?.icon_bat || "").includes("batt-low")
        ).length;

        countMoving = contratosFiltrados.filter((c) =>
          (c?.IconMoving || "").includes("moving")
        ).length;

        countStop = contratosFiltrados.filter((c) =>
          (c?.IconMoving || "").includes("stop")
        ).length;

        countStopAlert = contratosFiltrados.filter((c) =>
          (c?.IconMoving || "").includes("stopAlert")
        ).length;

        countDesvio = contratosFiltrados.filter((c) =>
          (c?.IconDesvio || "").includes("desvioalerta")
        ).length;

        countNoGps = contratosFiltrados.filter((c) => c?.bitGPS === true).length;

        countNoRuta = contratosFiltrados.filter(
          (c) => c?.DescripcionTrayecto === null && c?.FKLokTipoEquipo === 9
        ).length;
        countStreaming = contratosFiltrados.filter((c) => this.isStreamingOn(c)).length;

        timeExchangeContractCount = contratosFiltrados.filter((c) =>
          hasLegacyTimeExchange(c?.LoksysServerTime)
        ).length;

        countRefuerzo = contratosFiltrados.filter((data) => {
          const anexos = (this.state.filteredContratos || []).filter(
            (anexo) =>
              (anexo?.PlacaTruck || "") !== "" &&
              (data?.PlacaTruck || "") !== "" &&
              anexo.PlacaTruck === data.PlacaTruck &&
              anexo.ContainerNum === data.ContainerNum &&
              anexo.ContractID !== data.ContractID
          );
          return anexos.length > 0;
        }).length;
      } catch (error) {
        console.error("Error al contar los contratos filtrados:", error);
        console.log("contratosFiltrados:", contratosFiltrados);
      }

      this.setState({
        openCount: countOpenChain,
        lowBatteryCount: countLowBattery,
        filteredContratos: contratosFiltrados,
        countContrats: contratosFiltrados.length,
        timeExchange: timeExchangeContractCount,
        movingCount: countMoving,
        refuerzoCount: countRefuerzo,
        stopCount: countStop,
        stopAlertCount: countStopAlert,
        desvioCount: countDesvio,
        noGpsCount: countNoGps,
        noRutaCount: countNoRuta,
        streamingCount: countStreaming,
        unsecuredCount: contratosFiltrados.filter((contrato) => isUnsecuredContrato(contrato)).length,
      });

    } else {
      // ✅ Declara afuera para poder usarlas después
      let countOpenChain = 0;
      let countLowBattery = 0;
      let countMoving = 0;
      let countStop = 0;
      let countStopAlert = 0;
      let countDesvio = 0;
      let countNoGps = 0;
      let countNoRuta = 0;
      let timeExchangeContractCount = 0;
      let countRefuerzo = 0;
      let countStreaming = 0;

      try {
        countOpenChain = updatedContratos.filter(
          (c) =>
            (c?.IconLocked || "").includes("candado") ||
            (c?.IconLocked || "").includes("openedpadlockalerta")
        ).length;

        countLowBattery = updatedContratos.filter((c) =>
          (c?.icon_bat || "").includes("batt-low")
        ).length;

        countMoving = updatedContratos.filter((c) =>
          (c?.IconMoving || "").includes("moving")
        ).length;

        countStop = updatedContratos.filter((c) =>
          (c?.IconMoving || "").includes("stop")
        ).length;

        countStopAlert = updatedContratos.filter((c) =>
          (c?.IconMoving || "").includes("stopAlert")
        ).length;

        countDesvio = updatedContratos.filter((c) =>
          (c?.IconDesvio || "").includes("desvioalerta")
        ).length;

        countNoGps = updatedContratos.filter((c) => c?.bitGPS === true).length;

        countNoRuta = updatedContratos.filter(
          (c) => c?.DescripcionTrayecto === null && c?.FKLokTipoEquipo === 9
        ).length;
        countStreaming = updatedContratos.filter((c) => this.isStreamingOn(c)).length;

        timeExchangeContractCount = updatedContratos.filter((c) =>
          hasLegacyTimeExchange(c?.LoksysServerTime)
        ).length;

        countRefuerzo = updatedContratos.filter((data) => {
          const anexos = (this.state.filteredContratos || []).filter(
            (anexo) =>
              (anexo?.PlacaTruck || "") !== "" &&
              (data?.PlacaTruck || "") !== "" &&
              anexo.PlacaTruck === data.PlacaTruck &&
              anexo.ContainerNum === data.ContainerNum &&
              anexo.ContractID !== data.ContractID
          );
          return anexos.length > 0;
        }).length;
      } catch (error) {
        console.error("Error al contar los contratos filtrados:", error);
        console.log("contratosFiltrados:", filteredContratos);
      }

      // ✅ Ya existen sí o sí
      this.setState({
        openCount: countOpenChain,
        lowBatteryCount: countLowBattery,
        filteredContratos: filteredContratos,
        countContrats: filteredContratos.length,
        timeExchange: timeExchangeContractCount,
        movingCount: countMoving,
        refuerzoCount: countRefuerzo,
        stopCount: countStop,
        stopAlertCount: countStopAlert,
        desvioCount: countDesvio,
        noGpsCount: countNoGps,
        noRutaCount: countNoRuta,
        streamingCount: countStreaming,
        unsecuredCount: updatedContratos.filter((contrato) => isUnsecuredContrato(contrato)).length,
      });

      //console.log(this.state.filteredContratos);

    }

  };

  handleNewValueSavedFilter = (newFilters) => {
    this.setState({
      savedFilters: newFilters,
    });
  }

  updateDifferTime = (newDifferTime) => {
    //console.log("Differ Time actualizado", newDifferTime);
    this.setState({
      differTime: newDifferTime,
    });
  }

  // handleFilterButtons = (value) => {
  //   const localStorageFilters = localStorage.getItem("arrayFilters")
  //     ? JSON.parse(localStorage.getItem("arrayFilters"))
  //     : { filters: [] };

  //   const { listContratos } = this.state;
  //   let contratosFiltrados = [...listContratos];
  //   let newFilters = [...localStorageFilters.filters];
  //   let countContratosActualizado = this.state.countContrats; // Mantener el contador de contratos total

  //   // Función para filtrar los contratos por un ítem específico
  //   const filterByCondition = (filterName, conditionFn) => {
  //     const filtered = contratosFiltrados.filter(conditionFn);
  //     return filtered;
  //   };

  //   // Función para actualizar el estado según el filtro
  //   const updateFilterState = (filterName, filteredData, activeStateKey) => {
  //     // Sumamos el valor actual de contratos con el valor filtrado
  //     countContratosActualizado += filteredData.length;

  //     // Actualizamos el estado con el nuevo valor acumulado
  //     this.setState({
  //       newValueFilterButton: filterName,
  //       // countContrats: countContratosActualizado,  // Actualiza el total de contratos filtrados
  //       // filteredContratos: filteredData,  // Establece los contratos filtrados
  //       [activeStateKey]: true,  // Marca el filtro como activo
  //     }, () => {
  //       this.updateContratos(filteredData);
  //     });
  //   };

  //   // Función para eliminar el filtro y restaurar el contador previo
  //   const removeFilter = (filterName, activeStateKey) => {
  //     // Filtramos los filtros existentes eliminando el filtro que se desea quitar
  //     newFilters = newFilters.filter((filter) => filter.filterButton !== filterName);

  //     // Calculamos cuántos contratos fueron eliminados por este filtro
  //     const filteredOutContracts = this.state.filteredContratos.filter(contrato => contrato.filterCondition === filterName);

  //     // Restauramos el contador, restando los contratos eliminados
  //     const countContratosRestaurado = countContratosActualizado - filteredOutContracts.length;

  //     this.setState(
  //       {
  //         deleteValueFilterButton: filterName,
  //         [activeStateKey]: false,  // Marca el filtro como no activo
  //         countContrats: countContratosRestaurado,  // Restauramos el contador
  //       },
  //       () => {
  //         // Aplicamos los filtros restantes
  //         this.applyFilters({ filters: newFilters });
  //       }
  //     );
  //   };

  //   // Mapeo de los filtros
  //   const filtersMapping = {
  //     moving: () => {
  //       if (!this.state.isMovingActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.IconMoving.includes('moving')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isMovingActive");
  //       } else {
  //         removeFilter(value, "isMovingActive");
  //       }
  //     },
  //     stop: () => {
  //       if (!this.state.isStopActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.IconMoving.includes('stop')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isStopActive");
  //       } else {
  //         removeFilter(value, "isStopActive");
  //       }
  //     },
  //     stopAlert: () => {
  //       if (!this.state.isStopAlertActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.IconMoving.includes('stopAlert')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isStopAlertActive");
  //       } else {
  //         removeFilter(value, "isStopAlertActive");
  //       }
  //     },
  //     desvioalerta: () => {
  //       if (!this.state.isDesvioAlertActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.IconDesvio.includes('desvioalerta')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isDesvioAlertActive");
  //       } else {
  //         removeFilter(value, "isDesvioAlertActive");
  //       }
  //     },
  //     'batt-low': () => {
  //       if (!this.state.isLowBatteryActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.icon_bat.includes('batt-low')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isLowBatteryActive");
  //       } else {
  //         removeFilter(value, "isLowBatteryActive");
  //       }
  //     },
  //     candado: () => {
  //       if (!this.state.isOpenActive) {
  //         const filtered = filterByCondition(value, (contrato) =>
  //           contrato.IconLocked.includes('candado')
  //         );
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isOpenActive");
  //       } else {
  //         removeFilter(value, "isOpenActive");
  //       }
  //     },
  //     tiempo: () => {
  //       if (!this.state.isTimeExchangeActive) {
  //         const thirtyMinutesInMs = 30 * 60 * 1000;
  //         const filtered = contratosFiltrados.filter((contrato) => {
  //           const loksysServerTime = new Date(contrato.LoksysServerTime);
  //           const currentTime = new Date();
  //           currentTime.setHours(currentTime.getHours() - 5);
  //           return currentTime - loksysServerTime >= thirtyMinutesInMs;
  //         });
  //         newFilters.push({ filterButton: value });
  //         updateFilterState(value, filtered, "isTimeExchangeActive");
  //       } else {
  //         removeFilter(value, "isTimeExchangeActive");
  //       }
  //     },
  //   };

  //   // Llamada al filtro correspondiente
  //   if (filtersMapping[value]) {
  //     filtersMapping[value]();
  //   }

  //   // Guardar los filtros en el localStorage
  //   localStorage.setItem("arrayFilters", JSON.stringify({ filters: newFilters }));
  // };



  handleFilterButtons2 = (value) => {
    //console.log("Valor de filtro", value);
    if (value) {
      if (value === 'moving') {
        this.setState({
          isMovingActive: !this.state.isMovingActive,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'stop') {
        this.setState({
          isStopActive: !this.state.isStopActive,
          isMovingActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'stopAlert') {
        this.setState({
          isStopAlertActive: !this.state.isStopAlertActive,
          isMovingActive: false,
          isStopActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'desvioalerta') {
        this.setState({
          isDesvioAlertActive: !this.state.isDesvioAlertActive,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'batt-low') {
        this.setState({
          isLowBatteryActive: !this.state.isLowBatteryActive,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isOpenActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'candado') {
        this.setState({
          isOpenActive: !this.state.isOpenActive,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isTimeExchangeActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === 'tiempo') {
        this.setState({
          isTimeExchangeActive: !this.state.isTimeExchangeActive,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false
        });
      } else if (value === 'refuerzo') {
        this.setState({
          isTimeExchangeActive: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: !this.state.isRefuerzoActive,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,

        });
      } else if (value === 'noGps') {
        this.setState({
          isTimeExchangeActive: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: !this.state.isNoGpsActive,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === "noTrayecto") {
        //console.log("ENtradno a contador de trayectos ");
        this.setState({
          isTimeExchangeActive: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: !this.state.isNoRutaActive,
          isStreamingActive: false,
          isUnsecuredActive: false,
        });
      } else if (value === "streaming") {
        this.setState({
          isTimeExchangeActive: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: !this.state.isStreamingActive,
          isUnsecuredActive: false,
        });
      } else if (value === "unsecured") {
        this.setState({
          isTimeExchangeActive: false,
          isMovingActive: false,
          isStopActive: false,
          isStopAlertActive: false,
          isDesvioAlertActive: false,
          isLowBatteryActive: false,
          isOpenActive: false,
          isRefuerzoActive: false,
          isNoGpsActive: false,
          isNoRutaActive: false,
          isStreamingActive: false,
          isUnsecuredActive: !this.state.isUnsecuredActive,
        });
      }
    }

  }


  toggleResponsiveMoreInfo = (index) => {
    this.setState((prevState) => ({
      responsiveMoreInfo: prevState.responsiveMoreInfo === index ? null : index,
    }));
  };

  renderResponsiveMenu = (contrato) => (
    <div
      className="trafico-responsive-menu"
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
    >
    <MenuContratos
      contratoId={contrato.ContractID}
      data={contrato}
      handleAllStatesDropdowns={this.handleAllStatesDropdowns}
      abrirModal2={this.abrirModal2}
      abrirModalEnVivo={this.abrirModalEnVivo}
      showModalOpenResporteServicio={this.showModalOpenResporteServicio}
      toggleDropdownReportes={() => this.toggleDropdownReportes()}
      dropdownOpenReportes={this.state.dropdownOpenReportes}
      OpenReporteServicio={this.OpenReporteServicio}
      abrirModal={this.abrirModal}
      toggleDropdownMultimedia={() => this.toggleDropdownMultimedia()}
      dropdownOpenMultimedia={this.state.dropdownOpenMultimedia}
      OpenGalleryPhoto={this.OpenGalleryPhoto}
      OpenGalleryVideo={this.OpenGalleryVideo}
      OpenUploadPhoto={this.OpenUploadPhoto}
      OpenUploadVideo={this.OpenUploadVideo}
      OpenMultimediaHub={this.OpenMultimediaHub}
      toggleDropdownValitronics={() => this.toggleDropdownValitronics()}
      dropdownOpenValitronics={this.state.dropdownOpenValitronics}
      OpenComprobante={this.OpenComprobante}
      OpenListCheck={() => this.OpenListCheck(contrato)}
      toggleDropdownOpciones={() => this.toggleDropdownOpciones()}
      dropdownOpenOpciones={this.state.dropdownOpenOpciones}
      showEditContract={() => this.showEditContract(contrato)}
      EditContrato={() => this.EditContrato(contrato)}
      ActualizarContratoDevice={this.ActualizarContratoDevice}
    />
    </div>
  );

  renderResponsiveStatusIcons = (contrato) => (
    <div className="trafico-status-icons">
      {showBateria && <img src={contrato.icon_bat} width="22" height="25" alt="Batería" />}
      {showMoving && <img src={contrato.IconMoving} width="25" height="25" alt="Movimiento" />}
      {showLocked && <img src={contrato.IconLocked} width="25" height="25" alt="Seguro" />}
      {showBack && <img src={contrato.IconBack} width="25" height="25" alt="Retorno" />}
      {showDesvio && <img src={contrato.IconDesvio} width="25" height="25" alt="Desvío" />}
      {showSeguro && <img src={contrato.IconSeguro} width="25" height="25" alt="Seguro" />}
      {showValitronics && <img src={contrato.IconValitronics} width="25" height="25" alt="Valitronics" />}
      {contrato.DescripcionTrayecto === null && (
        <img src="/images/trayectonull.png" width="25" height="25" alt="Sin georuta" />
      )}
    </div>
  );

  getResponsiveTrafficStatus = (contrato) => {
    const movingIcon = String(contrato?.IconMoving || '').toLowerCase();
    const isStopped = movingIcon.includes('stop');
    const isMoving = movingIcon.includes('moving') && !isStopped;

    return {
      label: isMoving ? 'En tránsito' : isStopped ? 'Detenido' : (contrato?.TipoReporte || 'Sin estado'),
      className: isStopped ? 'is-stopped' : isMoving ? 'is-moving' : 'is-neutral',
    };
  };

  getResponsiveAlertTotal = () => [
    this.state.NoRutaCount,
    this.state.refuerzoCount,
    this.state.movingCount,
    this.state.stopCount,
    this.state.stopAlertCount,
    this.state.desvioCount,
    this.state.lowBatteryCount,
    this.state.openCount,
    this.state.unsecuredCount,
    this.state.timeExchange,
    this.state.streamingCount,
    this.state.NoGpsCount,
  ].reduce((total, count) => total + (Number(count) || 0), 0);

  toggleResponsiveAlerts = () => {
    this.setState((prevState) => ({
      responsiveAlertsExpanded: !prevState.responsiveAlertsExpanded,
    }));
  };

  handleResponsiveAlertKeyDown = (event, value) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleFilterButtons2(value);
    }
  };

  getResponsiveFilteredContracts = () => {
    const contratos = this.state.filteredContratos || [];
    const {
      isMovingActive,
      isStopActive,
      isStopAlertActive,
      isDesvioAlertActive,
      isLowBatteryActive,
      isOpenActive,
      isTimeExchangeActive,
      isRefuerzoActive,
      isNoGpsActive,
      isNoRutaActive,
      isStreamingActive,
      isUnsecuredActive,
    } = this.state;

    if (isMovingActive) {
      return contratos.filter((contrato) => String(contrato.IconMoving || '').includes('moving'));
    }
    if (isStopActive) {
      return contratos.filter((contrato) => String(contrato.IconMoving || '').includes('stop'));
    }
    if (isStopAlertActive) {
      return contratos.filter((contrato) => String(contrato.IconMoving || '').includes('stopAlert'));
    }
    if (isDesvioAlertActive) {
      return contratos.filter((contrato) => String(contrato.IconDesvio || '').includes('desvioalerta'));
    }
    if (isLowBatteryActive) {
      return contratos.filter((contrato) => String(contrato.icon_bat || '').includes('batt-low'));
    }
    if (isOpenActive) {
      return contratos.filter((contrato) => {
        const iconLocked = String(contrato.IconLocked || '');
        return iconLocked.includes('candado') || iconLocked.includes('openedpadlockalerta');
      });
    }
    if (isTimeExchangeActive) {
      return contratos.filter((contrato) => hasLegacyTimeExchange(contrato.LoksysServerTime));
    }
    if (isNoGpsActive) {
      return contratos.filter((contrato) => contrato.bitGPS === true);
    }
    if (isNoRutaActive) {
      return contratos.filter(
        (contrato) => contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
      );
    }
    if (isStreamingActive) {
      return contratos.filter((contrato) => this.isStreamingOn(contrato));
    }
    if (isUnsecuredActive) {
      return contratos.filter((contrato) => isUnsecuredContrato(contrato));
    }
    if (isRefuerzoActive) {
      return contratos.filter((contrato) => contratos.some(
        (anexo) =>
          anexo.PlacaTruck &&
          contrato.PlacaTruck &&
          anexo.PlacaTruck === contrato.PlacaTruck &&
          anexo.ContainerNum === contrato.ContainerNum &&
          anexo.ContractID !== contrato.ContractID
      ));
    }

    return contratos;
  };

  renderResponsiveTraffic = () => {
    if (this.state.isTrafficLoading) {
      return (
        <div className="card cardContainerTrafico2 trafico-responsive-view trafico-responsive-loading" role="status" aria-live="polite">
          <PreloaderHistorico />
        </div>
      );
    }

    const contratos = this.getResponsiveFilteredContracts();

    const renderTabletRow = (contrato, index) => (
      <div className="trafico-tablet-row" key={`tablet-${contrato.ContractID ?? index}`}>
        <div className="trafico-tablet-company">
          {showEmpresa && <strong>{contrato.NombreEmpresa}</strong>}
          {showDispositivo && <span>{contrato.FKLokDeviceID}</span>}
        </div>
        {showPlaca && <div className="trafico-tablet-cell">{contrato.PlacaTruck}</div>}
        {showRuta && <div className="trafico-tablet-cell">{contrato.DescripcionRuta}</div>}
        {showEstado && <div className="trafico-tablet-cell">{contrato.TipoReporte}</div>}
        {showTiempo && <div className="trafico-tablet-cell">{contrato.Tiempo}</div>}
        <div className="trafico-tablet-actions" onClick={(event) => event.stopPropagation()}>
          {this.renderResponsiveMenu(contrato)}
        </div>
      </div>
    );

    const renderMobileCard = (contrato, index) => (
      <article
        key={`mobile-${contrato.ContractID ?? index}`}
        className="trafico-mobile-card"
        onClick={() => this.toggleResponsiveMoreInfo(index)}
      >
        <div className="trafico-mobile-card-header">
          <div className="trafico-mobile-company">
            {showEmpresa && <strong>{contrato.NombreEmpresa}</strong>}
            {showDispositivo && <span>{contrato.FKLokDeviceID}</span>}
          </div>
          <div onClick={(event) => event.stopPropagation()}>{this.renderResponsiveMenu(contrato)}</div>
        </div>
        <div className="trafico-mobile-meta">
          {showPlaca && <span>{contrato.PlacaTruck}</span>}
          {showRuta && <span>{contrato.DescripcionRuta}</span>}
        </div>
        {showUbicacionGps && contrato.Ciudad && (
          <p className="trafico-mobile-line"><i className="bx bx-map" aria-hidden="true" />{contrato.Ciudad}</p>
        )}
        {showUbicacionTrafico && contrato.LastReportUbica && (
          <p className="trafico-mobile-line"><i className="bx bx-map-pin" aria-hidden="true" />{contrato.LastReportUbica}</p>
        )}
        {showUbicacionTrafico && contrato.LastReportNota && (
          <div className="trafico-mobile-observation">
            <div className="trafico-mobile-observation-label">
              <i className="bx bx-comment-detail" aria-hidden="true" />
              <strong>Observaciones:</strong>
            </div>
            <div className="trafico-mobile-observation-value">{contrato.LastReportNota}</div>
          </div>
        )}
        <div className="trafico-mobile-state-row">
          {showEstado && (() => {
            const status = this.getResponsiveTrafficStatus(contrato);
            return <span className={`trafico-mobile-status ${status.className}`}>{status.label}</span>;
          })()}
          {showTiempo && <span>{contrato.Tiempo}</span>}
        </div>
        {this.renderResponsiveStatusIcons(contrato)}
        {(this.state.collapsableResponsive || this.state.responsiveMoreInfo === index) && (
          <div className="trafico-mobile-details">
            <p><b>Contrato:</b> {contrato.ContractID}</p>
            <p><b>Contenedor:</b> {contrato.ContainerNum}</p>
            <p><b>Trayecto:</b> {contrato.DescripcionTrayecto}</p>
            <p><b>Último contacto:</b> {contrato.LoksysServerTime}</p>
          </div>
        )}
      </article>
    );

    return (
      <>
        <div className="card cardContainerTrafico2 trafico-responsive-view">
          <div className="trafico-tablet-list">
            <div className="trafico-tablet-header">
              <span>EMPRESA / DISPOSITIVO</span>
              {showPlaca && <span>PLACA</span>}
              {showRuta && <span>RUTA</span>}
              {showEstado && <span>ESTADO</span>}
              {showTiempo && <span>TIEMPO</span>}
              <span aria-label="Acciones" />
            </div>
            {contratos.map(renderTabletRow)}
          </div>
          <div className="trafico-mobile-list">{contratos.map(renderMobileCard)}</div>
        </div>
      </>
    );
  };

  render() {
    const showLiveInline = this.state.offcanvasActive;
    const trafficGridHeight = this.state.trafficGridHeight;
    const isMobileView = this.state.isMobileView;
    const displayLiveStreams = this.getLiveStreamsForDisplay();
    const isDeviceActionLoading = this.state.deviceActionLoading;
    return (

      <>
        <div className={`layout-wrapper layout-content-navbar trafico-page ${isDeviceActionLoading ? "is-device-action-loading" : ""}`}>
          <div className="layout-container">
            <div className="layout-page">
              <BarraTrafico
                onToggleNavigation={this.toggleNavigationMenu}
                onRegisterMock={this.registerMockTrigger}
                count={this.state.filteredContratos.length}
                filteredSolicitudes={this.state.filteredContratos}
                onUpdateSolicitudes={this.updateContratos}
                ListarContratos={this.ListarContratos}
                differTime={this.updateDifferTime}
                onOpenLive={this.handleOpenLive}
                onLiveNow={this.handleLiveNow}
                onLiveEnded={this.handleLiveEnded}
                enableContractSocket={this.props.enableContractSocket !== false}
              />
              <Toaster position="bottom-right" />
              <TraficoDesktopWindows
                ref={this.desktopWindowsRef}
                filteredContratos={this.state.filteredContratos}
                counts={{
                  movingCount: this.state.movingCount,
                  stopCount: this.state.stopCount,
                  noGpsCount: this.state.NoGpsCount,
                  streamingCount: this.state.streamingCount,
                }}
                onShortcut={this.handleDesktopWindowShortcut}
                onLauncherVisibilityChange={this.handleDesktopWindowLauncherVisibilityChange}
                onWindowLimitReached={this.handleDesktopWindowLimitReached}
                onOpenContractInModal={this.openContractInModalFromDesktop}
                renderContract={(contract, close) => (
                  <ReporteContrato
                    isOpen={true}
                    onClose={close}
                    contratoVar={contract}
                    isMultiventana={true}
                    aleatorio={Number(contract?.ContractID) || Math.floor(Math.random() * 1000) + 1}
                    images={() => this.OpenMultimediaHub(contract, multimediaHubTabs.PHOTOS)}
                    videos={() => this.OpenMultimediaHub(contract, multimediaHubTabs.VIDEOS)}
                    streaming={() => this.OpenMultimediaHub(contract, multimediaHubTabs.STREAMING)}
                    valitronics={() => this.OpenComprobante(contract)}
                    checkList={() => this.OpenListCheck(contract)}
                    monitoreo={() => this.showModalOpenResporteServicio(contract)}
                    trayecto={() => this.showModalTrayecto(contract)}
                    consolidado={() => this.OpenReporteConsolidado(contract)}
                    showEditContract={this.showEditContract}
                    rutaseleccionadaprop={this.state.rutaseleccionada}
                    bitInsertMonitoreo={this.state.bitInsertMonitoreo}
                    bitEditMonitoreo={this.state.bitEditMonitoreo}
                  />
                )}
              />
              {/* <button
                type="button"
                onClick={this.handleMockNotifications}
                style={{
                  position: "fixed",
                  right: 120,
                  bottom: 20,
                  zIndex: 2000,
                  border: "none",
                  borderRadius: 999,
                  padding: "10px 14px",
                  background: "#111",
                  color: "#fff",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                aria-label="Disparar notificaciones mock"
                title="Disparar notificaciones mock"
              >
                Mock
              </button> */}
              <button
                type="button"
                onClick={this.toggleOffcanvas}
                className={`live-fab ${displayLiveStreams.length > 0 ? "is-live" : ""}`}
                style={{
                  position: "fixed",
                  right: 20,
                  bottom: this.getMobileLiveFabBottom(),
                  zIndex: 2000,
                  border: "none",
                  borderRadius: 999,
                  padding: "10px 14px",
                  background: displayLiveStreams.length > 0 ? "#ff2d2d" : "#006699",
                  color: "#fff",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                aria-label="Ver transmisiones en vivo"
                title="Ver transmisiones en vivo"
              >
                <span className="live-indicator" aria-hidden="true" />
                Live ({displayLiveStreams.length})
              </button>

              {this.state.bitOpen && (
                <div className="content-wrapper">
                  <div className="container-fluid flex-grow-1 container-p-y">
                    <MDBRow className="d-flex justify-content-between align-items-start">
                      <MDBCol md="auto">
                        <label
                          className="fw-bold mb-4 label_trafico"
                          style={{ fontSize: "22px", marginRight: "10px" }}
                        >
                          {" "}
                          Tráfico {this.state.critico ? 'crítico' : ''} ({this.state.countContrats})
                        </label>
                        {this.state.collapsable ? (
                          <FaEyeSlash onClick={() => this.collapsable(false)} style={{ cursor: "pointer" }} height={12} />
                        ) : (
                          <FaEye
                            onClick={() => this.collapsable(true)} style={{ cursor: "pointer" }} height={12} />
                        )}

                      </MDBCol>
                      <MDBCol md={"auto"} className='countersColorsTrafico trafico-alerts-toolbar'>
                        <div className="trafico-alerts-mobile-heading">
                          <h2>Alertas rápidas</h2>
                          <p>Estado general de la flota</p>
                        </div>
                        <button
                          type="button"
                          className="trafico-alerts-summary"
                          onClick={this.toggleResponsiveAlerts}
                          aria-expanded={this.state.responsiveAlertsExpanded}
                          aria-controls="trafico-alerts-grid"
                        >
                          <span className="trafico-alerts-summary-icon" aria-hidden="true">
                            <i className="bx bx-bar-chart-alt-2" />
                          </span>
                          <span className="trafico-alerts-summary-copy">
                            <strong>
                              {this.state.responsiveAlertsExpanded ? "Mostrar menos" : "Mostrar más"}
                            </strong>
                          </span>
                          <i
                            className={`bx ${this.state.responsiveAlertsExpanded ? "bx-chevron-up" : "bx-chevron-down"}`}
                            aria-hidden="true"
                          />
                        </button>
                        <div
                          id="trafico-alerts-grid"
                          className={`trafico-alerts-grid ${this.state.responsiveAlertsExpanded ? "is-expanded" : "is-compact"}`}
                          aria-hidden={false}
                        >
                        <div className={`counterItem ${this.state.isNoRutaActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('noTrayecto')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'noTrayecto')} role="button" tabIndex={0} aria-label={`Sin georuta: ${this.state.NoRutaCount}`}>
                          <div className='notification'>
                            <img src="/images/trayectonull.png" alt="Temporizador" width={'25px'} height={'25px'} title="Contratos sin georutas asignadas" />
                            <div className='notificationCount'>{this.state.NoRutaCount}</div>
                          </div>
                        </div>
                        <div className={`counterItem ${this.state.isRefuerzoActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('refuerzo')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'refuerzo')} role="button" tabIndex={0} aria-label={`Refuerzo: ${this.state.refuerzoCount}`}>
                          <div className='notification'>
                            <span className="badge badge-danger ml-1" title="Dispositivo con refuerzo" style={{ alignItems: 'center' }}>R</span>
                            <div className='notificationCount'>{this.state.refuerzoCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isMovingActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('moving')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'moving')} role="button" tabIndex={0} aria-label={`En ruta: ${this.state.movingCount}`}>
                          <div className='notification'>
                            <img src="/images/moving.png" alt="Moving" title="Dispositivos en movimiento" />
                            <div className='notificationCount'>{this.state.movingCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isStopActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('stop')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'stop')} role="button" tabIndex={0} aria-label={`Detenidos: ${this.state.stopCount}`}>
                          <div className='notification'>
                            <img src="/images/stop.png" alt="Stop" title="Dispositivos detenidos" />
                            <div className='notificationCount'>{this.state.stopCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isStopAlertActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('stopAlert')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'stopAlert')} role="button" tabIndex={0} aria-label={`Detención prolongada: ${this.state.stopAlertCount}`}>
                          <div className='notification'>
                            <img src="/images/stopAlert.png" alt="Stop Alerta" title="Dispositivos con detención prolongada" />
                            <div className='notificationCount'>{this.state.stopAlertCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isDesvioAlertActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('desvioalerta')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'desvioalerta')} role="button" tabIndex={0} aria-label={`Desvío: ${this.state.desvioCount}`}>
                          <div className='notification'>
                            <img src="/images/desvioalerta.png" alt="Desvio" title="Alerta desvio" />
                            <div className='notificationCount'>{this.state.desvioCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isLowBatteryActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('batt-low')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'batt-low')} role="button" tabIndex={0} aria-label={`Batería baja: ${this.state.lowBatteryCount}`}>
                          <div className='notification'>
                            <img src="/images/batt-low.png" alt="Batería baja" width={'30px'} height={'30px'} title="Dispositivos con batería baja" style={{ paddingLeft: 5, paddingRight: 5 }} />
                            <div className='notificationCount'>{this.state.lowBatteryCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isOpenActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('candado')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'candado')} role="button" tabIndex={0} aria-label={`Candado abierto: ${this.state.openCount}`}>
                          <div className='notification'>
                            <img src="/images/openedpadlockalerta.gif" alt="Candado abierto" title="Dispositivos abiertos" width={30} />
                            <div className='notificationCount'>{this.state.openCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isUnsecuredActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('unsecured')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'unsecured')} role="button" tabIndex={0} aria-label={`Seguro desactivado: ${this.state.unsecuredCount}`}>
                          <div className='notification'>
                            <img src="/images/unsecured.gif" alt="Seguro desactivado" title="Dispositivos con seguro desactivado" width={30} height={30} />
                            <div className='notificationCount'>{this.state.unsecuredCount}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isTimeExchangeActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('tiempo')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'tiempo')} role="button" tabIndex={0} aria-label={`Tiempo excedido: ${this.state.timeExchange}`}>
                          <div className='notification'>
                            <img src="/images/timer-regular-24.png" alt="Temporizador" width={'30px'} height={'30px'} title="Contratos con tiempos excedidos a 30 minutos" />
                            <div className='notificationCount'>{this.state.timeExchange}</div>
                          </div>
                        </div>

                        <div className={`counterItem ${this.state.isStreamingActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('streaming')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'streaming')} role="button" tabIndex={0} aria-label={`Streaming activo: ${this.state.streamingCount}`}>
                          <div className='notification'>
                            <span className="en-vivo-live-dot" aria-hidden="true" title="Contratos con streaming activo"></span>
                            <div className='notificationCount'>{this.state.streamingCount}</div>
                          </div>
                        </div>


                        <div className={`counterItem ${this.state.isNoGpsActive ? 'active' : 'inactive'}`} onClick={() => this.handleFilterButtons2('noGps')} onKeyDown={(event) => this.handleResponsiveAlertKeyDown(event, 'noGps')} role="button" tabIndex={0} aria-label={`GPS inválido: ${this.state.NoGpsCount}`}>
                          <div className='notification'>
                            <img src="/images/NoGPS.png" alt="NOGPS" width={'30px'} height={'30px'} title="Contratos con GPS inválido" />
                            <div className='notificationCount'>{this.state.NoGpsCount}</div>
                          </div>
                        </div>
                        </div>
                      </MDBCol>


                      <MDBCol md="auto" className="d-flex flex-wrap align-items-center justify-content-center" id="FilterIconTrafico">
                        <div className="trafico-company-filter me-2">
                          <Select
                            isMulti
                            isSearchable
                            isClearable
                            closeMenuOnSelect={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            options={this.getTrafficCompanyOptions()}
                            value={this.getTrafficCompanyOptions().filter((option) =>
                              (this.state.selectedTrafficCompanies || []).includes(option.value)
                            )}
                            onChange={this.handleTrafficCompanyChange}
                            placeholder={
                              this.state.selectedTrafficCompanies?.length
                                ? `${this.state.selectedTrafficCompanies.length} empresas seleccionadas`
                                : "Seleccione empresas..."
                            }
                            noOptionsMessage={() => "No hay empresas disponibles"}
                            classNamePrefix="trafico-company-select"
                            aria-label="Filtrar por empresas"
                          />
                        </div>
                        <div className="FilterSearchTraficc me-2">
                          <div className="input-group">
                            <span className="input-group-text" id="b1">
                              <FaSearch />
                            </span>
                            <input
                              id="search"
                              type="text"
                              className="form-control"
                              placeholder="Filtrar"
                              aria-describedby="b1"
                              value={this.state.searchValue}
                              onChange={this.handleSearchChange}
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center filterTraficCss" style={{ height: '38.94px' }}>
                          <button
                            style={{
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 0,
                              position: "relative",
                            }}
                            className={`btn btn-outline-secondary ${this.state.notificationCircle ? "active" : ""}`}
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasFilter"
                            aria-controls="offcanvasFilter"
                          >
                            <FaFilter />
                            {this.state.notificationCircle && <div className="notification-badge"></div>}
                          </button>

                          <button
                            style={{
                              marginLeft: '12px',
                              width: '40px',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0
                            }}
                            className="btn btn-outline-secondary"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasEnd"
                            aria-controls="offcanvasEnd"
                          >
                            <FaTools style={{ fontSize: '1rem' }} />
                          </button>

                          <button
                            style={{
                              marginLeft: '12px',
                              width: '40px',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0
                            }}
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={this.toggleFullscreen}
                          >
                            {this.state.isFullscreen ? <FaCompress /> : <FaExpand />}
                          </button>
                          <button
                            type="button"
                            className={`btn btn-outline-secondary trafico-open-window-toolbar ${this.state.desktopWindowLauncherVisible ? "active" : ""}`}
                            title="Mostrar u ocultar multiventana"
                            aria-label="Mostrar u ocultar multiventana"
                            onClick={this.toggleDesktopTrafficWindowLauncher}
                          >
                            <i className="bx bx-window-alt" aria-hidden="true" />
                            {this.state.desktopWindowLauncherVisible && <div className="notification-badge" aria-hidden="true" />}
                          </button>
                        </div>
                      </MDBCol>



                    </MDBRow>
                    <MDBRow>

                    </MDBRow>

                    {showLiveInline && !isMobileView ? (
                      <div
                        className="trafico-live-stack"
                        ref={(el) => {
                          this.trafficStackRef = el;
                        }}
                      >
                        <div className="card cardContainerTrafico">
                          <div
                            className="table-responsive text-nowrap trafico-contracts-grid trafico-table-freeze-wrapper"
                            style={{
                              height: trafficGridHeight || "60%",
                              overflowY: "auto",
                              overflowX: "hidden",
                            }}
                          >
                            <table className="table table-hover trafico-table-freeze-2" id="tablaTRAF">
                              <thead className="FondoHeaderTabla2">
                                <tr>
                                  {showEmpresa && (
                                    <th
                                      style={{ color: "#ffffff", width: "220px" }}
                                    // onClick={() => this.sortData("NombreEmpresa")}
                                    >
                                      EMPRESA {this.renderSortIcon("NombreEmpresa")}
                                    </th>
                                  )}
                                  {showDispositivo && (
                                    <th
                                      style={{ color: "#ffffff", width: "230px" }}
                                    // onClick={() => this.sortData("FKLokDeviceID")}
                                    >
                                      DISPOSITIVO{" "}
                                      {this.renderSortIcon("FKLokDeviceID")}
                                    </th>
                                  )}
                                  {showBateria && (
                                    <th
                                      style={{ color: "#ffffff", width: "50px" }}
                                    // onClick={() => this.sortData("bateria")}
                                    >
                                      BATT {this.renderSortIcon("bateria")}
                                    </th>
                                  )}
                                  {showPlaca && (
                                    <th
                                      style={{ color: "#ffffff", width: "78px" }}
                                    // onClick={() => this.sortData("PlacaTruck")}
                                    >
                                      PLACA {this.renderSortIcon("PlacaTruck")}
                                    </th>
                                  )}
                                  {showRef && <th style={{ color: "#ffffff", width: "115px" }}>REF</th>}
                                  {showRuta && (
                                    <th
                                      className="trafico-ruta-col"
                                      style={{ color: "#ffffff", width: "240px" }}
                                    // onClick={() => this.sortData("DescripcionRuta")}
                                    >
                                      RUTA {this.renderSortIcon("DescripcionRuta")}
                                    </th>
                                  )}
                                  {showEstado && (
                                    <th style={{ color: "#ffffff", width: '110px' }}>ESTADO</th>
                                  )}
                                  {showUbicacionGps && (
                                    <th
                                      style={{ color: "#ffffff", width: "190px" }}
                                    // onClick={() => this.sortData("Ciudad")}
                                    >
                                      UBICACIÓN {this.renderSortIcon("Ciudad")}
                                    </th>
                                  )}
                                  {showUbicacionTrafico && (
                                    <th
                                      style={{ color: "#ffffff", width: "210px" }}
                                    // onClick={() => this.sortData("LastReportUbica")}
                                    >
                                      OBSERVACIONES{" "}
                                      {this.renderSortIcon("LastReportUbica")}
                                    </th>
                                  )}
                                  {showMoving && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconMoving")}
                                    >
                                      {this.renderSortIcon("IconMoving")}
                                    </th>
                                  )}
                                  {showLocked && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconLocked")}
                                    >
                                      {this.renderSortIcon("IconLocked")}
                                    </th>
                                  )}
                                  {showNoGps && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconLocked")}
                                    >
                                      {this.renderSortIcon("bitGPS")}
                                    </th>
                                  )}
                                  {showDesvio && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconDesvio")}
                                    >
                                      {this.renderSortIcon("IconDesvio")}
                                    </th>
                                  )}
                                  {showBack && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconBack")}
                                    >
                                      {this.renderSortIcon("IconBack")}
                                    </th>
                                  )}
                                  {showSeguro && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconSeguro")}
                                    >
                                      {this.renderSortIcon("IconSeguro")}
                                    </th>
                                  )}
                                  {showValitronics && (
                                    <th
                                      style={{ color: "#ffffff", width: "42px" }}
                                    // onClick={() => this.sortData("IconValitronics")}
                                    >
                                      {this.renderSortIcon("IconValitronics")}
                                    </th>
                                  )}
                                  {showPhotos && (
                                    <th
                                      style={{ color: "#ffffff", width: "60px", textAlign: "center" }}
                                      aria-label="Fotografías"
                                    ></th>
                                  )}
                                  {showTiempo && (
                                    <th
                                      className="trafico-tiempo-col"
                                      style={{ color: "#ffffff", width: "100px" }}
                                    // onClick={() => this.sortData("tiempoUnix")}
                                    >
                                      TIEMPO {this.renderSortIcon("tiempoUnix")}
                                    </th>
                                  )}
                                  <th
                                    style={{ color: "#ffffff", width: "38px" }}
                                  ></th>
                                </tr>
                              </thead>
                              <tbody className="table-border-bottom-0" id="tabladata">
                                {this.loadFillData(this.state.filteredContratos)}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div
                          className="trafico-resize-handle"
                          onMouseDown={this.handleTrafficResizeMouseDown}
                          role="separator"
                          aria-orientation="horizontal"
                        />

                        <div className="trafico-live-section">
                          {this.renderLiveStreamSection()}
                        </div>
                      </div>
                    ) : (
                      <div className="card cardContainerTrafico">
                        <div
                          className="table-responsive text-nowrap trafico-table-freeze-wrapper"
                          style={{
                            height: `calc(100dvh - 186px)`,
                            overflowY: "auto",
                            overflowX: "hidden",
                            // display: "flex",
                            // flexDirection: "column",
                          }}
                        >

                          <table className="table table-hover trafico-table-freeze-2" id="tablaTRAF">
                            <thead className="FondoHeaderTabla2">
                              <tr>
                                {showEmpresa && (
                                  <th
                                    style={{ color: "#ffffff", width: "220px" }}
                                  // onClick={() => this.sortData("NombreEmpresa")}
                                  >
                                    EMPRESA {this.renderSortIcon("NombreEmpresa")}
                                  </th>
                                )}
                                {showDispositivo && (
                                  <th
                                    style={{ color: "#ffffff", width: "230px" }}
                                  // onClick={() => this.sortData("FKLokDeviceID")}
                                  >
                                    DISPOSITIVO{" "}
                                    {this.renderSortIcon("FKLokDeviceID")}
                                  </th>
                                )}
                                {showBateria && (
                                  <th
                                    style={{ color: "#ffffff", width: "50px" }}
                                  // onClick={() => this.sortData("bateria")}
                                  >
                                    BATT {this.renderSortIcon("bateria")}
                                  </th>
                                )}
                                {showPlaca && (
                                  <th
                                    style={{ color: "#ffffff", width: "78px" }}
                                  // onClick={() => this.sortData("PlacaTruck")}
                                  >
                                    PLACA {this.renderSortIcon("PlacaTruck")}
                                  </th>
                                )}
                                {showRef && <th style={{ color: "#ffffff", width: "115px" }}>REF</th>}
                                {showRuta && (
                                  <th
                                    className="trafico-ruta-col"
                                    style={{ color: "#ffffff", width: "240px" }}
                                  // onClick={() => this.sortData("DescripcionRuta")}
                                  >
                                    RUTA {this.renderSortIcon("DescripcionRuta")}
                                  </th>
                                )}
                                {showEstado && (
                                  <th style={{ color: "#ffffff", width: '110px' }}>ESTADO</th>
                                )}
                                {showUbicacionGps && (
                                  <th
                                    style={{ color: "#ffffff", width: "190px" }}
                                  // onClick={() => this.sortData("Ciudad")}
                                  >
                                    UBICACIÓN {this.renderSortIcon("Ciudad")}
                                  </th>
                                )}
                                {showUbicacionTrafico && (
                                  <th
                                    style={{ color: "#ffffff", width: "210px" }}
                                  // onClick={() => this.sortData("LastReportUbica")}
                                  >
                                    OBSERVACIONES{" "}
                                    {this.renderSortIcon("LastReportUbica")}
                                  </th>
                                )}
                                {showMoving && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconMoving")}
                                  >
                                    {this.renderSortIcon("IconMoving")}
                                  </th>
                                )}
                                {showLocked && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconLocked")}
                                  >
                                    {this.renderSortIcon("IconLocked")}
                                  </th>
                                )}
                                {showNoGps && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconLocked")}
                                  >
                                    {this.renderSortIcon("bitGPS")}
                                  </th>
                                )}
                                {showDesvio && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconDesvio")}
                                  >
                                    {this.renderSortIcon("IconDesvio")}
                                  </th>
                                )}
                                {showBack && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconBack")}
                                  >
                                    {this.renderSortIcon("IconBack")}
                                  </th>
                                )}
                                {showSeguro && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconSeguro")}
                                  >
                                    {this.renderSortIcon("IconSeguro")}
                                  </th>
                                )}
                                {showValitronics && (
                                  <th
                                    style={{ color: "#ffffff", width: "42px" }}
                                  // onClick={() => this.sortData("IconValitronics")}
                                  >
                                    {this.renderSortIcon("IconValitronics")}
                                  </th>
                                )}
                                {showPhotos && (
                                  <th
                                    style={{ color: "#ffffff", width: "60px", textAlign: "center" }}
                                    aria-label="Fotografías"
                                  ></th>
                                )}
                                {showTiempo && (
                                  <th
                                    className="trafico-tiempo-col"
                                    style={{ color: "#ffffff", width: "100px" }}
                                  // onClick={() => this.sortData("tiempoUnix")}
                                  >
                                    TIEMPO {this.renderSortIcon("tiempoUnix")}
                                  </th>
                                )}
                                <th
                                  style={{ color: "#ffffff", width: "38px" }}
                                ></th>
                              </tr>
                            </thead>
                            <tbody className="table-border-bottom-0" id="tabladata">
                              {this.loadFillData(this.state.filteredContratos)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {showLiveInline && isMobileView && (
                      <LiveFloatingPanel
                        isOpen
                        title={`Live activos (${displayLiveStreams.length})`}
                        onClose={this.toggleOffcanvas}
                        defaultPosition={{ left: 12, bottom: 12 }}
                        defaultSize={{ width: "calc(100% - 24px)", height: "70vh" }}
                        className="trafico-live-modal"
                        disableDragResize
                        zIndex={11000}
                      >
                        {this.renderLiveStreamSection()}
                      </LiveFloatingPanel>
                    )}
                    {this.renderResponsiveTraffic()}
                  </div>
                  <div className="content-backdrop fade"></div>
                </div>
              )}
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
        </div >

        <div
          className="offcanvas offcanvas-end trafico-control-offcanvas"
          data-bs-scroll="true"
          data-bs-backdrop="false"
          tabIndex="-1"
          id="offcanvasEnd"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasScrollingLabel">
              Control de tráfico
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="row">

              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-16"
                    data-bs-dismiss="offcanvas"
                    onChange={(e) =>
                      this.handleChangueCritico(!this.state.critico)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Tráfico {this.state.critico ? 'crítico' : 'normal'}
                  </label>
                </div>
              </div>
              <h5 className="offcanvas-title" id="offcanvasScrollingLabel" style={{ marginBottom: 12 }}>
                Columnas grilla
              </h5>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-01"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-empresa", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    EMPRESA
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-19"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-photos", e.target.checked)
                    }
                  />
                  <label className="form-check-label" htmlFor="Sw-19">
                    FOTOGRAFIAS
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-02"
                    onChange={(e) =>
                      this.handleCheckboxChange(
                        "sw-ubicaciongps",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Ubicación GPS
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-03"
                    onChange={(e) =>
                      this.handleCheckboxChange(
                        "sw-dispositivo",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    DISPOSITIVO
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-17"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-nogps", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    GPS
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-04"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-ruta", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    RUTA
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-05"
                    onChange={(e) =>
                      this.handleCheckboxChange(
                        "sw-ubicaciontrafico",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    OBSERVACIONES
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-20"
                    defaultChecked={showRef}
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-ref", e.target.checked)
                    }
                  />
                  <label className="form-check-label" htmlFor="Sw-20">
                    REF
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-06"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-tiempo", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    TIEMPO
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-07"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-placa", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    PLACA
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-08"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-bateria", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    BATT
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-09"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-estado", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    ESTADO
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-11"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-moving", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Movimiento
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-12"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-locked", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Apertura
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-13"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-back", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Back
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-14"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-desvio", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Desvio
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-15"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-seguro", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Asegurado
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-16"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-valitronics", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Icono Valitronics
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <label>Fondo </label>
                  <select
                    className="form-select"
                    defaultValue={this.state.fondoseleccionado}
                    onChange={(e) => this.ChangeFondo(e.target.value)}
                  >
                    <option value="#e6eef7">Azul</option>
                    <option value="#F5F5D1">Amarillo</option>
                  </select>
                </div>
              </div>
              <h5 className="offcanvas-title" id="offcanvasScrollingLabel" style={{ marginBottom: 12 }}>
                Otras opciones
              </h5>
              <div className="mb-3">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="Sw-18"
                    onChange={(e) =>
                      this.handleCheckboxChange("sw-colors-refuerzo", e.target.checked)
                    }
                  />
                  <label className="form-check-label" for="mySwitch">
                    Refuerzos
                  </label>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="true"
          data-bs-backdrop="false"
          tabIndex="-1"
          id="offcanvasFilter"
          aria-labelledby="offcanvasScrollingLabel"
          style={{ zIndex: 2105 }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasScrollingLabel" style={{ display: 'flex', flexDirection: "column" }}>
              Filtros avanzados
              {localStorage.getItem("nameFilters") ? (
                <span style={{ color: '#006699' }}>
                  ({localStorage.getItem("nameFilters")})&nbsp;
                  {this.state.savedFilters ? (
                    <i
                      className="bx bx-flashing bx-pencil"
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <i
                      className="bx bx-pencil"
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </span>
              ) : (
                <span style={{ color: '#006699' }}>
                  (Sin guardar)
                </span>
              )}

            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <FilterBodyOffcanvas contratos={this.state.filteredContratos} listContratos={this.state.listContratos} onFiltersChange={this.applyFilters} savedFilter={this.handleNewValueSavedFilter} statusFilter={this.state.savedFilters} newValueFilter={this.state.newValueFilterButton} deleteNewFilter={this.state.deleteValueFilterButton} />
          </div>
        </div >

        {/* LiveFloatingPanel removido: ahora se muestra la sección inline debajo de la grilla */}

        {/* Modal edicion de contrato 🎩*/}
        < BaseModalCreateSolcitud
          isOpen={this.state.isDialogOpenEditSolicitud}
          title={'Actualizar contrato'}
          onClose={this.onCloseEditContract}
          childComponent={< FormUpdateContrato contrato={this.state.contratoseleccionado} info={this.state.infoUpdateContrato} sourceContract={this.state.dataGlobal} onClose={this.onCloseEditContract} />}
        />
        {/* Modal edicion de contrato 🎩*/}

        {/* Modal ediciotn contrato proyecto */}
        <BaseModalCreateSolcitud
          isOpen={this.state.isDialogOpenEditContratoProject}
          title={'Actualizar contrato'}
          onClose={this.onCloseEditContract}
          childComponent={<FormUpdateContratoProyecto contrato={this.state.contratoseleccionado} info={this.state.infoUpdateContrato} sourceContract={this.state.dataGlobal} onClose={this.onCloseEditContract} />}
        />
        {/* Modal ediciotn contrato proyecto */}

        {/* Modal seguimiento contrato monitoreo*/}
        <RSeguimientoServicio
          isOpen={this.state.isDialogOpenRSeguimientoServicio}
          title={'Monitoreo de tráfico'}
          onClose={this.onCloseReporteServicio}
          childComponent={<FormReporteServicio
            contrato={this.state.contratoseleccionado}
            images={this.OpenImages2}
            tracking={this.OpenTracking2}
            consolidado={this.OpenReporteConsolidado}
            bitInsert={this.state.bitInsertMonitoreo}
            bitEdit={this.state.bitEditMonitoreo}
          />}
        />
        {/* Modal seguimiento contrato */}

        {/* Modal Reporte consolidado ajustado */}
        <ModalReporteConsolidadoAjustado
          isOpen={this.state.isDialogOpenRServicioAjustado}
          title={'Reporte consolidado ajustado'}
          onClose={this.onCloseReporteServicioAjustado}
          childComponent={<FormStaticsMapsRecorrido
            infoContrato={this.state.infocontrato}
            handleUltPunto={(value) => this.handleUltPunto(value)}
            handleUltRecorrido={(value) => this.handleUltRecorrido(value)}
            onSubmit={this.handleSubmitAndOpenReporteAjustado}
          />}
        />
        {/* Modal Reporte consolidado ajustado */}
        {/* Modal Reporte servicio */}
        <ModalReporteServicio
          isOpen={this.state.isDialogOpenModalReporteServicio}
          onClose={this.onCloseModalReporteServicio}
          childComponent={<ReporteServicio
            contrato={this.state.infocontratoAjustado}
            ultPunto={this.state.ultPunto}
            contractR={this.state.contractR}
          />}
        />
        {/* Modal Reporte servicio */}


        <div
          className="modal fade"
          id="ModalAsignacion"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        >
          <ModalAsignacion
            contratoseleccionado={this.state.contratoseleccionado}
            listRutas={this.state.listRutas}
            onClose={this.handleCloseModalAsignacion}
            onUpdateContract={this.handleUpdateContract}
          />
        </div>


        {/* <div
          className="modal fade"
          id="ModalFoto"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        > */}
        <BaseModalAuto
          isOpen={this.state.isDialogOpenModalFoto}
          title={'Subir fotos'}
          onClose={this.onCloseModalFoto}
          childComponent={
            <ModalFoto
              device={this.state.device}
              username={this.state.username}
              placa={this.state.placa}
              FKICEmpresa={this.state.FKICEmpresa}
              FKLokProyecto={this.state.FKLokProyecto}
              data={this.state.dataGlobal}
              selectedContrato={this.state.contratoseleccionado}
              eventoSeleccionado={this.state.eventoseleccionado}
              listEventos={this.state.listEventos}
              editarEvento={this.EditarEvento}
              uploadPhoto={this.UploadPhoto}
              onClose={this.onCloseModalFoto}
            />
          }
        />
        {/* </div> */}


        {/* <div
          className="modal fade"
          id="ModalVideo"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        > */}
        <BaseModalAuto
          isOpen={this.state.isDialogOpenModalVideo}
          title={'Subir videos'}
          onClose={this.onCloseModalVideo}
          childComponent={
            <ModalVideo
              device={this.state.device}
              username={this.state.username}
              placa={this.state.placa}
              FKICEmpresa={this.state.FKICEmpresa}
              FKLokProyecto={this.state.FKLokProyecto}
              data={this.state.dataGlobal}
              selectedContrato={this.state.contratoseleccionado}
              eventoSeleccionado={this.state.eventoseleccionado}
              listEventos={this.state.listEventos}
              onClose={this.onCloseModalVideo}
            />}
        />

        {/* </div> */}

        <div
          className="modal fade"
          id="ModalGaleria"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        >
          {/* <BaseModalAuto2
          size={'xl'}
          isOpen={this.state.isDialogOpenModalGaleria}
          title="FOTOS CONTRATO"
          onClose={this.onCloseModalGaleria}
        >
          <Gallery
            contrato={this.state.contratoseleccionado}
            infoContrato={this.state.infocontratoContainer}
            tracking={this.OpenTracking}
            monitoreo={this.OpenMonitoreo2}
          />
        </BaseModalAuto2> */}


          <ModalGaleria
            isOpen={this.state.isDialogOpenModalGaleria}
            contratoseleccionado={this.state.contratoseleccionado}
            infocontratoContainer={this.state.infocontratoContainer}
            eliminar={this.eliminar}
            onCloseModalGaleria={this.onCloseModalGaleria}
            OpenTracking={this.OpenTracking}
            OpenMonitoreo2={this.OpenMonitoreo2}
            OpenConsolidado={this.OpenReporteConsolidado2}
          />
        </div>

        <div
          className="modal fade"
          id="ModalVideoGaleria"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <form className="modal-content video-gallery-modal-content" id="ModalGaleriaW">
              <div className="modal-header">
                <h5 className="modal-title" id="backDropModalTitle">
                  VIDEOS
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => { this.handleModalClose() }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="container text-center">
                  <div className="row">
                    <VideoGallery contrato={this.state.contratoseleccionado} />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div
          className="modal fade"
          id="ModalReporteServicio"
          data-bs-backdrop="static"
          data-bs-keyboard="true"
          tabIndex="-1"
        >
          {/* <div className="modal-dialog modal-lg">
            <form className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <ReporteServicio contrato={this.state.infocontrato} ultPunto={this.state.ultPunto} contractR={this.state.contractR} />
                </div>
              </div>
            </form>
          </div> */}
          <ModalReporteServicio2
            onCloseModalReporteServicio={this.onCloseModalReporteServicio}
            mostrarReporte={this.state.mostrarReporteConsolidado}
            infocontrato={this.state.infocontrato}
            ultPunto={this.state.ultPunto}
            contractR={this.state.contractR}
          />
        </div>

        {/* Modal para lista de chequeo  🎩*/}
        {/* <div
          className="modal fade"
          id="ModalListaCheck"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        > */}
        <BaseModalAuto
          size={'xl'}
          isOpen={this.state.isDialogOpenModalListaCheck}
          title={''}
          onClose={this.onCloseModalListaCheck}
          childComponent={<PrintComponent data={this.state.infocontrato} />}
        />
        {/* <div className="modal-dialog modal-lg">
          <form className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <PrintComponent data={this.state.infocontrato} />
              </div>
            </div>
          </form>
        </div> */}
        {/* </div> */}


        {/* <div
          className="modal fade"
          id="ModalComprobanteValitronics"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        > */}
        <ModalBaseLg
          isOpen={this.state.isDialogOpenModalComprobanteValitronics}
          title={''}
          onClose={this.onCloseModalComprobanteValitronics}
          childComponent={<ModalComprobanteValitronics
            listComprobantes={this.state.listComprobantes} />}
        />
        {/* <div className="modal-dialog modal-lg">
          <form className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <table className="table table-hover">
                  <thead className="FondoHeaderTabla2">
                    <th style={{ color: "#ffffff" }}>Comprobante</th>
                    <th style={{ color: "#ffffff" }}>fecha</th>
                    <th style={{ color: "#ffffff" }}>Latitud</th>
                    <th style={{ color: "#ffffff" }}>Longitud</th>
                    <th style={{ color: "#ffffff" }}>Usuario</th>
                  </thead>
                  <tbody id="tablacomprobante">
                    {this.loadFillData2(this.state.listComprobantes)}
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </div> */}

        {/* </div> */}

        <div
          className="modal fade"
          id="ModalDocumentosDian"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content border-0 bg-transparent shadow-none">
              <div className="modal-body p-0">
                <DianDocumentsHub contrato={this.state.contratoDian} />
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="ModalReporteDian"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg">
            <form className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="backDropModalTitle">
                  Contrato Dian
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <ReporteDian
                    isOpen={this.state.modalAbierto}
                    onClose={this.cerrarModal}
                    contratoVar={this.state.contratoDian}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* {this.state.bitOpenTracking && ( */}
        {/* <div
          className="modal fade"
          id="ModalReporteSegimiento"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-hidden={!this.state.modalAbierto2}
          tabIndex="-1"
        > */}
        <BaseModalXXL
          isOpen={this.state.modalAbierto2}
          title={'Contrato Seguimiento'}
          onClose={this.cerrarModal2}
          loading={this.state.modalLoading}
        >
          <ReporteContrato
            isOpen={this.state.modalAbierto2}
            onClose={this.cerrarModal2}
            contratoVar={this.state.infocontrato2}
            aleatorio={Math.floor(Math.random() * 1000) + 1}
            images={this.OpenImages}
            videos={this.OpenVideos}
            streaming={this.OpenStreaming}
            valitronics={this.OpenValitronics}
            checkList={this.OpenListCheckModal}
            monitoreo={this.OpenMonitoreo}
            trayecto={this.showModalTrayecto}
            consolidado={this.OpenReporteConsolidado}
            showEditContract={this.showEditContract}
            rutaseleccionadaprop={this.state.rutaseleccionada}
            bitInsertMonitoreo={this.state.bitInsertMonitoreo}
            bitEditMonitoreo={this.state.bitEditMonitoreo}
          />
        </BaseModalXXL >
        <BaseModalXXL
          isOpen={this.state.modalEnVivoOpen}
          title={'En vivo'}
          onClose={this.cerrarModalEnVivo}
          loading={this.state.modalIsLoading}
        >
          <EnVivoPanel
            contrato={this.state.contratoEnVivo}
            initialStreamUrl={this.state.liveStreamUrl}
            initialStreamVersion={this.state.liveStreamVersion}
            deviceActiveStreamUrls={(this.state.activeStreams || [])
              .filter(
                (stream) =>
                  String(stream?.deviceId || "") ===
                  String(this.state.contratoEnVivo?.FKLokDeviceID || "")
              )
              .map((stream) => String(stream?.streamId || "").trim())
              .filter(Boolean)}
            liveActive={(this.state.activeStreams || []).some(
              (stream) =>
                String(stream?.deviceId || "") ===
                String(this.state.contratoEnVivo?.FKLokDeviceID || "")
            )}
          />
        </BaseModalXXL>
        <BaseModalXXL
          isOpen={this.state.isDialogOpenModalMultimedia}
          title={""}
          onClose={this.onCloseModalMultimediaHub}
          fullscreen={this.state.isMobileView}
        >
          <ModalMultimediaHub
            contratoData={this.state.dataGlobal}
            selectedContrato={this.state.contratoseleccionado}
            infoContrato={this.state.infocontratoContainer}
            initialTab={this.state.multimediaHubTab}
            onSelectTab={(tab) => this.setState({ multimediaHubTab: tab })}
            onOpenUploadPhoto={() => this.OpenUploadPhoto(this.state.dataGlobal)}
            onOpenUploadVideo={() => this.OpenUploadVideo(this.state.dataGlobal)}
            onOpenTracking={() => {
              this.OpenTracking();
            }}
            onOpenMonitoreo={() => {
              this.OpenMonitoreo2();
            }}
            onOpenConsolidado={() => {
              this.OpenReporteConsolidado2();
            }}
            initialStreamUrl={this.state.liveStreamUrl}
            initialStreamVersion={this.state.liveStreamVersion}
            deviceActiveStreamUrls={(this.state.activeStreams || [])
              .filter(
                (stream) =>
                  String(stream?.deviceId || "") ===
                  String(this.state.dataGlobal?.FKLokDeviceID || "")
              )
              .map((stream) => String(stream?.streamId || "").trim())
              .filter(Boolean)}
            liveActive={(this.state.activeStreams || []).some(
              (stream) =>
                String(stream?.deviceId || "") ===
                String(this.state.dataGlobal?.FKLokDeviceID || "")
            )}
          />
        </BaseModalXXL>
        {/* </div> */}
        {/* )} */}

        <div className="alert alert-success" id="success-alert">
          <strong>Exitoso! </strong> Los cambios han sido realizados con exito.
        </div>

        <div className="alert alert-danger" id="danger-alert">
          <strong>Error! </strong> Se ha presentado un error, valide la
          información.
        </div>

      </>
    );
  }

  toggleRow(contrato) {
    const updatedListContratos = this.state.filteredContratos?.map((item) => {
      if (item.ContractID === contrato) {
        const newExpandedState = !item.expanded;
        // Guardar el nuevo estado expandido en localStorage
        localStorage.setItem(`contrato_${item.ContractID}_expanded`, JSON.stringify(newExpandedState));
        return {
          ...item,
          expanded: newExpandedState,
        };
      }
      return item;
    });

    this.setState({ filteredContratos: updatedListContratos });
  }

  collapsable(estado) {

    // Guardar el estado global de expansión en localStorage
    localStorage.setItem('global_expansion_state', JSON.stringify(estado));
    this.setState({ collapsable: estado });

    const updatedListContratos = this.state.filteredContratos?.map((item) => {
      // Actualizar cada contrato con el estado global de expansión
      localStorage.setItem(`contrato_${item.ContractID}_expanded`, JSON.stringify(estado));
      return {
        ...item,
        expanded: estado,
      };
    });

    this.setState({ filteredContratos: updatedListContratos, collapsableResponsive: estado });
  }

  loadFillData2(array) {
    return this.state.listComprobantes?.map((data) => {
      return (
        <tr>
          <td className="prueba" style={{ color: "#000" }}>
            <strong>{data.Comprobante}</strong>
          </td>
          <td className="prueba" style={{ color: "#000" }}>
            {data.Fecha}
          </td>
          <td className="prueba" style={{ color: "#000" }}>
            {data.Latitud}
          </td>
          <td className="prueba" style={{ color: "#000" }}>
            {data.Longitud}
          </td>
          <td className="prueba" style={{ color: "#000" }}>
            {data.Usuario}
          </td>
        </tr>
      )
    });
  }

  loadFillData(array) {
    if (this.state.isTrafficLoading) {
      return (
        <tr>
          <td colSpan="16" className="text-center trafico-grid-loading-cell">
            <PreloaderHistorico />
          </td>
        </tr>
      );
    }

    if (array.length === 0) {
      return (
        <tr>
          <td colSpan="16" className="text-center">
            <i className="bx bxs-spreadsheet bx-lg bx-tada-hover"></i>
            <p>No se encontraron contratos</p>
          </td>
        </tr>
      );
    }

    const {
      isMovingActive,
      isStopActive,
      isStopAlertActive,
      isDesvioAlertActive,
      isLowBatteryActive,
      isOpenActive,
      isTimeExchangeActive,
      isRefuerzoActive,
      isNoGpsActive,
      isNoRutaActive,
      isStreamingActive,
      isUnsecuredActive,
    } = this.state;

    // Array original (para anexos, conteos, etc.)
    const originalArray = [...array];

    // Copia para aplicar filtros por botón
    let arrayFilter = [...array];

    if (isMovingActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        String(contrato.IconMoving || "").includes("moving")
      );
    } else if (isStopActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        String(contrato.IconMoving || "").includes("stop")
      );
    } else if (isStopAlertActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        String(contrato.IconMoving || "").includes("stopAlert")
      );
    } else if (isDesvioAlertActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        String(contrato.IconDesvio || "").includes("desvioalerta")
      );
    } else if (isLowBatteryActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        String(contrato.icon_bat || "").includes("batt-low")
      );
    } else if (isOpenActive) {
      arrayFilter = arrayFilter.filter(
        (contrato) =>
          String(contrato.IconLocked || "").includes("candado") ||
          String(contrato.IconLocked || "").includes("openedpadlockalerta")
      );
    } else if (isTimeExchangeActive) {
      arrayFilter = arrayFilter.filter((contrato) =>
        hasLegacyTimeExchange(contrato.LoksysServerTime)
      );
    } else if (isNoGpsActive) {
      arrayFilter = arrayFilter.filter((contrato) => contrato.bitGPS === true);
    } else if (isNoRutaActive) {
      arrayFilter = arrayFilter.filter(
        (contrato) =>
          contrato.DescripcionTrayecto === null && contrato.FKLokTipoEquipo === 9
      );
    } else if (isStreamingActive) {
      arrayFilter = arrayFilter.filter((contrato) => this.isStreamingOn(contrato));
    } else if (isUnsecuredActive) {
      arrayFilter = arrayFilter.filter((contrato) => isUnsecuredContrato(contrato));
    } else if (isRefuerzoActive) {
      // Si el filtro de refuerzos está activo, solo mostramos contratos que tengan refuerzo
      arrayFilter = arrayFilter.filter((data) => {
        const anexos = originalArray.filter(
          (contratoAnexo) =>
            contratoAnexo.PlacaTruck &&
            data.PlacaTruck &&
            contratoAnexo.PlacaTruck === data.PlacaTruck &&
            contratoAnexo.ContainerNum === data.ContainerNum &&
            contratoAnexo.ContractID !== data.ContractID
        );
        return anexos.length > 0;
      });
    }

    if (arrayFilter.length === 0) {
      return (
        <tr>
          <td colSpan="16" className="text-center">
            <i className="bx bxs-spreadsheet bx-lg bx-tada-hover"></i>
            <p>No se encontraron contratos</p>
          </td>
        </tr>
      );
    }

    // =========================================
    // COLORES PASTEL POR PLACA (SOLO FILA PRINCIPAL)
    // SOLO SI showColorsRefuerzo === true
    // =========================================
    let colorByPlate = {};

    if (showColorsRefuerzo === true) {
      // contamos cuántas veces aparece cada placa
      const plateCounts = {};
      originalArray.forEach((contrato) => {
        const placa = contrato.PlacaTruck && contrato.PlacaTruck.toString().trim();
        if (!placa) return;
        plateCounts[placa] = (plateCounts[placa] || 0) + 1;
      });

      // asignamos un color solo a placas que aparecen más de una vez (es donde hay refuerzo/múltiples contratos)
      let colorIndex = 0;
      Object.entries(plateCounts).forEach(([placa, count]) => {
        if (count > 1) {
          colorByPlate[placa] = pastelColors[colorIndex % pastelColors.length].hex;
          colorIndex++;
        }
      });
    }

    return arrayFilter.map((data) => {
      // tooltip fila principal
      let tooltipDetention = "";
      if (String(data.IconMoving || "").includes("stop")) {
        const dataMin = formatMinutesToHoursAndMinutes(data.tiempodetencion);
        tooltipDetention = `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${dataMin}`;
      } else {
        tooltipDetention = `EL DISPOSITIVO VA \n A ${data.Speed} KM/H`;
      }

      // anexos: misma placa + mismo contenedor
      const anexos = originalArray.filter(
        (contratoAnexo) =>
          contratoAnexo.PlacaTruck &&
          data.PlacaTruck &&
          contratoAnexo.PlacaTruck === data.PlacaTruck &&
          contratoAnexo.ContainerNum === data.ContainerNum &&
          contratoAnexo.ContractID !== data.ContractID
      );
      const hasAnnex = anexos.length > 0;

      // anexos2: misma placa + contenedor distinto
      const anexos2 = originalArray.filter(
        (contratoAnexo) =>
          contratoAnexo.PlacaTruck &&
          data.PlacaTruck &&
          contratoAnexo.PlacaTruck === data.PlacaTruck &&
          contratoAnexo.ContainerNum !== data.ContainerNum &&
          contratoAnexo.ContractID !== data.ContractID
      );
      const hasAnnex2 = anexos2.length > 0;
      const hasStreaming = this.isStreamingOn(data);

      // color para esta placa:
      //  - solo si showColorsRefuerzo === true
      //  - y solo si realmente tiene refuerzo (hasAnnex || hasAnnex2)
      const placaKey = data.PlacaTruck && data.PlacaTruck.toString().trim();
      const basePlateColor =
        showColorsRefuerzo === true && placaKey ? colorByPlate[placaKey] : undefined;

      const plateColor =
        basePlateColor && (hasAnnex || hasAnnex2) ? basePlateColor : undefined;

      const validation = () => {
        if (data.FKLokTipoEquipo !== 9 && data.IconDesvio) {
          return (
            <img
              src={`${data.IconDesvio}`}
              width="25"
              height="25"
              title="Desvío"
            />
          );
        } else if (
          showDesvio &&
          data.FKLokTipoEquipo === 9 &&
          data.DescripcionTrayecto === null
        ) {
          return (
            <img
              src="/images/trayectonull.png"
              width="25"
              height="25"
              title="No tiene georuta asignada"
            />
          );
        } else {
          return (
            <img
              src={`${data.IconDesvio}`}
              width="25"
              height="25"
              title="Desvío"
            />
          );
        }
      };

      const validation2 = () => {
        if (data.bitGPS && data.ContadorGps >= 3) {
          return (
            <img
              src="/images/NoGpsAlert.png"
              width="25"
              height="25"
              title={`ultimo(s) ${data.ContadorGps} reporte(s) con GPS invalido(s)`}
            />
          );
        } else if (data.bitGPS) {
          return (
            <img
              src="/images/NoGPS.png"
              width="25"
              height="25"
              title={`ultimo(s) ${data.ContadorGps} reporte(s) con GPS invalido(s)`}
            />
          );
        } else {
          return (
            <img src="/images/transparent.png" width="25" height="25" />
          );
        }
      };

      const validationAnexo = (anexo) => {
        if (anexo.FKLokTipoEquipo !== 9 && anexo.IconDesvio) {
          return (
            <img
              src={`${anexo.IconDesvio}`}
              width="25"
              height="25"
              title="Desvío"
            />
          );
        } else if (
          showDesvio &&
          anexo.FKLokTipoEquipo === 9 &&
          anexo.DescripcionTrayecto === null
        ) {
          return (
            <img
              src="/images/trayectonull.png"
              width="25"
              height="25"
              title="No tiene georuta asignada"
            />
          );
        } else {
          return (
            <img
              src={`${anexo.IconDesvio}`}
              width="25"
              height="25"
              title="Desvío"
            />
          );
        }
      };

      const validationAnexo2 = (anexo) => {
        if (anexo.bitGPS && anexo.ContadorGps >= 3) {
          return (
            <img
              src="/images/NoGpsAlert.png"
              width="25"
              height="25"
              title={`ultimo(s) ${data.ContadorGps} reporte(s) con GPS invalido(s)`}
            />
          );
        } else if (anexo.bitGPS) {
          return (
            <img
              src="/images/NoGPS.png"
              width="25"
              height="25"
              title={`ultimo(s) ${data.ContadorGps} reporte(s) con GPS invalido(s)`}
            />
          );
        } else {
          return (
            <img src="/images/transparent.png" width="25" height="25" />
          );
        }
      };

      return (
        <React.Fragment key={data.ContractID}>
          {/* Fila principal del contrato */}
          <tr
            onClick={() => this.toggleRow(data.ContractID)}
            id={`contract-${data.ContractID}`}
            className="traficoTR scroll-offset"
            style={plateColor ? { backgroundColor: plateColor } : {}}
          >
            {showEmpresa && (
              <td
                className="prueba"
                style={{ color: "#000", paddingLeft: "10px" }}
              >
                <strong>{data.NombreEmpresa}</strong>
              </td>
            )}
            {showDispositivo && (
              <td style={{ color: "#000" }}>
                <div className="device-live-wrap">
                  <Tooltip content="Clic izquierdo: abrir tracking | Clic derecho: editar contrato">
                  <button
                    type="button"
                    className="trafico-device-link"
                     disabled={this.state.deviceActionLoading}
                    onClick={(event) => {
                      event.stopPropagation();
                      this.handleDeviceTrackingClick(data);
                    }}
                    onContextMenu={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      this.showEditContract(data);
                    }}
                    aria-label={`Abrir tracking en tiempo real del dispositivo ${data.FKLokDeviceID}`}
                  >
                    {data.FKLokDeviceID}
                  </button>
                  </Tooltip>
                  {hasStreaming && (
                    <button
                      type="button"
                      className="live-pill btn-pulse"
                      onClick={(event) => {
                        event.stopPropagation();
                        this.abrirModalEnVivo(
                          data,
                          this.getLiveStreamUrlForDevice(data.FKLokDeviceID)
                        );
                      }}
                      title="Streaming activo"
                      aria-label="Streaming activo"
                    >
                      <span className="live-pill-dot" aria-hidden="true"></span>
                      Live
                    </button>
                  )}
                </div>
              </td>
            )}
            {showBateria && (
              <td style={{ textAlign: "center" }}>
                <img
                  src={`${data.icon_bat}`}
                  width="20"
                  height="25"
                  title={data.bateria}
                />
              </td>
            )}
            {showPlaca && (
              <td className="trafico-placa-cell" style={{ color: "#000" }}>
                {data.PlacaTruck}
                {hasAnnex ? (
                  <span
                    className="badge badge-danger ml-1"
                    title="Refuerzo"
                  >
                    R
                  </span>
                ) : hasAnnex2 ? (
                  <span
                    className="badge badge-success ml-1"
                    title="Múltiple"
                  >
                    M
                  </span>
                ) : null}
              </td>
            )}
            {showRef && <td style={{ color: "#000" }}>{data.Ref}</td>}
            {showRuta && (
              <td className="trafico-ruta-col" style={{ color: "#000" }}>{data.DescripcionRuta}</td>
            )}
            {showEstado && (
              <td style={{ color: "#000" }}>{data.TipoReporte}</td>
            )}
            {showUbicacionGps && (
              <td className="trafico-ubic-gps-cell" style={{ color: "#000" }}>
                <strong>GPS: </strong>{data.Ciudad}
                {showUbicacionTrafico && data.LastReportUbica && (
                  <>
                    <br />
                    <strong>Ult. Trafico: </strong>
                    {data.LastReportUbica}
                  </>
                )}
                {data.mostrargeocerca === 1 && (
                  <>
                    <br />
                    <strong>Geocerca: </strong>
                    {data.geocerca} {`(${data.LastReportgeocerca} min)`}
                  </>
                )}
              </td>
            )}
            {showUbicacionTrafico && (
              <td className="trafico-observaciones-cell" style={{ color: "#000" }}>{data.LastReportNota}</td>
            )}
            {showMoving && (
              <td className="textCenterIcon">
                <img
                  src={`${data.IconMoving}`}
                  width="25"
                  height="25"
                  title={
                    data.IconMoving.includes("stop")
                      ? `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${formatMinutesToHoursAndMinutes(
                        data.tiempodetencion
                      )}`
                      : `EL DISPOSITIVO VA \n A ${data.Speed} KM/H`
                  }
                />
              </td>
            )}
            {showLocked && (
              <td>
                <img
                  src={`${data.IconLocked}`}
                  width="25"
                  height="25"
                  title="Estado de apertura"
                />
              </td>
            )}
            {showNoGps && <td>{validation2()}</td>}
            {showDesvio && <td>{validation()}</td>}
            {showBack && (
              <td>
                <img
                  src={`${data.IconBack}`}
                  width="25"
                  height="25"
                  title="Retorno"
                />
              </td>
            )}
            {showSeguro && (
              <td>
                <img
                  src={`${data.IconSeguro}`}
                  width="25"
                  height="25"
                  title="Seguridad"
                />
              </td>
            )}
            {showValitronics && (
              <td>
                <img
                  src={`${data.IconValitronics}`}
                  width="25"
                  height="25"
                  title="Contrato valitronics"
                />
              </td>
            )}
            {showPhotos && (
              <td style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="trafico-camera-button"
                  onClick={(event) => {
                    event.stopPropagation();
                    this.OpenMultimediaHub(data, multimediaHubTabs.PHOTOS);
                  }}
                  title="Abrir fotos en Centro multimedia y streaming"
                  aria-label={`Abrir fotos del contrato ${data.ContractID} en Centro multimedia y streaming`}
                >
                  <img
                    src={Number(data.countphotos) > 0 ? "/images/camerablue.png" : "/images/camera.png"}
                    width="26"
                    height="26"
                    alt=""
                  />
                </button>
              </td>
            )}
            {showTiempo && <td className="trafico-tiempo-col">{data.Tiempo}</td>}
            <td onClick={(e) => e.stopPropagation()}>
              <MenuContratos
                contratoId={data.ContractID}
                data={data}
                handleAllStatesDropdowns={this.handleAllStatesDropdowns}
                abrirModal2={this.abrirModal2}
                abrirModalEnVivo={this.abrirModalEnVivo}
                showModalOpenResporteServicio={
                  this.showModalOpenResporteServicio
                }
                toggleDropdownReportes={this.toggleDropdownReportes}
                dropdownOpenReportes={this.state.dropdownOpenReportes}
                OpenReporteServicio={this.OpenReporteServicio}
                abrirModal={this.abrirModal}
                toggleDropdownMultimedia={this.toggleDropdownMultimedia}
                dropdownOpenMultimedia={this.state.dropdownOpenMultimedia}
                OpenGalleryPhoto={this.OpenGalleryPhoto}
                OpenGalleryVideo={this.OpenGalleryVideo}
                OpenUploadPhoto={this.OpenUploadPhoto}
                OpenUploadVideo={this.OpenUploadVideo}
                OpenMultimediaHub={this.OpenMultimediaHub}
                toggleDropdownValitronics={this.toggleDropdownValitronics}
                dropdownOpenValitronics={this.state.dropdownOpenValitronics}
                OpenComprobante={this.OpenComprobante}
                OpenListCheck={this.OpenListCheck}
                toggleDropdownOpciones={this.toggleDropdownOpciones}
                dropdownOpenOpciones={this.state.dropdownOpenOpciones}
                showEditContract={this.showEditContract}
                EditContrato={this.EditContrato}
                ActualizarContratoDevice={this.ActualizarContratoDevice}
              />
            </td>
          </tr>

          {data.expanded && (
            <>
              {/* Fila expandida con la información detallada del contrato */}
              <tr
                style={{
                  backgroundColor: this.state.fondoseleccionado,
                  borderBottom: "1px dashed #006699",
                }}
              >
                <td colSpan={columnasfijadas} >
                  <div className="trafico-expanded-details">
                    <div className="trafico-expanded-contract">
                      <b>Contrato:</b> {data.ContractID}
                      <br />
                      <b>Nivel riesgo:</b>
                    </div>
                    <div className="trafico-expanded-container">
                      <b>Container:</b> {data.ContainerNum}
                    </div>
                    <div className="trafico-expanded-route">
                      <b>Trayecto:</b> {data.DescripcionTrayecto}
                      <br />
                      <b>Ultimo Contacto:</b> {formattedGlobalDate(data.LoksysServerTime)}
                    </div>
                  </div>
                </td>
              </tr>

              {/* Renderiza solo un grupo de anexos de forma exclusiva */}
              {hasAnnex ? (
                anexos.map((anexo) => {
                  let tooltipDetentionAnexo = "";
                  if (anexo.IconMoving.includes("stop")) {
                    const dataMinAnexo = formatMinutesToHoursAndMinutes(anexo.tiempodetencion);
                    tooltipDetentionAnexo = `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${dataMinAnexo}`;
                  } else {
                    tooltipDetentionAnexo = `EL DISPOSITIVO VA \n A ${anexo.Speed} KM/H`;
                  }
                  return (
                    <tr
                      key={anexo.ContractID}
                      style={{
                        backgroundColor: "#FFF9C4", // amarillo pastel para diferenciar
                        borderBottom: "1px dashed #006699"
                      }}
                    >
                      {showEmpresa && (
                        <td className="prueba" style={{ color: "#000", paddingLeft: "5px" }}>
                          <strong>{anexo.NombreEmpresa}</strong>
                        </td>
                      )}
                      {showDispositivo && (
                        <td style={{ color: "#000", padding: "5px" }}>
                          <div className="device-live-wrap">
                            <Tooltip content="Clic izquierdo: abrir tracking | Clic derecho: editar contrato">
                            <button
                              type="button"
                              className="trafico-device-link"
                               disabled={this.state.deviceActionLoading}
                              onClick={(event) => {
                                event.stopPropagation();
                                this.handleDeviceTrackingClick(anexo);
                              }}
                              onContextMenu={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.showEditContract(anexo);
                              }}
                              aria-label={`Abrir tracking en tiempo real del dispositivo ${anexo.FKLokDeviceID}`}
                            >
                              {anexo.FKLokDeviceID}
                            </button>
                            </Tooltip>
                            {this.isStreamingOn(anexo) && (
                              <button
                                type="button"
                                className="live-pill btn-pulse"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.abrirModalEnVivo(
                                    anexo,
                                    this.getLiveStreamUrlForDevice(anexo.FKLokDeviceID)
                                  );
                                }}
                                title="Streaming activo"
                                aria-label="Streaming activo"
                              >
                                <span className="live-pill-dot" aria-hidden="true"></span>
                                Live
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                      {showBateria && (
                        <td style={{ textAlign: "center", padding: "5px" }}>
                          <img src={`${anexo.icon_bat}`} width="20" height="25" title={anexo.bateria} />
                        </td>
                      )}
                      {showPlaca && <td className="trafico-placa-cell" style={{ color: "#000", padding: "5px" }}>{anexo.PlacaTruck}</td>}
                      {showRef && <td style={{ color: "#000", padding: "5px" }}>{anexo.Ref}</td>}
                      {showRuta && <td className="trafico-ruta-col" style={{ color: "#000", padding: "5px" }}>{anexo.DescripcionRuta}</td>}
                      {showEstado && <td style={{ color: "#000", padding: "5px" }}>{anexo.TipoReporte}</td>}
                      {showUbicacionGps && (
                        <td className="trafico-ubic-gps-cell" style={{ color: "#000", padding: "5px" }}>
                          <strong>GPS: </strong>{anexo.Ciudad}
                          {showUbicacionTrafico && anexo.LastReportUbica && (
                            <>
                              <br />
                              <strong>Ult. Trafico: </strong>
                              {anexo.LastReportUbica}
                            </>
                          )}
                          {anexo.mostrargeocerca === 1 && (
                            <>
                              <br />
                              <strong>Geocerca: </strong>
                              {anexo.geocerca} {`(${anexo.LastReportgeocerca} min)`}
                            </>
                          )}
                        </td>
                      )}
                      {showUbicacionTrafico && (
                        <td className="trafico-observaciones-cell" style={{ color: "#000", padding: "5px" }}>{anexo.LastReportNota}</td>
                      )}
                      {showMoving && (
                        <td className="textCenterIcon" style={{ padding: "5px", textAlign: "center" }}>
                          <img
                            src={`${anexo.IconMoving}`}
                            width="25"
                            height="25"
                            title={tooltipDetentionAnexo}
                          />
                        </td>
                      )}
                      {showLocked && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconLocked}`} width="25" height="25" />
                        </td>
                      )}
                      {showNoGps && (
                        <td>
                          {validationAnexo2(anexo)}
                        </td>
                      )}
                      {showDesvio && (
                        <td>
                          {validationAnexo(anexo)}
                        </td>
                      )}
                      {showBack && (
                        <td>
                          <img src={`${anexo.IconBack}`} width="25" height="25" title="Retorno" />
                        </td>
                      )}
                      {showSeguro && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconSeguro}`} width="25" height="25" />
                        </td>
                      )}
                      {showValitronics && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconValitronics}`} width="25" height="25" />
                        </td>
                      )}
                      {showPhotos && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <button
                            type="button"
                            className="trafico-camera-button"
                            onClick={(event) => {
                              event.stopPropagation();
                              this.OpenMultimediaHub(anexo, multimediaHubTabs.PHOTOS);
                            }}
                            title="Abrir fotos en Centro multimedia y streaming"
                            aria-label={`Abrir fotos del contrato ${anexo.ContractID} en Centro multimedia y streaming`}
                          >
                            <img
                              src={Number(anexo.countphotos) > 0 ? "/images/camerablue.png" : "/images/camera.png"}
                              width="26"
                              height="26"
                              alt=""
                            />
                          </button>
                        </td>
                      )}
                      {showTiempo && <td className="trafico-tiempo-col" style={{ padding: "5px" }}>{anexo.Tiempo}</td>}
                      <td style={{ padding: "5px" }}>
                        <button
                          onClick={() => this.scrollToContract(anexo.ContractID)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer"
                          }}
                          title="Ir a contrato"
                        >
                          <FaInfoCircle size={20} color="#007bff" />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : hasAnnex2 ? (
                anexos2.map((anexo) => {
                  let tooltipDetentionAnexo = "";
                  if (anexo.IconMoving.includes("stop")) {
                    const dataMinAnexo = formatMinutesToHoursAndMinutes(anexo.tiempodetencion);
                    tooltipDetentionAnexo = `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${dataMinAnexo}`;
                  } else {
                    tooltipDetentionAnexo = `EL DISPOSITIVO VA \n A ${anexo.Speed} KM/H`;
                  }
                  return (
                    <tr
                      key={`anexo2-${anexo.ContractID}`}
                      style={{
                        backgroundColor: "#A8E6CF", // fondo distinto para anexos 2
                        borderBottom: "1px dashed #006699"
                      }}
                    >
                      {showEmpresa && (
                        <td className="prueba" style={{ color: "#000", paddingLeft: "5px" }}>
                          <strong>{anexo.NombreEmpresa}</strong>
                        </td>
                      )}
                      {showDispositivo && (
                        <td style={{ color: "#000", padding: "5px" }}>
                          <div className="device-live-wrap">
                            <Tooltip content="Clic izquierdo: abrir tracking | Clic derecho: editar contrato">
                            <button
                              type="button"
                              className="trafico-device-link"
                              disabled={this.state.deviceActionLoading}
                              onClick={(event) => {
                                event.stopPropagation();
                                this.handleDeviceTrackingClick(anexo);
                              }}
                              onContextMenu={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.showEditContract(anexo);
                              }}
                              aria-label={`Abrir tracking en tiempo real del dispositivo ${anexo.FKLokDeviceID}`}
                            >
                              {anexo.FKLokDeviceID}
                            </button>
                            </Tooltip>
                            {this.isStreamingOn(anexo) && (
                              <button
                                type="button"
                                className="live-pill btn-pulse"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.abrirModalEnVivo(
                                    anexo,
                                    this.getLiveStreamUrlForDevice(anexo.FKLokDeviceID)
                                  );
                                }}
                                title="Streaming activo"
                                aria-label="Streaming activo"
                              >
                                <span className="live-pill-dot" aria-hidden="true"></span>
                                Live
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                      {showBateria && (
                        <td style={{ textAlign: "center", padding: "5px" }}>
                          <img src={`${anexo.icon_bat}`} width="20" height="25" title={anexo.bateria} />
                        </td>
                      )}
                      {showPlaca && <td className="trafico-placa-cell" style={{ color: "#000", padding: "5px" }}>{anexo.PlacaTruck}</td>}
                      {showRef && <td style={{ color: "#000", padding: "5px" }}>{anexo.Ref}</td>}
                      {showRuta && <td className="trafico-ruta-col" style={{ color: "#000", padding: "5px" }}>{anexo.DescripcionRuta}</td>}
                      {showEstado && <td style={{ color: "#000", padding: "5px" }}>{anexo.TipoReporte}</td>}
                      {showUbicacionGps && (
                        <td className="trafico-ubic-gps-cell" style={{ color: "#000", padding: "5px" }}>
                          <strong>GPS: </strong>{anexo.Ciudad}
                          {showUbicacionTrafico && anexo.LastReportUbica && (
                            <>
                              <br />
                              <strong>Ult. Trafico: </strong>
                              {anexo.LastReportUbica}
                            </>
                          )}
                          {anexo.mostrargeocerca === 1 && (
                            <>
                              <br />
                              <strong>Geocerca: </strong>
                              {anexo.geocerca} {`(${anexo.LastReportgeocerca} min)`}
                            </>
                          )}
                        </td>
                      )}
                      {showUbicacionTrafico && (
                        <td className="trafico-observaciones-cell" style={{ color: "#000", padding: "5px" }}>{anexo.LastReportNota}</td>
                      )}
                      {showMoving && (
                        <td className="textCenterIcon" style={{ padding: "5px", textAlign: "center" }}>
                          <img
                            src={`${anexo.IconMoving}`}
                            width="25"
                            height="25"
                            title={tooltipDetentionAnexo}
                          />
                        </td>
                      )}
                      {showLocked && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconLocked}`} width="25" height="25" />
                        </td>
                      )}
                      {showNoGps && (
                        <td>
                          {validationAnexo2(anexo)}
                        </td>
                      )}
                      {showDesvio && (
                        <td>
                          {validationAnexo(anexo)}
                        </td>
                      )}
                      {showBack && (
                        <td>
                          <img src={`${anexo.IconBack}`} width="25" height="25" title="Retorno" />
                        </td>
                      )}
                      {showSeguro && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconSeguro}`} width="25" height="25" />
                        </td>
                      )}
                      {showValitronics && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <img src={`${anexo.IconValitronics}`} width="25" height="25" />
                        </td>
                      )}
                      {showPhotos && (
                        <td style={{ padding: "5px", textAlign: "center" }}>
                          <button
                            type="button"
                            className="trafico-camera-button"
                            onClick={(event) => {
                              event.stopPropagation();
                              this.OpenMultimediaHub(anexo, multimediaHubTabs.PHOTOS);
                            }}
                            title="Abrir fotos en Centro multimedia y streaming"
                            aria-label={`Abrir fotos del contrato ${anexo.ContractID} en Centro multimedia y streaming`}
                          >
                            <img
                              src={Number(anexo.countphotos) > 0 ? "/images/camerablue.png" : "/images/camera.png"}
                              width="26"
                              height="26"
                              alt=""
                            />
                          </button>
                        </td>
                      )}
                      {showTiempo && <td className="trafico-tiempo-col" style={{ padding: "5px" }}>{anexo.Tiempo}</td>}
                      <td style={{ padding: "5px" }}>
                        <button
                          onClick={() => this.scrollToContract(anexo.ContractID)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer"
                          }}
                          title="Ir a contrato"
                        >
                          <FaInfoCircle size={20} color="#007bff" />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : null}
            </>
          )}

        </React.Fragment>
      );
    });

    $(".dropdown-toggle").dropdown();
  }






}

export default Trafico;



